/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

/*
* arrive.js
* v2.4.1
* https://github.com/uzairfarooq/arrive
* MIT licensed
*
* Copyright (c) 2014-2017 Uzair Farooq
*/
var Arrive=function(e,t,n){"use strict";function r(e,t,n){l.addMethod(t,n,e.unbindEvent),l.addMethod(t,n,e.unbindEventWithSelectorOrCallback),l.addMethod(t,n,e.unbindEventWithSelectorAndCallback)}function i(e){e.arrive=f.bindEvent,r(f,e,"unbindArrive"),e.leave=d.bindEvent,r(d,e,"unbindLeave")}if(e.MutationObserver&&"undefined"!=typeof HTMLElement){var o=0,l=function(){var t=HTMLElement.prototype.matches||HTMLElement.prototype.webkitMatchesSelector||HTMLElement.prototype.mozMatchesSelector||HTMLElement.prototype.msMatchesSelector;return{matchesSelector:function(e,n){return e instanceof HTMLElement&&t.call(e,n)},addMethod:function(e,t,r){var i=e[t];e[t]=function(){return r.length==arguments.length?r.apply(this,arguments):"function"==typeof i?i.apply(this,arguments):n}},callCallbacks:function(e,t){t&&t.options.onceOnly&&1==t.firedElems.length&&(e=[e[0]]);for(var n,r=0;n=e[r];r++)n&&n.callback&&n.callback.call(n.elem,n.elem);t&&t.options.onceOnly&&1==t.firedElems.length&&t.me.unbindEventWithSelectorAndCallback.call(t.target,t.selector,t.callback)},checkChildNodesRecursively:function(e,t,n,r){for(var i,o=0;i=e[o];o++)n(i,t,r)&&r.push({callback:t.callback,elem:i}),i.childNodes.length>0&&l.checkChildNodesRecursively(i.childNodes,t,n,r)},mergeArrays:function(e,t){var n,r={};for(n in e)e.hasOwnProperty(n)&&(r[n]=e[n]);for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);return r},toElementsArray:function(t){return n===t||"number"==typeof t.length&&t!==e||(t=[t]),t}}}(),c=function(){var e=function(){this._eventsBucket=[],this._beforeAdding=null,this._beforeRemoving=null};return e.prototype.addEvent=function(e,t,n,r){var i={target:e,selector:t,options:n,callback:r,firedElems:[]};return this._beforeAdding&&this._beforeAdding(i),this._eventsBucket.push(i),i},e.prototype.removeEvent=function(e){for(var t,n=this._eventsBucket.length-1;t=this._eventsBucket[n];n--)if(e(t)){this._beforeRemoving&&this._beforeRemoving(t);var r=this._eventsBucket.splice(n,1);r&&r.length&&(r[0].callback=null)}},e.prototype.beforeAdding=function(e){this._beforeAdding=e},e.prototype.beforeRemoving=function(e){this._beforeRemoving=e},e}(),a=function(t,r){var i=new c,o=this,a={fireOnAttributesModification:!1};return i.beforeAdding(function(n){var i,l=n.target;(l===e.document||l===e)&&(l=document.getElementsByTagName("html")[0]),i=new MutationObserver(function(e){r.call(this,e,n)});var c=t(n.options);i.observe(l,c),n.observer=i,n.me=o}),i.beforeRemoving(function(e){e.observer.disconnect()}),this.bindEvent=function(e,t,n){t=l.mergeArrays(a,t);for(var r=l.toElementsArray(this),o=0;o<r.length;o++)i.addEvent(r[o],e,t,n)},this.unbindEvent=function(){var e=l.toElementsArray(this);i.removeEvent(function(t){for(var r=0;r<e.length;r++)if(this===n||t.target===e[r])return!0;return!1})},this.unbindEventWithSelectorOrCallback=function(e){var t,r=l.toElementsArray(this),o=e;t="function"==typeof e?function(e){for(var t=0;t<r.length;t++)if((this===n||e.target===r[t])&&e.callback===o)return!0;return!1}:function(t){for(var i=0;i<r.length;i++)if((this===n||t.target===r[i])&&t.selector===e)return!0;return!1},i.removeEvent(t)},this.unbindEventWithSelectorAndCallback=function(e,t){var r=l.toElementsArray(this);i.removeEvent(function(i){for(var o=0;o<r.length;o++)if((this===n||i.target===r[o])&&i.selector===e&&i.callback===t)return!0;return!1})},this},s=function(){function e(e){var t={attributes:!1,childList:!0,subtree:!0};return e.fireOnAttributesModification&&(t.attributes=!0),t}function t(e,t){e.forEach(function(e){var n=e.addedNodes,i=e.target,o=[];null!==n&&n.length>0?l.checkChildNodesRecursively(n,t,r,o):"attributes"===e.type&&r(i,t,o)&&o.push({callback:t.callback,elem:i}),l.callCallbacks(o,t)})}function r(e,t){return l.matchesSelector(e,t.selector)&&(e._id===n&&(e._id=o++),-1==t.firedElems.indexOf(e._id))?(t.firedElems.push(e._id),!0):!1}var i={fireOnAttributesModification:!1,onceOnly:!1,existing:!1};f=new a(e,t);var c=f.bindEvent;return f.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t);var o=l.toElementsArray(this);if(t.existing){for(var a=[],s=0;s<o.length;s++)for(var u=o[s].querySelectorAll(e),f=0;f<u.length;f++)a.push({callback:r,elem:u[f]});if(t.onceOnly&&a.length)return r.call(a[0].elem,a[0].elem);setTimeout(l.callCallbacks,1,a)}c.call(this,e,t,r)},f},u=function(){function e(){var e={childList:!0,subtree:!0};return e}function t(e,t){e.forEach(function(e){var n=e.removedNodes,i=[];null!==n&&n.length>0&&l.checkChildNodesRecursively(n,t,r,i),l.callCallbacks(i,t)})}function r(e,t){return l.matchesSelector(e,t.selector)}var i={};d=new a(e,t);var o=d.bindEvent;return d.bindEvent=function(e,t,r){n===r?(r=t,t=i):t=l.mergeArrays(i,t),o.call(this,e,t,r)},d},f=new s,d=new u;t&&i(t.fn),i(HTMLElement.prototype),i(NodeList.prototype),i(HTMLCollection.prototype),i(HTMLDocument.prototype),i(Window.prototype);var h={};return r(f,h,"unbindAllArrive"),r(d,h,"unbindAllLeave"),h}}(window,"undefined"==typeof jQuery?null:jQuery,void 0);


/*
 currency.js - v1.2.2
 http://scurker.github.io/currency.js

 Copyright (c) 2019 Jason Wilson
 Released under MIT license
*/
(function(d,c){"object"===typeof exports&&"undefined"!==typeof module?module.exports=c():"function"===typeof define&&define.amd?define(c):(d=d||self,d.currency=c())})(this,function(){function d(b,a){if(!(this instanceof d))return new d(b,a);a=Object.assign({},m,a);var f=Math.pow(10,a.precision);this.intValue=b=c(b,a);this.value=b/f;a.increment=a.increment||1/f;a.groups=a.useVedic?n:p;this.s=a;this.p=f}function c(b,a){var f=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0,c=a.decimal,g=a.errorOnInvalid;
var e=Math.pow(10,a.precision);var h="number"===typeof b;if(h||b instanceof d)e*=h?b:b.value;else if("string"===typeof b)g=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),e=(e*=b.replace(/\((.*)\)/,"-$1").replace(g,"").replace(c,"."))||0;else{if(g)throw Error("Invalid Input");e=0}e=e.toFixed(4);return f?Math.round(e):e}var m={symbol:"$",separator:",",decimal:".",formatWithSymbol:!1,errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#"},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;
d.prototype={add:function(b){var a=this.s,f=this.p;return d((this.intValue+c(b,a))/f,a)},subtract:function(b){var a=this.s,f=this.p;return d((this.intValue-c(b,a))/f,a)},multiply:function(b){var a=this.s;return d(this.intValue*b/Math.pow(10,a.precision),a)},divide:function(b){var a=this.s;return d(this.intValue/c(b,a,!1),a)},distribute:function(b){for(var a=this.intValue,f=this.p,c=this.s,g=[],e=Math[0<=a?"floor":"ceil"](a/b),h=Math.abs(a-e*b);0!==b;b--){var k=d(e/f,c);0<h--&&(k=0<=a?k.add(1/f):k.subtract(1/
f));g.push(k)}return g},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s,c=a.pattern,d=a.negativePattern,g=a.formatWithSymbol,e=a.symbol,h=a.separator,k=a.decimal;a=a.groups;var l=(this+"").replace(/^-/,"").split("."),m=l[0];l=l[1];"undefined"===typeof b&&(b=g);return(0<=this.value?c:d).replace("!",b?e:"").replace("#","".concat(m.replace(a,"$1"+h)).concat(l?k+l:""))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/
this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return d});


window.lazySizesConfig = window.lazySizesConfig || {};
//page is optimized for fast onload event
//lazySizesConfig.loadMode = 1;
lazySizesConfig.init = true;
/*! lazysizes - v5.3.2 */
!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});

/*! lazysizes - v5.3.2 */

!function(e,t){var a=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",a,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],t):e.lazySizes?a():e.addEventListener("lazyunveilread",a,!0)}(window,function(e,i,o){"use strict";var l,d,u={};function s(e,t,a){var n,r;u[e]||(n=i.createElement(t?"link":"script"),r=i.getElementsByTagName("script")[0],t?(n.rel="stylesheet",n.href=e):(n.onload=function(){n.onerror=null,n.onload=null,a()},n.onerror=n.onload,n.src=e),u[e]=!0,u[n.src||n.href]=!0,r.parentNode.insertBefore(n,r))}i.addEventListener&&(l=function(e,t){var a=i.createElement("img");a.onload=function(){a.onload=null,a.onerror=null,a=null,t()},a.onerror=a.onload,a.src=e,a&&a.complete&&a.onload&&a.onload()},addEventListener("lazybeforeunveil",function(e){var t,a,n;if(e.detail.instance==o&&!e.defaultPrevented){var r=e.target;if("none"==r.preload&&(r.preload=r.getAttribute("data-preload")||"auto"),null!=r.getAttribute("data-autoplay"))if(r.getAttribute("data-expand")&&!r.autoplay)try{r.play()}catch(e){}else requestAnimationFrame(function(){r.setAttribute("data-expand","-10"),o.aC(r,o.cfg.lazyClass)});(t=r.getAttribute("data-link"))&&s(t,!0),(t=r.getAttribute("data-script"))&&(e.detail.firesLoad=!0,s(t,null,function(){e.detail.firesLoad=!1,o.fire(r,"_lazyloaded",{},!0,!0)})),(t=r.getAttribute("data-require"))&&(o.cfg.requireJs?o.cfg.requireJs([t]):s(t)),(a=r.getAttribute("data-bg"))&&(e.detail.firesLoad=!0,l(a,function(){r.style.backgroundImage="url("+(d.test(a)?JSON.stringify(a):a)+")",e.detail.firesLoad=!1,o.fire(r,"_lazyloaded",{},!0,!0)})),(n=r.getAttribute("data-poster"))&&(e.detail.firesLoad=!0,l(n,function(){r.poster=n,e.detail.firesLoad=!1,o.fire(r,"_lazyloaded",{},!0,!0)}))}},!(d=/\(|\)|\s|'/)))});

const $addToCart = $('#AddToCart');
const $AddToCartText = $('.AddToCart-text');
const normalOptionSelectors = $('.normal-option-selectors');
const addToBagSubtitle = $('.product-shop-inventory-notice');
let headerOverlay = $('#header_overlay');
let overlay = $('#productInfo_overlay');
let carousel = document.querySelector('#mediaGallery .product__media-list');

// Custom workaround to check if product has the product.tag 'custom pdp'
// This helps determine how the size variant selector will behave
const $isCustomPdp = $addToCart.attr('data-custom-pdp-tag') === 'true' ? true : false;
function smoothScrollToTop(element, time) {
    let start = element.scrollTop;
    let change = -start;
    let currentTime = 0;
    let increment = 20;
    let animateScroll = function () {
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, time);
        element.scrollTop = val;
        if (currentTime < time) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}
var openedAccordions = [];
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};
function hideAllOptions() {
    $('.has-options-opened').removeClass('has-options-opened');
    $('.show-variants').removeClass('show-variants');
    if (!$('body').hasClass('final-sale-item')) {
        $('body').removeClass('pdp-variants-opened');
    }
}
function activateReadersTabIndex() {
    $('.frame-available-options .readers--variant').each(function () {
        $(this).attr('tabindex', '0');
    });
}
function deactivateReadersTabIndex() {
    $('.frame-available-options .readers--variant').each(function () {
        $(this).attr('tabindex', '-1');
    });
}

function nudgeKeyFeatures() {
    // Check if .overflow-scroll-x.model-carousel is found
    var carouselElement = $('.overflow-scroll-x[data-carousel-id="key-features-carousel"]');
    if (carouselElement.length > 0 && carouselElement.find('.overflow-scroll-item').length > 1) {
        // Define a variable to track if the user scrolls within the next 5 seconds
        var scrolledWithin5Seconds = false;

        // Listen for the scroll event on the .overflow-scroll-x.model-carousel element
        var scrollListener = function () {
            scrolledWithin5Seconds = true;
        };
        carouselElement.on('scroll', scrollListener);

        // Wait for 5 seconds to check if the user has scrolled
        setTimeout(function () {
            // Remove the scroll listener
            carouselElement.off('scroll', scrollListener);

            // If the user hasn't scrolled within 5 seconds, add the class
            if (!scrolledWithin5Seconds) {
                carouselElement.addClass('nudge-key-features');

                // Remove the class after 1 second of adding it
                setTimeout(function () {
                    carouselElement.removeClass('nudge-key-features');
                }, 800);
            }
        }, 3000);
    }
}


var nudgeInterval;
var isFirstNudge;
// Function to check and nudge the #productInfo section
function nudgeProductInfo() {
    // Check if the body doesn't have the class "already-opened-tab"
  if (!$('body').hasClass('already-opened-tab')) {
    // Add the class "nudge-bottom-sheet" to #productInfo
    if ($('body').hasClass('pdp-nudge-image-carousel')) {
        $('.pdp-main-carousel').addClass('nudge-images');
        setTimeout(function(){
            $('.pdp-main-carousel').removeClass('nudge-images');
        },800);
    } else {
        $('#productInfo').addClass('nudge-bottom-sheet');
        setTimeout(function(){
        $('#productInfo').removeClass('nudge-bottom-sheet');
        },800);
    }

    // If this is the first nudge, clear the initial interval and set a new one with a 10-second delay
    if (isFirstNudge) {
      isFirstNudge = false;
      clearInterval(nudgeInterval);
      if ($('body').hasClass('pdp-nudge-image-carousel')) {
        nudgeInterval = setInterval(nudgeProductInfo, 6000);
      } else {
        nudgeInterval = setInterval(nudgeProductInfo, 8000);
      }
    }
  } else {
    clearInterval(nudgeInterval);
  }
}

if (deviceIsMobile.matches) {
    // Define a variable to track whether this is the first nudge
    isFirstNudge = true;

    

    // Call the function every 5 seconds and store the interval ID
    if ($('body').hasClass('pdp-nudge-image-carousel')) {
        var nudgeInterval = setInterval(nudgeProductInfo, 2500);
    } else {
        var nudgeInterval = setInterval(nudgeProductInfo, 4000);
    }
}
let isScrollingOnImages;

carousel.addEventListener('scroll', function () {
    window.clearTimeout(isScrollingOnImages);
    clearInterval(nudgeInterval);
    isFirstNudge = true;
    nudgeInterval = setInterval(nudgeProductInfo, 2500);
    document.body.classList.add('scrolling-on-images');
    if (!document.body.classList.contains('scrolled-images')) {
        document.body.classList.add('scrolled-images');
    }
    if (carousel.scrollTop < 100) {
        document.body.classList.remove('hide-announcement-bar');
    } else {
        document.body.classList.add('hide-announcement-bar');
    }
    // Check if the user has scrolled to the bottom of the carousel
    if (carousel.scrollHeight - carousel.scrollTop === carousel.clientHeight) {
        // Add the class 'ready-to-open' when the user has scrolled to the end
        if (!$('body').hasClass('just-clicked-swatch')) {
            carousel.classList.add('nudge-carousel');
            setTimeout(function () {
                carousel.classList.add('ready-to-open');
                carousel.classList.remove('nudge-carousel');
            }, 700);

            setTimeout(function () {
                carousel.classList.add('ready-to-open');
            }, 700);
        }
    } else {
        // Remove the class 'ready-to-open' when the user is no longer at the end
        carousel.classList.remove('ready-to-open');
    }

    // Set a timeout to run after scrolling ends
    isScrollingOnImages = setTimeout(function () {
        // Remove class from body
        document.body.classList.remove('scrolling-on-images');
    }, 100); // 100 milliseconds delay, adjust if needed
});
function checkSoldOutAndAdditionalColorways(showSecondProductRow, showThirdProductRow) {
    let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
    let plusMinusSwatchSymbol = plusMinusSwatch.find('em');
    let imageScrollbar = $('.active-product-card .pdp-main-carousel .carousel-track-wrapper');
    if ($('.large-product-swatch-bar').hasClass('carousel-product-swatch-bar')) {
        plusMinusSwatch.css('opacity', 1);
        //console.log("Second row: " + showSecondProductRow);
        //console.log("Third row: " + showThirdProductRow);
        //$(".has-options-opened").removeClass("has-options-opened");
        //$(".show-variants").removeClass("show-variants");
        //$("body").removeClass("pdp-variants-opened");
        if (showSecondProductRow || showThirdProductRow) {
            $('body').addClass('pdp-showing-additional-colorways');
            $('.pdp-family-products-swatch-bar').addClass('show-additional-colorways');
            if (plusMinusSwatchSymbol.text() === '+') {
                plusMinusSwatchSymbol.text('-');
            }
        } else {
            if (!$('body').hasClass('manually-opened-swatch-bar')) {
                plusMinusSwatchSymbol.text('+');
                $('body').removeClass('pdp-showing-additional-colorways');
                $('.pdp-family-products-swatch-bar').removeClass('show-additional-colorways');
            }
        }
    } else if ($('.large-product-swatch-bar').hasClass('show-additional-colorways')) {
        plusMinusSwatch.css('opacity', 1);
        if (showSecondProductRow) {
            //productInfo.css('transform', 'translateY(calc(100% - 230px))');
            plusMinusSwatchSymbol.text('-');
            //console.log("show second row");
        } else {
            //console.log("not second row");
            if (!$('body').hasClass('manually-opened-swatch-bar')) {
                plusMinusSwatchSymbol.text('+');
                $('body').removeClass('pdp-showing-additional-colorways');
                $('.pdp-family-products-swatch-bar').removeClass('show-additional-colorways');
            }
            if ($('body').hasClass('pdp-tab-opened')) {
                if (!$('body').hasClass('manually-opened-swatch-bar')) {
                    $('body').removeClass('pdp-showing-additional-colorways');
                    $('.pdp-family-products-swatch-bar').removeClass(
                        'show-additional-colorways',
                    );
                }
                //productInfo.css('transform', 'translateY(calc(100% - 230px))');
                //plusMinusSwatchSymbol.text("-");
                ////console.log("remove opened swatch bar state 2");
            } else {
                if (!$('body').hasClass('pdp-tab-opened')) {
                    //$('body').removeClass('pdp-showing-additional-colorways');
                    //$('.pdp-family-products-swatch-bar').removeClass('show-additional-colorways');
                    ////console.log("show first row 3");
                    //$(".large-product-swatch-bar").removeClass(
                    // "show-additional-colorways"
                    //);
                    //imageScrollbar.css("transform", "translateY(0px)");
                    //productInfo.css('transform', 'translateY(calc(100% - 185px))');
                    //plusMinusSwatchSymbol.text("+");
                    //$("body").removeClass("pdp-showing-additional-colorways");
                }
            }
        }
    } else {
        $('body').removeClass('pdp-showing-additional-colorways');
        $('.pdp-family-products-swatch-bar').removeClass('show-additional-colorways');
        if ($addToCart.hasClass('power-not-selected')) {
            $('.sticky-option-selectors ul[data-option-name="lens"]').addClass('show-variants');
            //productInfo.css('transform', 'translateY(calc((100% - 185px) - 48px))');
            $('body').addClass('pdp-variants-opened');
            $('.sticky-option-selectors button[data-option-name="lens"]').addClass(
                'has-options-opened',
            );
            setTimeout(function () {
                $('.sticky-option-selectors .lens--readers--options')
                    .addClass('readers--show')
                    .attr('aria-hidden', false);
            }, 500);
        } else {
            imageScrollbar.css('transform', 'translateY(0px)');
            //productInfo.css('transform', 'translateY(calc(100% - 185px))');
            //plusMinusSwatchSymbol.text("+");
            //$(".has-options-opened").removeClass("has-options-opened");
            //$(".show-variants").removeClass("show-variants");
            //$("body").removeClass("pdp-variants-opened");
            $('.sticky-option-selectors .lens--readers--options')
                .removeClass('readers--show')
                .attr('aria-hidden', true);
        }
    }
}
$(document).on('click', '.plus-minus-swatch', function () {
    let familyProductsCount = $('.large-product-swatch-bar').attr('data-family-products-count');
    let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
    let plusMinusSwatchSymbol = plusMinusSwatch.find('em');
    $('body').addClass('already-opened-tab');
    $('.large-product-swatch-bar').toggleClass('show-additional-colorways');
    $('body').toggleClass('pdp-showing-additional-colorways');
    if ($('body').hasClass('pdp-showing-additional-colorways')) {
        plusMinusSwatchSymbol.text('-');
        $('body').addClass('manually-opened-swatch-bar');
    } else {
        plusMinusSwatchSymbol.text('+');
        $('body').removeClass('manually-opened-swatch-bar');
    }
    //console.log("Clicked plus swatch");
});
let isGesture = false;
function registerEvents() {
    if (deviceIsMobile.matches) {
        var hasNudgedKeyFeatures = false;
        $(document).off('.myTouchNamespace1');
        $(document).off('.myTouchNamespace2');
        $(document).off('.myTouchNamespace3');
        $(document).off('.myTouchNamespace4');
        $(document).off('.myTouchNamespace5');
        $(document).off('.myTouchNamespace6');
        $(document).off('.myTouchNamespace7');
        $(document).off('.myTouchNamespace8');

        // Listen for the gesturestart event
        window.addEventListener('gesturestart', function (e) {
            isGesture = true;
        });

        // Listen for the gestureend event
        window.addEventListener('gestureend', function (e) {
            isGesture = false;
        });

        var startY;
        $(document).on(
            'touchstart.myTouchNamespace1',
            '.active-product-card .product__media-list',
            function (e) {
                startY = e.originalEvent.touches[0].clientY;
            },
        );
        // Open bottom sheet on swipe up of last image
        $(document).on(
            'touchmove.myTouchNamespace2',
            '.active-product-card .product__media-list',
            function (e) {
                if (isGesture) return; //
                var touch = e.originalEvent.touches[0];
                var moveY = startY - touch.clientY;
                let productInfo = $('.active-product-card .product__info-wrapper');
                let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
    
                if (
                    $(this).scrollTop() + $(this).innerHeight() >=
                    $(this)[0].scrollHeight - 100
                ) {
                    if (
                        moveY > 100 &&
                        !$('.active-product-card .product__media-list').hasClass(
                            'nudge-carousel',
                        ) &&
                        !$('body').hasClass('just-clicked-swatch')
                    ) {
                        productInfo.data('opening', '');
                        productInfo.css('transform', 'translateY(55px)');
                        overlay.css('opacity', 0.9);
                        $('body').addClass('already-opened-tab');

                        if (!hasNudgedKeyFeatures) {
                            nudgeKeyFeatures();
                            hasNudgedKeyFeatures = true; // Set the flag to true
                        }

                        $(
                            '.frame-available-options .product-variants-wrapper.normal-option-selectors, .pdp-message-carousel-wrapper',
                        ).css('opacity', 1);
                        if (
                            $('.pdp-family-products-swatch-bar').hasClass(
                                'large-product-swatch-bar',
                            )
                        ) {
                            $('.pdp-family-products-swatch-bar').addClass(
                                'show-additional-colorways',
                            );
                            $('body').addClass('pdp-showing-additional-colorways');
                            plusMinusSwatch.css('opacity', 0);
                        }
                        hideAllOptions();
                        setTimeout(() => {
                            productInfo.css('transform', '');
                            productInfo.attr('data-open', '');
                            productInfo.removeAttr('data-opening');
                            productInfo.removeClass('closed-state');
                        }, 300);
                        $('body').addClass('pdp-tab-opened');
                        $('body').removeClass('pdp-variants-opened');
                        if (
                            $('.selected-readers').length > 0 &&
                            $(
                                '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                            ).hasClass('active-variant') &&
                            $(
                                '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                            ).hasClass('has-readers-selected')
                        ) {
                            let powerValue = $('.selected-readers').data('power-value');
                            if (!$('body').hasClass('extra20-pdp')) {
                                $AddToCartText.html(
                                    'Add with Readers <em>' + powerValue + '</em>',
                                );
                            } else {
                                if (window.theme.currencyISO === 'USD') {
                                    $AddToCartText.text('Add to Bag for +20% Off');
                                } else {
                                    $AddToCartText.text('Add to Bag');
                                }
                            }
                        } else if (
                            $(
                                '.all-available-blue-light button[data-variant-name="Blue Light"]',
                            ).hasClass('active-variant')
                        ) {
                            if (!$('body').hasClass('extra20-pdp')) {
                                $AddToCartText.text('Add with Blue Light');
                            } else {
                                if (window.theme.currencyISO === 'USD') {
                                    $AddToCartText.text('Add to Bag for +20% Off');
                                } else {
                                    $AddToCartText.text('Add to Bag');
                                
                                }
                            }
                        }

                        autoplayPLPVideos();
                    }
                }
            },
        );
        var startY2;
        $(document).on(
            'touchstart.myTouchNamespace3',
            '.active-product-card .product__info-wrapper',
            function (e) {
                if (e.originalEvent.touches.length > 1) {
                    isGesture = true;
                    return;
                }
                isGesture = false;
                startY2 = e.originalEvent.touches[0].clientY;
            },
        );
        // Close bottom sheet on swipe down
        $(document).on(
            'touchmove.myTouchNamespace4',
            '.active-product-card .product__info-wrapper',
            function (e) {
                if (isGesture || e.originalEvent.touches.length > 1) {
                    return;
                }
                var touch = e.originalEvent.touches[0];
                var moveY2 = startY2 - touch.clientY;
                let productInfo = $('.active-product-card .product__info-wrapper');
                let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
                let plusMinusSwatchSymbol = plusMinusSwatch.find('em');
                let imageScrollbar = $(
                    '.active-product-card .pdp-main-carousel .carousel-track-wrapper',
                );
                if ($(this).scrollTop() === 0 && productInfo.attr('data-open') !== undefined) {
                    if (moveY2 < -60) {
                        setTimeout(function () {
                            productInfo.removeAttr('data-closing', '');
                        }, 600);
                        productInfo.attr('data-closing', '');
                        overlay.css('opacity', 0);
                        smoothScrollToTop(productInfo, 100);
                        $(
                            '.frame-available-options .product-variants-wrapper.normal-option-selectors, .pdp-message-carousel-wrapper',
                        ).css('opacity', 0);
                        productInfo.removeAttr('data-open');
                        if (
                            $('.pdp-family-products-swatch-bar').hasClass(
                                'large-product-swatch-bar',
                            )
                        ) {
                            let $activeSwatch = $('.pdp-family-swatch-product.frame-active');
                            let swatchIndex = $activeSwatch.index('.pdp-family-swatch-product');
                            let showSecondProductRow = swatchIndex >= 8 && swatchIndex <= 15;
                            let showThirdProductRow = swatchIndex > 15;
                            checkSoldOutAndAdditionalColorways(
                                showSecondProductRow,
                                showThirdProductRow,
                            );
                        } else {
                            let showSecondProductRow = false;
                            let showThirdProductRow = false;
                            if ($('body').hasClass('pdp-frame-case')) {
                                imageScrollbar.css('transform', 'translateY(0px)');
                                //productInfo.css('transform', 'translateY(calc(100% - 135px))');
                                plusMinusSwatchSymbol.text('+');
                                $('.has-options-opened').removeClass('has-options-opened');
                                $('.show-variants').removeClass('show-variants');
                                if (!$('body').hasClass('final-sale-item')) {                              
                                    $('body').removeClass('pdp-variants-opened');
                                } else {
                                    $('body').addClass('pdp-variants-opened');
                                }
                            } else if (
                                $('body').hasClass('template-krewe-gift-card') ||
                                $('body').hasClass('template-summer-tote-2023')
                            ) {
                                imageScrollbar.css('transform', 'translateY(0px)');
                                //productInfo.css('transform', 'translateY(calc(100% - 217px))');
                                plusMinusSwatchSymbol.text('+');
                                $('.has-options-opened').removeClass('has-options-opened');
                                $('.show-variants').removeClass('show-variants');
                                if (!$('body').hasClass('final-sale-item')) {                              
                                    $('body').removeClass('pdp-variants-opened');
                                } else {
                                    $('body').addClass('pdp-variants-opened');
                                }
                            } else {
                                if (
                                    $('.lens--readers--options').length &&
                                    $('.lens--readers--options').hasClass('readers--show') &&
                                    !$('.selected-readers').length
                                ) {
                                    // console.log('Readers found');
                                    $addToCart.removeClass('power-not-selected');
                                    $AddToCartText.text('Add to Bag');
                                    $('.lens--readers--options').each(function () {
                                        $(this)
                                            .removeClass('readers--show')
                                            .attr('aria-hidden', 'true');
                                    });
                                    $(
                                        'button.active-variant[data-variant-name="Blue Light Readers"]',
                                    ).each(function () {
                                        $(this).removeClass('active-variant');
                                    });
                                }
                                checkSoldOutAndAdditionalColorways(
                                    showSecondProductRow,
                                    showThirdProductRow,
                                );
                                //console.log("this 2");
                            }
                            //console.log('This fired');
                        }
                        if (
                            $('.selected-readers').length > 0 &&
                            $(
                                '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                            ).hasClass('active-variant') &&
                            $(
                                '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                            ).hasClass('has-readers-selected')
                        ) {
                            let powerValue = $('.selected-readers').data('power-value');
                            $AddToCartText.html('Add with Lens <em>' + powerValue + '</em>');
                        } else if (
                            $(
                                '.all-available-blue-light button[data-variant-name="Blue Light"]',
                            ).hasClass('active-variant')
                        ) {
                            if (!$('body').hasClass('extra20-pdp')) {
                                $AddToCartText.text('Add with Lens');
                            } else {
                                if (window.theme.currencyISO === 'USD') {
                                    $AddToCartText.text('Add to Bag for +20% Off');
                                } else {
                                    $AddToCartText.text('Add to Bag');
                                
                                }
                            }
                        }
                        $('body').removeClass('pdp-tab-opened');
                        if (!$('body').hasClass('final-sale-item')) {                              
                            $('body').removeClass('pdp-variants-opened');
                        } else {
                            if ($('body').hasClass('showing-waitlist-bar')) {
                                $('body').removeClass('pdp-variants-opened');
                            } else {
                                $('body').addClass('pdp-variants-opened');
                            }
                        }
                    }
                }
            },
        );
        var startY3;
        $(document).on(
            'touchstart.myTouchNamespace5',
            '.active-product-card .product__info-wrapper',
            function (e) {
                if (e.originalEvent.touches.length > 1) {
                    isGesture = true;
                    return;
                }
                isGesture = false;
                startY3 = e.originalEvent.touches[0].clientY;
            },
        );
        /// OPEN TAB
        $(document).on(
            'touchmove.myTouchNamespace6',
            '.active-product-card .product__info-wrapper',
            function (e) {
                if (isGesture || e.originalEvent.touches.length > 1) {
                    return;
                }

                var touch = e.originalEvent.touches[0];
                var moveY = startY3 - touch.clientY;
                let productInfo = $('.active-product-card .product__info-wrapper');
                let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
                if (!$(this).data('open') && moveY > 50) {
                    $('body').addClass('already-opened-tab');

                    if (!hasNudgedKeyFeatures) {
                        nudgeKeyFeatures();
                        hasNudgedKeyFeatures = true; // Set the flag to true
                    }

                    productInfo.data('opening', '');
                    productInfo.css('transform', 'translateY(55px)');
                    $(overlay).css('opacity', 0.9);
                    $(
                        '.frame-available-options .product-variants-wrapper.normal-option-selectors, .pdp-message-carousel-wrapper',
                    ).css('opacity', 1);
                    if (
                        $('.pdp-family-products-swatch-bar').hasClass('large-product-swatch-bar')
                    ) {
                        $('.pdp-family-products-swatch-bar').addClass(
                            'show-additional-colorways',
                        );
                        $('body').addClass('pdp-showing-additional-colorways');
                        plusMinusSwatch.css('opacity', 0);
                    }
                    setTimeout(() => {
                        productInfo.css('transform', '');
                        productInfo.attr('data-open', '');
                        productInfo.removeAttr('data-opening');
                        productInfo.removeClass('closed-state');
                    }, 300);
                    $('body').addClass('pdp-tab-opened');
                    $('body').removeClass('pdp-variants-opened');
                    $('.show-variants').removeClass('show-variants');
                    $('.has-options-opened').removeClass('has-options-opened');
                    $('.show-variants').removeClass('show-variants');
                    if (
                        $(
                            '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                        ).hasClass('active-variant') &&
                        $(
                            '.all-available-blue-light-readers button[data-variant-name="Blue Light Readers"]',
                        ).hasClass('has-readers-selected')
                    ) {
                        let powerValue = $('.selected-readers').data('power-value');
                        if (!$('body').hasClass('extra20-pdp')) {
                            $AddToCartText.html('Add with Readers <em>' + powerValue + '</em>');
                        } else {
                            if (window.theme.currencyISO === 'USD') {
                                $AddToCartText.text('Add to Bag for +20% Off');
                            } else {
                                $AddToCartText.text('Add to Bag');
                            
                            }
                        }
                    } else if (
                        $(
                            '.all-available-blue-light button[data-variant-name="Blue Light"]',
                        ).hasClass('active-variant')
                    ) {
                        if (!$('body').hasClass('extra20-pdp')) {
                            $AddToCartText.text('Add with Blue Light');
                        } else {
                            if (window.theme.currencyISO === 'USD') {
                                $AddToCartText.text('Add to Bag for +20% Off');
                            } else {
                                $AddToCartText.text('Add to Bag');
                            }
                        }
                    }
                    if ($('.pdp-family-swatch.pdp-family-swatch-product:nth-child(16)').length) {
                        $('.pdp-family-swatch.pdp-family-swatch-product:nth-child(16)').css(
                            'opacity',
                            1,
                        );
                        $(
                            '.pdp-family-products-swatch-bar-scroll .pdp-family-swatch-product',
                        ).css('transform', 'translateY(0px)');
                    }

                    autoplayPLPVideos();
                }
            },
        );
        $(document).on(
            'click.myTouchNamespace7',
            '.frame-reviews-section .yotpo-widget-instance',
            function (e) {
                let productInfo = $('.active-product-card .product__info-wrapper');
                let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
                let plusMinusSwatchSymbol = plusMinusSwatch.find('em');
                let imageScrollbar = $(
                    '.active-product-card .pdp-main-carousel .carousel-track-wrapper',
                );
                if ($('.pdp-family-products-swatch-bar').hasClass('large-product-swatch-bar')) {
                    $('.pdp-family-products-swatch-bar').addClass('show-additional-colorways');
                    $('body').addClass('pdp-showing-additional-colorways');
                    plusMinusSwatch.css('opacity', 0);
                }
                $('body').addClass('pdp-tab-opened');
                $('body').removeClass('pdp-variants-opened');
                $('.show-variants').removeClass('show-variants');
                $('.has-options-opened').removeClass('has-options-opened');
                $('.show-variants').removeClass('show-variants');
                if (productInfo.attr('data-open')) {
                    if ($('.accordion-heading-reviews').hasClass('opened-accordion')) {
                        $('.active-product-card .product__info-wrapper').animate(
                            {
                                scrollTop: $('.accordion-wrapper-reviews').position().top + 5,
                            },
                            'slow',
                        );
                    } else {
                        $('.accordion-heading-reviews').click();
                    }
                } else {
                    productInfo.attr('data-opening', '');
                    productInfo.css('transform', 'translateY(55px)');
                    overlay.css('opacity', 0.9);
                    $('.pdp-message-carousel-wrapper').css('opacity', 1);
                    setTimeout(function () {
                        productInfo.css('transform', '');
                        productInfo.attr('data-open', '');
                        productInfo.removeAttr('data-opening');
                        productInfo.removeClass('closed-state');
                    }, 300);
                    setTimeout(function () {
                        if ($('.accordion-heading-reviews').hasClass('opened-accordion')) {
                            $('.active-product-card .product__info-wrapper').animate(
                                {
                                    scrollTop:
                                        $('.accordion-wrapper-reviews').position().top + 5,
                                },
                                'slow',
                            );
                        } else {
                            if ($('.opened-accordion').length > 1) {
                                $('.accordion-heading-reviews').click();
                            } else {
                                $('.active-product-card .product__info-wrapper').animate(
                                    {
                                        scrollTop:
                                            $('.accordion-wrapper-reviews').position().top + 5,
                                    },
                                    500,
                                );
                                $('.accordion-heading-reviews').click();
                            }
                        }
                    }, 200);
                    normalOptionSelectors.css('opacity', 1);
                    $('body').addClass('pdp-tab-opened');
                    $('body').removeClass('pdp-variants-opened');
                }
            },
        );

        $(document).on('click.myTouchNamespace8', '.how-it-fits-trigger', function (e) {
            let productInfo = $('.active-product-card .product__info-wrapper');
            let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
            if ($('.pdp-family-products-swatch-bar').hasClass('large-product-swatch-bar')) {
                $('.pdp-family-products-swatch-bar').addClass('show-additional-colorways');
                $('body').addClass('pdp-showing-additional-colorways');
                plusMinusSwatch.css('opacity', 0);
            }
            $('body').addClass('pdp-tab-opened');
            $('body').removeClass('pdp-variants-opened');
            $('.show-variants').removeClass('show-variants');
            $('.has-options-opened').removeClass('has-options-opened');
            $('.show-variants').removeClass('show-variants');
            if (productInfo.attr('data-open')) {
                if ($('.accordion-heading-how-it-fits').hasClass('opened-accordion')) {
                    $('.active-product-card .product__info-wrapper').animate(
                        {
                            scrollTop: $('.accordion-wrapper-how-it-fits').position().top + 5,
                        },
                        'slow',
                    );
                } else {
                    $('.accordion-heading-how-it-fits').click();
                }
            } else {
                productInfo.attr('data-opening', '');
                productInfo.css('transform', 'translateY(55px)');
                overlay.css('opacity', 0.9);
                $('.pdp-message-carousel-wrapper').css('opacity', 1);
                setTimeout(function () {
                    productInfo.css('transform', '');
                    productInfo.attr('data-open', '');
                    productInfo.removeAttr('data-opening');
                    productInfo.removeClass('closed-state');
                }, 300);
                setTimeout(function () {
                    if ($('.accordion-heading-how-it-fits').hasClass('opened-accordion')) {
                        $('.active-product-card .product__info-wrapper').animate(
                            {
                                scrollTop:
                                    $('.accordion-wrapper-how-it-fits').position().top + 5,
                            },
                            'slow',
                        );
                    } else {
                        if ($('.opened-accordion').length > 1) {
                            $('.accordion-heading-how-it-fits').click();
                        } else {
                            $('.active-product-card .product__info-wrapper').animate(
                                {
                                    scrollTop:
                                        $('.accordion-wrapper-how-it-fits').position().top + 5,
                                },
                                500,
                            );
                            $('.accordion-heading-how-it-fits').click();
                        }
                    }
                }, 200);
                normalOptionSelectors.css('opacity', 1);
                $('body').addClass('pdp-tab-opened');
                $('body').removeClass('pdp-variants-opened');
            }
        });

        headerOverlay.on('click', function (event) {
            let productInfo = $('.active-product-card .product__info-wrapper');
            let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
            if ($('body').hasClass('pdp-tab-opened') && productInfo.scrollTop() != 0) {
                $('.product__info-wrapper').animate({ scrollTop: 0 }, 300);
            } else {
                // mimic the behavior as if the user had dragged the product info down
                productInfo.attr('data-closing', '');
                checkSoldOutAndAdditionalColorways();
                overlay.css('opacity', 0); // New line
                smoothScrollToTop(productInfo, 100);
                setTimeout(function () {
                    productInfo.css('transform', '');
                    productInfo.removeAttr('data-open');
                    productInfo.removeAttr('data-closing');
                    productInfo.scrollTop(0); // This will reset the scroll position to top when the .active-product-card .product__info-wrapper is closed
                }, 600);
                //console.log'Touch ended and it is closed')
                $('body').removeClass('pdp-tab-opened');
            }
        });
        setTimeout(function () {
            $('#mediaGallery ul').scrollTop(0);
        }, 200);
    } else {
        $(document).off('.myTouchNamespace1');
        $(document).off('.myTouchNamespace2');
        $(document).off('.myTouchNamespace3');
        $(document).off('.myTouchNamespace4');
        $(document).off('.myTouchNamespace5');
        $(document).off('.myTouchNamespace6');
        $(document).off('.myTouchNamespace7');
        $(document).on('click', '.frame-reviews-section .pr-rating-stars', function (e) {
            $('html, body').animate(
                {
                    scrollTop: $('.main-reviews').offset().top - 100,
                },
                700,
            );
        });
    }
}
registerEvents();
// Call the function again whenever the window is resized
$(window).resize(function () {
    // Remove all previous event listeners to prevent duplicate registrations
    // Re-register the events based on the current screen size
    registerEvents();
});

function removePlayerControls() {
    var videoElements = document.querySelectorAll('video');

    if (videoElements.length > 0) {
        videoElements.forEach(function(videoElement) {
        videoElement.controls = false;
    
        videoElement.addEventListener('play', function () {
            this.controls = false;
        });
    
        videoElement.addEventListener('pause', function () {
            this.controls = false;
        });
    });
    }
}

const bodyElement = document.body;
let disconnectMutation = false;
const classChangeCallback = (mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
       // console.log('body class changed');
       
       if (bodyElement.classList.contains('how-it-fits-first')) {
        disconnectMutation = true;
        openDefaultAccordion(disconnectMutation);
      }
        
    }
  }
};

const bodyClassObserver = new MutationObserver(classChangeCallback);

const bodyClassObserverConfig = { attributes: true, attributeFilter: ['class'] };

bodyClassObserver.observe(bodyElement, bodyClassObserverConfig);

function setRootCSSVariable(variable, value) {
    document.documentElement.style.setProperty(variable, value);
}

const frameCasePrice = $('#frameCase').attr('data-add-on-amount');
//floatSidebar.forceUpdate();
/* +----------------------+
   |         ```          |
   +----------------------+
   Colorway swatch hover/click
   +----------------------+
   |         ```          |
   +----------------------+ */
let familyItemHover;
const $productMainImagesContainer = $('.pdp-main-carousel ul');
const $productPrice = $('.pdp-price');
let $frameTitle = $('.pdp-frame-title');
const $frameDescription = $('.collection-description');
const $frameMainDescription = $('.product__description.main-description');
const $frameModelInfo = $('.accordion-how-it-fits .accordion__content-inner');
const $keyFeatures = $('.key-features-carousel');
const $productForm = $('product-form input[name="id"]');
const $constructionAccordionContent = $('.accordion-construction .accordion__content-inner');
const $colorAccordionContent = $('.accordion-color .accordion__content-inner');
const $lensAccordionContent = $('.accordion-lens-details .accordion__content-inner');
const $warrantyAccordionContent = $('.accordion-warranty .accordion__content-inner');
const $breadcrumbTitle = $('.breadcrumb-item:last-child');
const currentCollectionHandle = $('.product').attr('data-current-collection-handle');
let $productAccordion = $('.product__accordion:not(.accordion-popup-wrapper)');
const preShopTag =
    '<a href="/collections/pre-shop-sale-he-2026" title="Go to Pre-Shop"><img src="' +
    window.theme.preshop_tag +
    '" alt="Event Pre-Shop" style="position: relative;top: -1px;" />';
const preShopTagOnlineOnly =
    '<a href="/collections/pre-shop-sale-he-2026" title="Go to Pre-Shop"><img src="' +
    window.theme.preshop_online_only_tag +
    '" alt="Event Pre-Shop Online Only" style="position: relative;top: -1px;" />';
const preShopTagOnlineOnlyMobile =
    '<a href="/collections/pre-shop-sale-he-2026" title="Go to Pre-Shop"><img src="' +
    window.theme.preshop_online_only_tag_mobile +
    '" alt="Pre-Shop Online Only" style="position: relative;top: -1px;" />';
const onlineOnlyTag =
    '<a href="/collections/sale"><img src="' +
    window.theme.sale_online_only_tag +
    '" alt="Online Only" style="position: relative;top: -1px;" /></a>'; 
const allSaleTag =
    '<span class="br--title bb--title pdp--sub-title pdp-online-only pdp-sale-online-only"><a href="/collections/sale"><img src="https://cdn.shopify.com/s/files/1/2422/6603/files/PE-2023-EndsTonight-Tag.gif?v=1680724104" /></span>';
const sotdTag =
    '<a href="/collections/sale"><img src="https://cdn.shopify.com/s/files/1/2422/6603/files/HE-2023-SOTD-Tag.gif?v=1697832362" alt="Steal of the Day"></a>';
let specialBodyClass = '';

function getSpecialBodyClass() {
    const activeFrame = document.querySelector('.frame-active button');
    const colorBodyClass = activeFrame.getAttribute('data-product-special-body-class');

    specialBodyClass = colorBodyClass || '';
}

function openDefaultAccordion() {
    let accordionToOpen = 'key-features';

    if ($('body').hasClass('how-it-fits-first')) {
        accordionToOpen = 'how-it-fits';
    }

    if ($('body:not(.disable_opened_accordion)').hasClass('special-pdp')) {
        accordionToOpen = 'design-notes';
    }
    $productAccordion.each(function () {
        var $this = $(this);
        // Skip if this is a popup accordion
        if ($this.hasClass('accordion-popup-wrapper')) {
            return;
        }
        var accordionHeading = $this.find('.accordion__title').text();
        if (!$this.hasClass('accordion-wrapper-'+accordionToOpen)) {
            $this.removeClass('product-accordion-opened');
            $this
                .find('.accordion-heading:not(.accordion-popup-trigger)')
                .removeClass('opened-accordion')
                .attr('aria-expanded', 'false');
            $this
                .find('.accordion__content')
                .css('max-height', '0')
                .prop('hidden', true);
            $this
                .find('.hidden-focus-target')
                .attr('aria-hidden', 'true')
                .attr('tabindex', '-1');
            $this.find('.accordion__content a').attr('tabindex', '-1');
            $this.find('.accordion__content button').attr('tabindex', '-1');
            $this
                .find('.accordion__content button')
                .attr('data-gtm-label', accordionHeading + ' - Open');
        } else if (
            $this.hasClass('accordion-wrapper-'+accordionToOpen) &&
            !$this.hasClass('product-accordion-opened')
        ) {
            $this.addClass('product-accordion-opened');
            $this
                .find('.accordion-heading:not(.accordion-popup-trigger)')
                .addClass('opened-accordion')
                .attr('aria-expanded', 'true');
            $this.find('.accordion__content').prop('hidden', false);
            $this
                .find('.hidden-focus-target')
                .attr('aria-hidden', 'false')
                .attr('tabindex', '0');
            $this
                .find('.accordion__content button')
                .attr('data-gtm-label', accordionHeading + ' - Close');
        }
        $('.face-shapes-wrapper').removeClass('face-shapes-opened');
        $('.face-shapes-trigger').removeClass('close-face-shapes');
        $('.face-shapes-trigger').attr(
            'data-gtm-label',
            "What's My Face Shape? - Open",
        );
    });

    updateAccordionHeight();

    setTimeout(function(){
        if (accordionToOpen == 'key-features') {
            //console.log('updated key features carousels');
            updateKeyFeaturesCarousels();
        } else {
           // console.log('updated accordion model carousels');
            updateAccordionModelCarousels()
        }
        carouselsDrag();
    },100);

    //console.log('opened accordion: ' + accordionToOpen);



    if (disconnectMutation) {
        bodyClassObserver.disconnect();
    }
    
}

document.addEventListener('DOMContentLoaded', function () {
    openDefaultAccordion();
    $('body').removeClass('not-loaded');
    if (normalOptionSelectors.hasClass('size-option-hidden') && normalOptionSelectors.hasClass('lens-option-hidden')) {
        $('body').addClass('pdp-no-options');
    }
    getSpecialBodyClass();
});

if (deviceIsMobile.matches) {
    familyItemHover;
}
let pdp_options_events = 'mouseenter';
if (deviceIsMobile.matches) {
    familyItemHover;
    pdp_options_events = 'click';
}

// Apply Filter Slides - PDP Carousel Messages on Page Load
document.addEventListener('DOMContentLoaded', function () {
    // Apply initial filter
    filterSlides();
});

$(document).on('mouseenter click', '.pdp-family-swatch-product button', function (e) {
    e.preventDefault();
    let $this = $(this);
    function loadHoveredElements() {
        let product = {
            handle: $this.attr('data-product-handle'),
            id: $this.attr('data-product-id'),
            familyName: $this.attr('data-product-family-name'),
            familyHandle: $this.attr('data-family-handle'),
            fullName: $this.attr('data-product-full-name'),
            featuredImage: $this.attr('data-product-featured-image'),
            sku: $this.attr('data-product-sku'),
            url: $this.attr('data-product-url'),
            inventoryQuantity: $this.attr('data-inventory-quantity'),
            isVanityLens: $this.attr('data-product-is-vanity'),
            adminProductType: $this.attr('data-product-type'),
            fullPrice: $this.attr('data-product-price-full'),
            framePrice: $this.attr('data-product-price'),
            comparePrice: $this.attr('data-product-compare-at-price'),
            productisPreOrder: $this.data('product-is-preorder'),
            productCustomAtcText: $this.data('data-product-custom-atc-text'),
            preOrderDate: $this.data('product-preorder-text'),
            preOrderLineProperty: $this.attr('data-product-preorder-property'),
            hasSpecialBodyClass: $this.attr('data-product-special-body-class'),
            colorwayPDP: $this.attr('data-family-specific-pdp'),
            hideWaitlist: $this.attr('data-product-hide-waitlist'),
            addToBagSubtitleText: $this.attr('data-add-to-bag-subtitle'),
            add_ons_pricing: {
                with_case: $this.attr('data-product-price-with-case'),
                with_soft_case: $this.attr('data-product-price-with-case'),
                with_blue_light: $this.attr('data-product-price-with-blue-light'),
                with_readers: $this.attr('data-product-price-with-blue-light-readers'),
                with_case_and_blue_light: $this.attr('data-product-price-with-case-blue-light'),
                with_case_and_readers: $this.attr('data-product-price-with-case-blue-light-readers'),
                with_soft_case_and_blue_light: $this.attr('data-product-price-with-case-blue-light'),
                with_soft_case_and_readers: $this.attr('data-product-price-with-case-blue-light-readers')
            },
            tag: {
                label: $this.attr('data-product-main-tag'),
                alt: $this.attr('data-product-main-tag-alt'),
                url: $this.attr('data-product-main-tag-link'),
                borderColor: $this.attr('data-product-main-tag-border-color'),
                color: $this.attr('data-product-main-tag-color'),
                triggersPopup: $this.attr('data-product-main-tag-popup-trigger'),
                popupTag: $this.attr('data-product-main-tag-popup-trigger-tag'),
            },
            sale: {
                onSale: $this.attr('data-product-is-sale-item'),
                sale_type: $this.attr('data-product-product-type'),
                extra20: $this.data('product-extra20'),
                allSalePeriod: $this.attr('data-product-all-sale-period'),
                isRestocked: $this.attr('data-product-is-restocked'),
                isPreShop: $this.attr('data-product-is-pre-shop'),
                addGWP: $this.attr('data-add-gwp'),
                isOnlineOnly: $this.attr('data-product-is-sale-item-online-only'),
                isSOTD: $this.attr('data-product-is-sale-item-sotd'),
            },
            addToBagColors: {
                name: $this.attr('data-custom-atb-color'),
                backgroundColor: $this.attr('data-atb-bg-color'),
                textColor: $this.attr('data-atb-color-text'),
                hoverBackgroundColor: $this.attr('data-atb-bg-color-hover'),
                hoverTextColor: $this.attr('data-atb-color-text-hover'),
                subtitle: $this.attr('data-atb-custom-subtitle'),
                subtitle_quantity: $this.attr('data-atb-custom-inventory'),
                subtitle_inventory_based: $this.attr('data-atb-custom-subtitle-inventory-based')
            },
            valueProp: $this.attr('data-product-value-prop'),
            specialLineProperty: $this.attr('data-product-special-line-property'),
        };

        product.variantID = $('.family-product-contents[data-product-handle="' + product.handle + '"]').attr('data-variant-id'),
        product.title = $('.family-product-contents[data-product-handle="' +product.handle +'"] .frame-title').html(),
        product.images = $('.family-product-contents[data-product-handle="' + product.handle +'"] .frame-product-images').children(),
        product.frameMainDescription = $('.family-product-contents[data-product-handle="' + product.handle + '"] .main-description').html(),
        product.frameDetailsDescription = $('.family-product-contents[data-product-handle="' + product.handle + '"] .frame-description').html(),
        product.modelInfo = $('.family-product-contents[data-product-handle="' + product.handle + '"] .frame-model-info').html(),
        product.variants = {
            size: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .frame-variants ul[data-option-name="size"]'
            ).html(),
            lens: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .frame-variants ul[data-option-name="lens"]'
            ).html(),
        };
        product.accordions = {
            designNotes: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .frame-design-notes'
            ).html(),
            keyFeatures: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .frame-key-features'
            ).html(),
            constructionContent: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .construction'
            ).html(),
            colorContent: $(
                '.family-product-contents[data-product-handle="' + product.handle + '"] .color'
            ).html(),
            lensContent: $(
                '.family-product-contents[data-product-handle="' + product.handle + '"] .lens'
            ).html(),
            warrantyContent: $(
                '.family-product-contents[data-product-handle="' +
                    product.handle +
                    '"] .warranty'
            ).html(),
        };

        if (product.hasSpecialBodyClass == 'false') {
            $('body').removeClass(specialBodyClass);
        } else {
            specialBodyClass = product.hasSpecialBodyClass;
            $('body').addClass(specialBodyClass);
        }

        // Apply Body Classes based on Pre-Shop Logic
        if (product.sale.isPreShop === 'true' && window.theme.preShopActive) {
            $('body').addClass('preshop-pdp');
        } else {
            $('body').removeClass('preshop-pdp');
        }

        //var $mediaList = $('.pdp-main-carousel .product__media-list');
        //$mediaList.scrollTop($mediaList.scrollTop() + 1).scrollTop($mediaList.scrollTop() - 1);
        $('body').addClass('just-clicked-swatch');
        $('.product-form__variants option').attr('value', product.variantID);
        $('.product-form__variants').trigger('change');
        setTimeout(function () {
            $('body').removeClass('just-clicked-swatch');
        }, 300);
        normalOptionSelectors.css('opacity', 0);
        $('.accordion-design-notes .accordion__content-inner').html(
            product.accordions.designNotes,
        );
        $('#addPolarized').prop('checked', false);
        $('#buyItNow').css('display', 'block');
        $('.pdp-family-products-swatch-bar-scroll .frame-active').removeClass('frame-active');
        $(
            '.pdp-family-products-swatch-bar-scroll button[data-product-handle="' +
                product.handle +
                '"]',
        )
            .parent()
            .addClass('frame-active');
        let $clickedSwatch = $('.pdp-family-products-swatch-bar-scroll .frame-active');
        let swatchIndex = $clickedSwatch.index('.pdp-family-swatch-product') + 1;
        let showSecondProductRow = swatchIndex >= 8 && swatchIndex <= 15;
        let showThirdProductRow = swatchIndex > 15;
        //console.log("Click on swatch: ", swatchIndex);
        //console.log("Show second row: ", showSecondProductRow);
        //console.log("Show third row: ", showThirdProductRow);

        let isSpecialFrame = false;
        let hitInventoryThreshold = false;
        if (product.fullName == 'LIPFLIP | Cherry + Julep' || product.fullName == 'ZANDER | Julep + Custom Vanity Tint' || product.fullName == 'LIPFLIP | Cherry + Julep Mirror Vanity (Float Edition)') {
            isSpecialFrame = true;
        }

        if (product.inventoryQuantity > 0 && product.inventoryQuantity <= 10) {
            hitInventoryThreshold = true;
        }
        
        // This updates the ADD-TO-CART Button's data-product-item-type correctly based on Product Swatch selected/hovered.
        $('#AddToCart').attr(
            'data-product-item-type',
            $this.attr('data-product-product-type')
        );

        checkAvailableVariants(
            $this,
            product.handle,
            product.variants.size,
            product.variants.lens,
        );

        /*
          `finalSaleFrameWithCase`: Defines a specific string used to identify products that are 'Final Sale' and include a frame case without an additional selection/add-on/purchase.
          This value must match the 'Product Type' from the Shopify product admin for sale logic to apply correctly.
        */
        const finalSaleFrameWithCase = 'FINAL SALE: Frame includes frame case';
        /*
            Reset: Hide all PDP messages on swatch hover/click;
        */
        $('.pdp-message').removeClass('show-pdp-message');
        // console.log('product.sale.sale_type',product.sale.sale_type)

        /* Reset data-main-tag on ADD TO CART Button */
        $('#AddToCart').attr('data-main-tag','').removeClass('cta-color-krewe-x-loveshackfancy');
        $('.accordion-wrapper-store-locator').attr('data-main-tag','');
      
        if (normalOptionSelectors.hasClass('size-option-hidden') && normalOptionSelectors.hasClass('lens-option-hidden')) {
            $('body').addClass('pdp-no-options');
        }

        /* 
            Apply Custom Tag to Add To Cart Button 
            This is used to apply a custom color based on products with this data-main-tag.
        */
        if (product.tag.alt === 'KREWE x LoveShackFancy'){
           $('#AddToCart').attr('data-main-tag','KREWE x LoveShackFancy').addClass('cta-color-krewe-x-loveshackfancy');
           $('.accordion-wrapper-store-locator').attr('data-main-tag','KREWE x LoveShackFancy');
        }

        /* Product Type: KIT */
        if (product.adminProductType === 'KIT') {
            $addToCart.addClass('has-vanity-lens');
            $addToCart
                .attr('data-line-property-frame', 'Vanity lenses are exchange only')
                .attr('data-line-property-note', 'Process time is additional 3 business days');

            $('#buyItNowBtn').addClass('has-vanity-lens');
            $('#buyItNowBtn')
                .attr('data-line-property-frame', 'Vanity lenses are exchange only')
                .attr('data-line-property-note', 'Process time is additional 3 business days');
        } 
        /* Product Sale Type FINAL SALE */
        else if (product.sale.sale_type === 'FINAL SALE') {
            /* 
                Product Tag: `frame with case:FINAL`
                Display PDP Message: 'FINAL SALE: Frame includes frame case'
            */
            let pdpSaleItemTag = 'popup:FINAL'; 
            // $('.variant-button.variant-hard-case.variant-selected').click();
            // console.log('pdpSaleItemTag', $('.pdp-message.pdp-popup-final'));
            $('.pdp-message').removeClass('show-pdp-message');
            setTimeout((e)=>{
                $('.pdp-message.pdp-popup-final')
                .addClass('show-pdp-message');
            },200);
            
            /* Reset: Remove Vanity Lens rules */
            $addToCart.removeClass('has-vanity-lens'); 
            $('#buyItNowBtn').removeClass('has-vanity-lens');
        }

        /* Product Sale Type FINAL SALE: Frame includes frame case */
        else if (product.sale.sale_type === 'finalSaleFrameWithCase') {
            /* 
                Product Tag: `frame with case:FINAL`
                Display PDP Message: 'FINAL SALE: Frame includes frame case'
            */
            let pdpSaleItemTag = 'frame with case:FINAL';
            $('.pdp-message').removeClass('show-pdp-message');
            $('.pdp-message[data-message-tag="' + pdpSaleItemTag + '"')
                .addClass('show-pdp-message');

            /* Reset: Remove Vanity Lens rules */
            $addToCart.removeClass('has-vanity-lens'); 
            $('#buyItNowBtn').removeClass('has-vanity-lens');

            /* 
                Apply: "FINAL SALE: Frame includes frame case" line item property
                Apply: "Frame includes frame case" line item property Note
            */
            $addToCart
                .attr('data-line-property-frame', finalSaleFrameWithCase.substring(0, 10))
                .attr('data-line-property-note', finalSaleFrameWithCase.replace('FINAL SALE: ','').trim());
            $('#buyItNowBtn')
                .attr('data-line-property-frame', finalSaleFrameWithCase.substring(0, 10))
                .attr('data-line-property-note', finalSaleFrameWithCase.replace('FINAL SALE: ','').trim());
        }

        /*
            Product Family Name - KRAWFISH BOIL (Special Merchandise).
            This probably can be deleted and handled differently
        */
        else if (product.familyName === "KRAWFISH BOIL '25") {
            // Apply a line item property note about Pre-Order Shipping
            $addToCart.attr('data-line-property-note', 'SHIPS BY 5.30');
        } 

        /* Default Fallback */
        else {
            /* Reset: Remove Vanity Lens rules */
            $addToCart.removeClass('has-vanity-lens');
            $('#buyItNowBtn').removeClass('has-vanity-lens');

            /* 
                Reset: `data-line-property-frame`
                Reset: `data-line-property-note`
            */
            $addToCart
                .attr('data-line-property-frame', '')
                .attr('data-line-property-note', '');
            $('#buyItNowBtn')
                .attr('data-line-property-frame', '')
                .attr('data-line-property-note', '');
        }

        if (showSecondProductRow) {
            $('.pdp-family-products-swatch-bar').addClass('second-row-item-active');
            $('.pdp-family-products-swatch-bar').removeClass('third-row-item-active');
        } else if (showThirdProductRow) {
            $('.pdp-family-products-swatch-bar').addClass('third-row-item-active');
            $('.pdp-family-products-swatch-bar').removeClass('second-row-item-active');
            //console.log("showThirdProductRow");
        } else {
            $('.pdp-family-products-swatch-bar').removeClass('second-row-item-active');
            $('.pdp-family-products-swatch-bar').removeClass('third-row-item-active');
        }
  
        if (product.addToBagSubtitleText != 'false') {

            $('.product-shop-inventory-notice').addClass('active').attr('aria-hidden', false);
            $addToCart.addClass('pdp-low-inventory');
            addToBagSubtitle.html(product.addToBagSubtitleText);

        } else if (product.inventoryQuantity > 0 && product.inventoryQuantity < 11) {
            
            $('.active-gwp').removeClass('active-gwp');
            $('.product-shop-inventory-notice').addClass('active').attr('aria-hidden', false);
            $addToCart.addClass('pdp-low-inventory');

            $('.product-shop-inventory-notice').html(
                'In Demand <span class="tick-tock-quantity">' +
                    product.inventoryQuantity +
                    '</span> left',
            );
   
            $('.tick-tock-quantity').text(product.inventoryQuantity);

        } else {
            if (window.theme.gwp_active && product.sale.addGWP === 'true') {
                $('.product-shop-inventory-notice').addClass('active-gwp');
                let gwpText = '';

                gwpText = '<span class="longer-message">INCLUDES GIFT WITH PURCHASE</span><span class="shorter-message">+GIFT WITH PURCHASE</span>'

                $('.product-shop-inventory-notice')
                    .addClass('active')
                    .attr('aria-hidden', false)
                    .html(gwpText);
                $addToCart.addClass('pdp-low-inventory');
            } else {
                $('.product-shop-inventory-notice')
                    .removeClass('active')
                    .removeClass('active-gwp')
                    .attr('aria-hidden', true);
                $addToCart.removeClass('pdp-low-inventory');
            }
        }

        // Apply "Sale Pre-Shop" Label for Pre-Shop Items when Pre-Shop is Active
        if (window.theme.preShopActive && product.sale.isPreShop === 'true') {
            product.tag.label = 'Sale Pre-Shop';
            product.tag.color = 'var(--color-add-to-bag-sale)';
        }

        /* This helps prevent "Final Sale" from being displayed on Non Final Sale Items */    
        if ($('.pdp-tag').length > 0 && $('.pdp-tag').hasClass('pdp-tag-static') && product.sale.sale_type === 'FINAL SALE') {
            product.tag.label = 'Final Sale';
        }

        ///////// PDP TAGS ///////
        if (
            window.theme.preShopActive &&
            product.sale.isPreShop === 'true' &&
            $('body').hasClass('landed-on-preshop')
        ) {
            if (product.sale.isOnlineOnly === 'true') {
                if (deviceIsMobile.matches) {
                    $('.pdp-tag').html(preShopTagOnlineOnlyMobile);
                } else {
                    $('.pdp-tag').html(preShopTagOnlineOnly);
                }
            } else {
                $('.pdp-tag').html(preShopTag);
            }

            //console.log('is pre shop and landed on preshop');
        } else if (
            window.theme.isSaleActive &&
            product.sale.onSale === 'true' &&
            (product.sale.isSOTD === 'true' || product.sale.isOnlineOnly === 'true')
        ) {
            if (product.sale.isSOTD === 'true') {
                $('.pdp-tag').html(sotdTag);
            } else if (product.sale.isOnlineOnly === 'true') {
                $('.pdp-tag').html(onlineOnlyTag);
            }
        } else if (
            (product.tag.label != 'false' &&
                !$this.hasClass('pdp-swatch-sold-out') && product.addToBagSubtitleText != 'false'
            )) {

                if (product.tag.label.includes('cdn')) {
                    var imgSrc = product.tag.label;
                    var imgElement;
                    if (product.tag.borderColor != 'false') {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr({
                            'src': imgSrc,
                            'style': 'border-bottom:1px solid ' + product.tag.borderColor,
                        });
                    } else {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr('src', imgSrc);
                    }
                    var currentTag = $('.pdp-tag img').attr('src');
                    if (currentTag != imgSrc) {
                        $('.pdp-tag').empty().append(imgElement);
                    }
                    if (product.tag.triggersPopup === 'true') {
                        const formattedPopupId = product.tag?.popupTag 
                        ? product.tag.popupTag
                            .toLowerCase()
                            .replace(/[^a-z0-9\s]/g, '')
                            .replace(/\s+/g, '_')
                            .trim()
                        : '';
                        $('.pdp-tag').children().wrapAll(
                            '<button class="tag-based-popup-trigger" aria-label="Opens popup. Learn more about ' +
                            product.tag.alt +
                            '" aria-expanded="false" aria-controls="popup_'+ formattedPopupId +'" data-info-popup-item-tag="' +
                            product.tag.popupTag +
                            '" style="color:'+ product.tag.color +'"></button>'
                        );
                    } else if (
                        product.tag.url != 'false' &&
                        product.tag.url != $('.pdp-tag a').attr('href')
                    ) {
                        $('.pdp-tag').children().wrapAll('<a href="' + product.tag.url + '" style="color:'+ product.tag.color +'"></a>');
                    }
                } else if (product.tag.url != 'false') {
                    $('.pdp-tag').html(
                        '<a href="' +
                        product.tag.url +
                        '"><span style="color:'+ product.tag.color +'">' +
                        product.tag.label +
                        '</span></a>'
                    );
                } else {
                    $('.pdp-tag').empty().text(product.tag.label).removeClass('triggers-popup').css('color', product.tag.color);
                }
                
                
        } else {
           // console.log('is not pre shop');
            if (
                (product.tag.label != 'false' &&
                    !$this.hasClass('pdp-swatch-sold-out') &&
                    !$('.product-shop-inventory-notice:not(.active-gwp)').hasClass('active') &&
                    product.sale.isRestocked) ||
                ($('.product-shop-inventory-notice.active-gwp').hasClass('active') &&
                    !$this.hasClass('pdp-swatch-sold-out') &&
                    product.adminProductType === 'OPTICAL')
            ) {
                if (product.tag.label.includes('cdn')) {
                    var imgSrc = product.tag.label;
                    var imgElement;
                    if (product.tag.borderColor != 'false') {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr({
                            'src': imgSrc,
                            'style': 'border-bottom:1px solid ' + product.tag.borderColor,
                        });
                    } else {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr('src', imgSrc);
                    }
                    var currentTag = $('.pdp-tag img').attr('src');
                    if (currentTag != imgSrc) {
                        $('.pdp-tag').empty().append(imgElement);
                    }
                    if (product.tag.triggersPopup === 'true') {
                        const formattedPopupId = product.tag?.popupTag 
                        ? product.tag.popupTag
                            .toLowerCase()
                            .replace(/[^a-z0-9\s]/g, '')
                            .replace(/\s+/g, '_')
                            .trim()
                        : '';

                        $('.pdp-tag').children().wrapAll(
                            '<button class="tag-based-popup-trigger" aria-label="Opens popup. Learn more about ' +
                            product.tag.alt +
                            '" aria-expanded="false" aria-controls="popup_'+ formattedPopupId +'" data-info-popup-item-tag="' +
                            product.tag.popupTag +
                            '" style="color:'+ product.tag.color +'"></button>'
                        );
                    } else if (
                        product.tag.url != 'false' &&
                        product.tag.url != $('.pdp-tag a').attr('href')
                    ) {
                        $('.pdp-tag').children().wrapAll('<a href="' + product.tag.url + '" style="color:'+ product.tag.color +'"></a>');
                    }
                } else if (product.tag.url != 'false') {
                    $('.pdp-tag').html(
                        '<a href="' +
                        product.tag.url +
                        '"><span style="color:'+ product.tag.color +'">' +
                        product.tag.label +
                        '</span></a>'
                    );
                } else {
                    $('.pdp-tag').empty().text(product.tag.label).removeClass('triggers-popup').css('color', product.tag.color);
                }
            } else if (
                product.tag.label != 'false' &&
                !$this.hasClass('pdp-swatch-sold-out') &&
                product.sale.isRestocked === 'true' && 
                hitInventoryThreshold == false
            ) {
                if (product.tag.label.includes('cdn')) {
                    var imgSrc = product.tag.label;
                    var imgElement;
                    if (product.tag.borderColor != 'false') {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr({
                            'src': imgSrc,
                            'style': 'border-bottom:1px solid ' + product.tag.borderColor,
                        });
                    } else {
                        imgElement = $('<img alt="' + product.tag.alt + '">').attr('src', imgSrc);
                    }
                    var currentTag = $('.pdp-tag img').attr('src');
                    if (currentTag != imgSrc) {
                        $('.pdp-tag').empty().append(imgElement);
                    }
                    if (product.tag.triggersPopup === 'true') {
                        const formattedPopupId = product.tag?.popupTag 
                        ? product.tag.popupTag
                            .toLowerCase()
                            .replace(/[^a-z0-9\s]/g, '')
                            .replace(/\s+/g, '_')
                            .trim()
                        : '';
                        if ($('.tag-based-popup-trigger').length == 0) {
                            
                            $('.pdp-tag').children().wrapAll(
                                '<button class="tag-based-popup-trigger" aria-label="Opens popup. Learn more about ' +
                                product.tag.alt +
                                '" aria-expanded="false" aria-controls="popup_' + formattedPopupId + '" data-info-popup-item-tag="' +
                                product.tag.popupTag +
                                '" style="'+ product.tag.color +'"></button>'
                            );
                        }
                    } else if (
                        product.tag.url != 'false' &&
                        product.tag.url != $('.pdp-tag a').attr('href')
                    ) {
                        $('.pdp-tag').children().wrapAll('<a href="' + product.tag.url + '" style="color:'+ product.tag.color +'"></a>');
                    }
                } else if (product.tag.url != 'false') {
                    $('.pdp-tag').html(
                        '<a href="' +
                        product.tag.url +
                        '"><span style="color:'+ product.tag.color +'">' +
                        product.tag.label +
                        '</span></a>'
                    );
                } else {
                    $('.pdp-tag').empty().text(product.tag.label).removeClass('triggers-popup').css('color', product.tag.color);
                }
            } else {
                if ($this.hasClass('pdp-swatch-sold-out')) {
                    if (product.sale.sale_type === 'FINAL SALE') {
                        $('.pdp-tag').html('<em class="final-sale-ooo">Final Sale</em>');
                    } else {
                        $('.pdp-tag').text('Sold Out');
                    }
                } else {
                    if (
                        $('.product-shop-inventory-notice').hasClass('active') &&
                        !$('.product-shop-inventory-notice').hasClass('active-gwp')
                    ) {
                        $('.pdp-tag').empty().text('Low Stock');
                    } else {
                        $('.pdp-tag').empty();
                    }
                }
            }
        }
        $('.product-add-to-cart, #buyItNowBtn').attr(
            'data-product-item-type',
            product.sale.sale_type,
        );
        $('#buyItNowBtn').attr('data-variant-id', product.variantID);

        if (product.sale.extra20) {
            $('body').addClass('extra20-pdp');
        } else {
            $('body').removeClass('extra20-pdp');
        }

        function checkItemType() {
            if ($('body').hasClass('template-pdp-pre-shop')) {
                product.sale.sale_type = $this.attr('data-product-product-type-preshop');
            }

            if (product.sale.sale_type === 'FINAL SALE') {
               // console.log('Final Sale Item');
                $('.pdp-message').removeClass('show-pdp-message');
               // console.log('product.familyName: ' + product.familyName);
                
                if (product.familyName != 'ST. LOUIS KIDS' && product.familyName != 'FRAME CASE' && !$('body').hasClass('pdp-frame-case') && product.familyName != 'RORY') {
                    $('body')
                    .addClass('sale-item')
                    .removeClass('exchange-only-pdp')
                    .addClass('final-sale-pdp')
                    .addClass('final-sale-item');

                    
                    /* NO CLASES INCLUDED FOR FINAL SALE ITEMS */

                    /*
                    if (!$('body').hasClass('pdp-variants-opened')) {
                        $('body').addClass('pdp-variants-opened');
                        $('.case-options-dropdown').addClass('has-options-opened');
                    }
                    $('.pdp-message.pdp-inventory-final').addClass('show-pdp-message');
                    $('#frameCase').prop('checked', true);
                    $('.variant-no-case').removeClass('variant-selected');
                    $('.variant-hard-case').addClass('variant-selected');
                    $('button[data-variant-name="no-case"]').removeClass('active-variant');
                    $('button[data-variant-name="with-case"]').addClass('active-variant');
                    $addToCart.attr('data-include-frame-case', true);
                    $('#buyItNowBtn').attr('data-include-frame-case', true);
                    */
                    $addToCart.attr('data-include-frame-case', false);
                    $('#buyItNowBtn').attr('data-include-frame-case', false);
                    
                    
                } else {
                    $('body')
                    .addClass('sale-item')
                    .removeClass('exchange-only-pdp');
                    
                    $addToCart.attr('data-include-frame-case', false);
                    $('#buyItNowBtn').attr('data-include-frame-case', false);
                }

               // console.log('Final sale');

                if (window.theme.isSaleActive) {
                    $addToCart.attr('data-line-property-frame', product.sale.sale_type);
                    // console.log('*** product.sale.sale_type', product.sale.sale_type);
                    $('#buyItNowBtn').attr('data-line-property-frame', product.sale.sale_type)
                } else if ($('body').hasClass('landed-on-preshop')  && window.theme.preShopActive) {
                    $addToCart.attr('data-line-property-hidden-frame', product.sale.sale_type);
                }
               // goToPreShopSlide();
                //updateLabel();
            } else if (product.sale.sale_type === 'EXCHANGE ONLY') {
                $('body')
                    .addClass('sale-item')
                    .removeClass('final-sale-pdp')
                    .addClass('exchange-only-pdp')
                    .removeClass('final-sale-item');
                //console.log('Exchange only item');
                if (window.theme.isSaleActive) {
                    $addToCart.attr('data-line-property-frame', product.sale.sale_type);
                    $('#buyItNowBtn').attr('data-line-property-frame', product.sale.sale_type);

                    if ($('body').hasClass('pdp-variants-opened') && !$('.show-variant-options').hasClass('has-options-opened')) {
                        $('body').removeClass('pdp-variants-opened');
                    }
                } else if ($('body').hasClass('landed-on-preshop')  && window.theme.preShopActive) {
                    
                    $addToCart.attr('data-line-property-hidden-frame', product.sale.sale_type);

                    if ($('body').hasClass('pdp-variants-opened') && !$('.show-variant-options').hasClass('has-options-opened')) {
                        $('body').removeClass('pdp-variants-opened');
                    }
                }
                //console.log('EXCHANGE item');
                $('#frameCase').prop('checked', false);
                $('button[data-variant-name="no-case"]').addClass('active-variant');
                $('button[data-variant-name="with-case"]').removeClass('active-variant');
                $addToCart.attr('data-include-frame-case', false);
                $('#buyItNowBtn').attr('data-include-frame-case', false);
                //goToPreShopSlide();
            } else {
                $('body')
                    .removeClass('sale-item')
                    .removeClass('final-sale-pdp')
                    .removeClass('exchange-only-pdp')
                    .removeClass('final-sale-item');
                //console.log('Full price item');
                $('body').removeClass('template-pdp-pre-shop');
                $addToCart.attr('data-include-frame-case', false);
                $('#buyItNowBtn').attr('data-include-frame-case', false);
                //goToSCSlide();

                if (product.adminProductType === 'KIT') {
                    $addToCart.attr('data-line-property-frame', 'Vanity lenses are exchange only');
                    $('#buyItNowBtn').attr('data-line-property-frame', 'Vanity lenses are exchange only')
                } else {
                    $addToCart.attr('data-line-property-frame', false);
                    $('#buyItNowBtn').attr('data-line-property-frame', false);
                }

                if(window.theme.isSaleActive && product.sale.sale_type === 'FINAL SALE: Frame includes frame case') {
                    $addToCart.attr('data-line-property-frame', 'FINAL SALE');
                    $('#buyItNowBtn').attr('data-line-property-frame', 'FINAL SALE');
                } else {
                    $addToCart.attr('data-line-property-frame', false);
                    $('#buyItNowBtn').attr('data-line-property-frame', false);
                }

                $('#frameCase').prop('checked', false);
                $('button[data-variant-name="no-case"]').addClass('active-variant');
                $('button[data-variant-name="with-case"]').removeClass('active-variant');
                if (window.theme.isSaleActive || window.theme.preShopActive) {
                    //updateLabel();

                    if ($('body').hasClass('pdp-variants-opened') && !$('.show-variant-options').hasClass('has-options-opened')) {
                        $('body').removeClass('pdp-variants-opened');
                    }
                    
                }

                if ($('body').hasClass('landed-on-preshop') && window.theme.preShopActive) {
                    $addToCart.attr('data-line-property-hidden-frame', '');
                    if ($('body').hasClass('pdp-variants-opened') && !$('.show-variant-options').hasClass('has-options-opened')) {
                        $('body').removeClass('pdp-variants-opened');
                    }
                }
            }

            updateSliderFilter();
        }

        // Apply Body Classes based on Pre-Shop Logic
        if (product.sale.isPreShop === 'true' && window.theme.preShopActive) {
            $('body').addClass('template-pdp-pre-shop')
                .addClass('sale-item')
                .removeClass('final-sale-pdp')
                .removeClass('final-sale-item')
                .removeClass('exchange-only-pdp');
        }

        if (
            product.sale.isPreShop === 'true' &&
            window.theme.preShopActive &&
            $('body').hasClass('landed-on-preshop')
        ) {
            ////console.log'Is preshop: true / Variable is: ' + product.sale.isPreShop);
            $('body').addClass('template-pdp-pre-shop');
            if (product.sale.isOnlineOnly === 'true') {
                $('.pdp-collection-title').html(preShopTagOnlineOnly);
            } else {
                $('.pdp-collection-title').html(preShopTag);
            }
        } else {
            $('body').removeClass('template-pdp-pre-shop');
        }
        //console.log('Product type: ' + product.sale.sale_type);
 
            if (window.theme.isSaleActive) {
                ////console.logproduct.sale.sale_type)
                //checkItemType();
                //console.log('Inventory quantity: ' + product.inventoryQuantity);
                //console.log('Is extra20 item: ' + extra20);
                if (product.inventoryQuantity > 0 && product.sale.extra20 && window.theme.currencyISO === 'USD') {
                    //console.log('Extra 20 item');

                    $('.pdp-ticker-extra').css('display', 'block');
                    $('body').addClass('show-low-stock-ticker');

                    if ($('.sale-ticker-wrapper .ticker-type-extra-20').length == 0) {
                        $('.sale-ticker-wrapper').empty();
                        $('.hidden-tickers .ticker-type-extra-20')
                            .clone()
                            .appendTo('.sale-ticker-wrapper');
                    }
                } else if (
                    product.inventoryQuantity > 0 &&
                    product.inventoryQuantity < 76 &&
                    product.sale.onSale === 'true'
                ) {
                    //console.log('Low stock sale item');
                    $('.pdp-ticker-extra').css('display', 'block');
                    $('body').addClass('show-low-stock-ticker');

                    if ($('.sale-ticker-wrapper .ticker-type-going-fast').length == 0) {
                        $('.sale-ticker-wrapper').empty();
                        $('.hidden-tickers .ticker-type-going-fast')
                            .clone()
                            .appendTo('.sale-ticker-wrapper');
                    }
                } else if (product.inventoryQuantity < 1 && product.sale.onSale === 'true') {
                    //console.log('Sale item and sold out');

                    $('.pdp-ticker-extra').css('display', 'block');
                    $('body').addClass('show-low-stock-ticker');

                    if ($('.sale-ticker-wrapper .ticker-type-going-fast').length) {
                        $('.sale-ticker-wrapper').empty();
                        $('.hidden-tickers .ticker-type-sold-out')
                            .clone()
                            .appendTo('.sale-ticker-wrapper');
                    } else {
                        if ($('.sale-ticker-wrapper .ticker-type-sold-out').length == 0) {
                            $('.sale-ticker-wrapper').empty();
                            $('.hidden-tickers .ticker-type-sold-out')
                                .clone()
                                .appendTo('.sale-ticker-wrapper');
                        }
                    }
                } else {
                    // console.log('No ticker found');
                    $('.sale-ticker-wrapper').empty();
                }
            } else if (
                window.theme.preShopActive &&
                $('body').hasClass('template-pdp-pre-shop') &&
                $('body').hasClass('landed-on-preshop')
            ) {
                let pdpSaleItemTag = $this.data('product-sale-tag');
                $('.pdp-message').removeClass('show-pdp-message');
                $('.pdp-message[data-message-tag="' + pdpSaleItemTag + '"').addClass(
                    'show-pdp-message',
                );
                setTimeout(function () {
                    //checkItemType();
                   // goToPreShopSlide();
                }, 100);

                if (product.inventoryQuantity > 0 && product.inventoryQuantity < 76) {
                    $('.pdp-ticker-extra').css('display', 'block');
                    $('body').addClass('show-low-stock-ticker');

                    if (!$('.sale-ticker-wrapper .ticker-type-going-fast').length) {
                        $('.sale-ticker-wrapper').empty();
                        $('.hidden-tickers .ticker-type-going-fast')
                            .clone()
                            .appendTo('.sale-ticker-wrapper');

                        // console.log('No ticker found');
                    }
                } else {
                    $('.sale-ticker-wrapper').empty();
                }

                //console.log('This true');
            } else if (
                window.theme.preShopActive &&
                product.sale.isPreShop === 'true' &&
                $('body').hasClass('landed-on-preshop')
            ) {
                $('body').addClass('template-pdp-pre-shop');
                setTimeout(function () {
                    //checkItemType();
                   // goToPreShopSlide();
                }, 100);

                if (product.inventoryQuantity > 0 && product.inventoryQuantity < 76) {
                    $('.pdp-ticker-extra').css('display', 'block');
                    $('body').addClass('show-low-stock-ticker');

                    if ($('.sale-ticker-wrapper .ticker-type-going-fast').length == 0) {
                        $('.sale-ticker-wrapper').empty();
                        $('.hidden-tickers .ticker-type-going-fast')
                            .clone()
                            .appendTo('.sale-ticker-wrapper');
                    }
                } else {
                    $('.sale-ticker-wrapper').empty();
                }
            } else {
                // console.log('Standard item');
                $('body')
                    .removeClass('template-pdp-pre-shop')
                    .removeClass('final-sale-pdp')
                    .removeClass('final-sale-item')
                    .removeClass('exchange-only-pdp');
                $('.pdp-message').removeClass('show-pdp-message');
                $('#frameCase').prop('checked', false);
                if ($('body').hasClass('landed-on-preshop')) {
                    //goToSCSlide();
                    $('.sale-ticker-wrapper').empty();
                }
                $addToCart.attr('data-include-frame-case', false);
                $('#buyItNowBtn').attr('data-include-frame-case', false);
            }

        
            checkItemType();

  
        /*
            This prevents the custom product line property metafield from being applied to data-line-proeprty-lens when Special Line Property (Product Line Property Metafield) is `finalSaleFrameWithCase` 
        */
        if (product.specialLineProperty && !product.specialLineProperty.includes(finalSaleFrameWithCase)) {
            $addToCart.attr('data-line-property-lens', product.specialLineProperty);
            $('#buyItNowBtn').attr('data-line-property-lens', product.specialLineProperty);
        }

        if ($('html, body').scrollTop() > 20 && $(window).width() > 990) {
            $('html, body').scrollTop(110);
        }
        if (product.sale.addGWP === 'true') {
            $('#buyItNowBtn').addClass('include-gwp');
        } else {
            $('#buyItNowBtn').removeClass('include-gwp');
        }
        ////console.logproduct.familyName);
        $('.pdp-family-title').text(product.familyName);
        $('body').addClass('pdp-collection-hovered');
        if ($this.hasClass('pdp-swatch-sold-out')) {
            //console.log("Sold Out");
            $('body').addClass('showing-waitlist-bar');
            $('.product-back-in-stock').addClass('active').attr('aria-hidden', false);
            $('.product-form, .product-variants-wrapper').attr('aria-hidden', true);
            $('.product-form button, .product-form div[role=button]').attr('tabindex', '-1');
            $('.product-back-in-stock input, .product-back-in-stock button').attr(
                'tabindex',
                '0',
            );
            $('#buyItNow, .afterpay-link').attr('aria-hidden', true).attr('tabindex', '-1');
            $('.has-options-opened').removeClass('has-options-opened');
            $('.show-variants').removeClass('show-variants');
            $('body').removeClass('pdp-variants-opened');
            checkSoldOutAndAdditionalColorways(showSecondProductRow, showThirdProductRow);
            $('.product-soldout-label').addClass('show-sold-out-label');
            $addToCart.css('display', 'none');
            $AddToCartText.text('OUT OF STOCK');
            $addToCart.addClass('product-is-sold-out');
            if ($('.product-shop-back-in-stock-fields').hasClass('product-waitlisted')) {
                $('.product-shop-back-in-stock-fields').removeClass('product-waitlisted');
                $('.product-shop-back-in-stock-submit').text('Notify Me');
            }
            hideAllOptions();
            if (
                $('.normal-option-selectors .lens--readers--options').hasClass(
                    'readers--show',
                ) &&
                $addToCart.hasClass('power-not-selected')
            ) {
                $('.lens--readers--options').each(function () {
                    $(this).removeClass('readers--show').attr('aria-hidden', true);
                });
                $addToCart.removeClass('power-not-selected');
                setTimeout(function () {
                    $('button.active-variant[data-variant-name="Blue Light Readers"]').each(
                        function () {
                            $(this).removeClass('active-variant');
                        },
                    );
                }, 100);
            }

            if (product.hideWaitlist === 'true') {
                $('.waitlist-soldout').addClass('hide-back-in-stock');
            } else {
                $('.waitlist-soldout').removeClass('hide-back-in-stock');
            }
        } else {
            //console.log("In stock");
            $('.product-soldout-label').removeClass('show-sold-out-label');
            $('body').removeClass('showing-waitlist-bar');
            checkSoldOutAndAdditionalColorways(showSecondProductRow, showThirdProductRow);
            $('.product-back-in-stock').removeClass('active').attr('aria-hidden', true);
            $('.product-form, .product-variants-wrapper').attr('aria-hidden', false);
            $('#buyItNow').attr('aria-hidden', false).attr('tabindex', '0');
            $('.product-form button, .product-form div[role=button], .afterpay-link').attr(
                'tabindex',
                '0',
            );
            $('.product-back-in-stock input, .product-back-in-stock button').attr(
                'tabindex',
                '-1',
            );
            $addToCart.css('display', 'block');
            $addToCart.prop('disabled', false);
            if (product.sale.extra20) {
                if (window.theme.currencyISO === 'USD') {
                    $AddToCartText.text('Add to Bag for +20% Off');
                } else {
                    $AddToCartText.text('Add to Bag');
                }
            } else {
                if (
                    $('button[data-variant-name="Blue Light Readers"]').hasClass(
                        'active-variant',
                    ) &&
                    $('button[data-variant-name="Blue Light Readers"]').hasClass(
                        'has-readers-selected',
                    )
                ) {
                    let selectedReaderValue = $('.selected-readers').attr('data-power-value');

                    $AddToCartText.html('Add with Lens <em>' + selectedReaderValue + '</em>');
                    if (
                        product.productisPreOrder === 'false' ||
                        product.productisPreOrder == false
                    ) {
                        $addToCart.removeClass('pre-order-atb');
                        $('.pdp-preorder-date').html('');
                        $addToCart.attr('data-line-property-Pre-Order', '')
                        //console.log('Product not pre-order');
                    }
                } else if (
                    $('button[data-variant-name="Blue Light"]').hasClass('active-variant')
                ) {
                    $AddToCartText.text('Add With Lens');
                    if (
                        product.productisPreOrder === 'false' ||
                        product.productisPreOrder == false
                    ) {
                        $addToCart.removeClass('pre-order-atb');
                        $('.pdp-preorder-date').html('');
                        $addToCart.attr('data-line-property-Pre-Order', '')
                        //console.log('Product not pre-order');
                    }
                    //console.log('This triggered 3');
                } else {
                    if (
                        product.productisPreOrder === 'true' ||
                        product.productisPreOrder === true
                    ) {
                        $('.pdp-preorder-date').html(product.preOrderDate);
                        $addToCart.addClass('pre-order-atb');
                        if (product.handle === 'galvan-silver-chroma-crystal' || product.handle === 'galvan-12k-chroma-iberia') {
                            $('.AddToCart-text').text('Reserve Yours Now');
                        } 
                        /* Product Family Name - HEIDI */
                        else if (product.familyName === "HEIDI") {
                            // Apply code here for HEIDI family
                        }
                        else {
                            $('.AddToCart-text').text('Pre-Order');
                        }
                        $addToCart.attr('data-line-property-Pre-Order', product.preOrderLineProperty)
                        //console.log('Product is pre-order');
                    } else {
                        if (!$('.lens--readers--options').hasClass('readers--show')) {
                            if ($('.lens--readers--options').hasClass('readers--show')) {
                                $('.lens--readers--options').each(function () {
                                    $(this).removeClass('readers--show');
                                });
                                $(
                                    'button.active-variant[data-variant-name="Blue Light Readers"]',
                                ).each(function () {
                                    $(this).removeClass('active-variant');
                                });
                            }
                            if (!product.sale.extra20) {
                                $AddToCartText.text('Add to Bag');
                            } else {
                                if (window.theme.currencyISO === 'USD') {
                                    $AddToCartText.text('Add to Bag for +20% Off');
                                } else {
                                    $AddToCartText.text('Add to Bag');
                                
                                }
                            }
                            //console.log('This triggered');
                        } else if (
                            ($('.lens--readers--options').hasClass('readers--show') &&
                                product.adminProductType === 'KIT') ||
                            ($('.lens--readers--options').hasClass('readers--show') &&
                                product.adminProductType === 'SUNGLASSES')
                        ) {
                            $addToCart.removeClass('power-not-selected');
                            $('.lens--readers--options').each(function () {
                                $(this).removeClass('readers--show').attr('aria-hidden', true);
                            });
                            $('body').removeClass('optical-addon-selected');
                            $(
                                'button.active-variant[data-variant-name="Blue Light Readers"]',
                            ).each(function () {
                                $(this).removeClass('active-variant');
                            });
                        }
                        $('.pdp-preorder-date').html('');
                        $addToCart.attr('data-line-property-Pre-Order', '');
                        $addToCart.removeClass('pre-order-atb');
                        //console.log('This triggered 2');
                        if (!$addToCart.hasClass('power-not-selected')) {
                            if (product.inventoryQuantity > 0 && isSpecialFrame) {
                        
                                $AddToCartText.html(
                                    'ADD TO BAG <span class="dot"></span> Only <span class="tick-tock-quantity">' +
                                        product.inventoryQuantity +
                                        '</span> left',
                                )
            
                            } else {
                                $AddToCartText.text('Add to Bag');
                            }
                        }
                    }
                }
                if (product.productisPreOrder === 'true' || product.productisPreOrder === true) {
                    $('.pdp-preorder-date').html(product.preOrderDate);
                    $addToCart.addClass('pre-order-atb');
                    $addToCart.attr('data-line-property-Pre-Order', product.preOrderLineProperty);
                    if ($addToCart.hasClass('power-not-selected')) {
                        $AddToCartText.text('Select Power');
                    }
                    //console.log('Product is pre-order');
                }
            }
            $addToCart.removeClass('product-is-sold-out');
            if ($('.product-shop-back-in-stock-fields').hasClass('product-waitlisted')) {
                $('.product-shop-back-in-stock-fields').removeClass('product-waitlisted');
                $('.product-shop-back-in-stock-submit').text('Email Me');
            }
        }
        $addToCart.attr('data-variant-id', product.variantID);
        $addToCart.attr('data-product-id', product.id);
        $('#buyItNowBtn').attr('value', product.variantID);
        if (product.adminProductType === 'OPTICAL') {
            $('.accordion-wrapper-lens-details').css('display', 'none');
        } else {
            if ($('.accordion-wrapper-lens-details').css('display') === 'none') {
                $('.accordion-wrapper-lens-details').css('display', 'block');
            }
        }
        if ($('.family-product-contents[data-product-handle="' + product.handle + '"]').length) {
            $frameTitle.html(product.title);
            $keyFeatures.html(product.accordions.keyFeatures);
            updateKeyFeaturesCarousels();
            $constructionAccordionContent.html(product.accordions.constructionContent);
            $lensAccordionContent.html(product.accordions.lensContent);
            $colorAccordionContent.html(product.accordions.colorContent);
            $warrantyAccordionContent.html(product.accordions.warrantyContent);
            checkEachAccordionLi();
            setTimeout(function () {
                updateAccordionHeight();
            }, 200);
            updateProductImages(
                product.images,
                $productMainImagesContainer,
                product.handle,
                showSecondProductRow
            );
            $('body').removeClass('pdp-tab-opened');
            if (
                (product.adminProductType === 'KIT' && $('.all-options-available').length) ||
                (product.adminProductType === 'SUNGLASSES' &&
                    $('.all-options-available').length) ||
                (product.adminProductType === 'KIT' && $('.optical-options-list').length) ||
                (product.adminProductType === 'SUNGLASSES' && $('.optical-options-list').length)
            ) {
                //console.log('kit clicked');
                if (
                    product.adminProductType === 'KIT' ||
                    product.adminProductType === 'SUNGLASSES'
                ) {
                    if (
                        $(
                            '.family-product-contents-wrapper button[data-variant-name="Blue Light"].active-variant',
                        ).length
                    ) {
                        $('button[data-variant-name="Blue Light"].active-variant').each(
                            function () {
                                $(this).removeClass('active-variant');
                            },
                        );
                        $AddToCartText.text('Add to Bag');
                    }
                    if (
                        $('.normal-option-selectors .lens--readers--options').hasClass(
                            'readers--show',
                        )
                    ) {
                        $('.lens--readers--options').each(function () {
                            $(this).removeClass('readers--show').attr('aria-hidden', true);
                        });
                        $('button.active-variant[data-variant-name="Blue Light Readers"]').each(
                            function () {
                                $(this).removeClass('active-variant');
                            },
                        );
                        //$('body').removeClass('pdp-variants-opened');
                        if ($('.show-variant-options.has-options-opened').length) {
                            //console.log("has options opened");
                            //$('.show-variant-options[data-option-name="lens"]').click();
                        }
                    }
                    if ($('button[data-variant-name="Blue Light"] em').length) {
                        //$('button[data-variant-name="Blue Light"] em').remove();
                    }

                    if (
                        $('button[data-variant-name="Blue Light Readers"]').hasClass(
                            'has-readers-selected',
                        )
                    ) {
                        $('.selected-readers')[0].click();
                    }
                    if (
                        $(
                            '.family-product-contents-wrapper button[data-variant-name="Blue Light"].active-variant',
                        ).length
                    ) {
                        //console.log('Found active blue light variant');
                        $(
                            '.family-product-contents-wrapper button[data-variant-name="Blue Light"].active-variant',
                        ).click();
                        if ($('.show-variant-options.has-options-opened').length) {
                            //$(".show-variant-options.has-options-opened").click();
                        }
                    }
                    $('body').removeClass('readers-selected');
                    $('body').removeClass('variant-option-selected');
                    $('body').removeClass('optical-addon-selected');
                    //$("body").removeClass("pdp-variants-opened");
                    if (!product.sale.extra20) {
                        $AddToCartText.text('Add to Bag');
                    } else {
                        if (window.theme.currencyISO === 'USD') {
                            $AddToCartText.text('Add to Bag for +20% Off');
                        } else {
                            $AddToCartText.text('Add to Bag');
                        }
                    }
                }
            }
            if ($('button[data-variant-name="Blue Light Readers"]').hasClass('active-variant')) {
                //console.log('Blue light readers selected');
                let currentPrice = product.fullPrice;
                let blueLightAddOn = $(
                    '.frame-available-options button[data-variant-name="Blue Light Readers"]',
                ).attr('data-variant-add-on-price');

                if (product.sale.sale_type === 'FINAL SALE') {
                    if ($('.variant-hard-case').hasClass('variant-selected') && !window.theme.preShopActive) {
                        $('.product-price-main-price').text(product.add_ons_pricing.with_case_and_readers);
                        //console.log('Final sale with readers and case', product.add_ons_pricing.with_case_and_readers);
                    } else {
                        //console.log('Final sale with readers');
                        $('.product-price-main-price').text(product.add_ons_pricing.with_readers);
                    }
                } else {
                    //console.log('Not final sale with readers');
                    $('.product-price-main-price').text(product.add_ons_pricing.with_readers);
                }
                // console.log('Price with readers:' + $frameAddOnsPrice);
                if (product.comparePrice != 'false') {
                    if ($('.product-price-compare-at').length) {
                        $('.product-price-compare-at').text(product.comparePrice);
                    } else {
                        $('.pdp-header .pdp-price').prepend(
                            '<span class="product-price product-price-compare-at">' +
                            product.comparePrice +
                            '</span>',
                        );
                    }
                } else {
                    $('.product-price-compare-at').remove();
                    //console.log('Final sale without case', product.add_ons_pricing.with_readers);
                }
            } else if ($('button[data-variant-name="Blue Light"]').hasClass('active-variant')) {
                //console.log('Blue light selected');
                let currentPrice = product.fullPrice;
                let blueLightAddOn = $(
                    '.frame-available-options button[data-variant-name="Blue Light"]',
                ).attr('data-variant-add-on-price');

                if (product.sale.sale_type === 'FINAL SALE') {
                    if ($('.variant-hard-case').hasClass('variant-selected') && !window.theme.preShopActive) {
                        $('.product-price-main-price').text(product.add_ons_pricing.with_case_and_blue_light);
                    } else {
                        $('.product-price-main-price').text(product.add_ons_pricing.with_blue_light);
                    }
                } else {
                    $('.product-price-main-price').text(product.add_ons_pricing.with_blue_light);
                }
                // console.log('Price with readers:' + $frameAddOnsPrice);
                if (product.comparePrice != 'false') {
                    if ($('.product-price-compare-at').length) {
                        $('.product-price-compare-at').text(product.comparePrice);
                    } else {
                        $('.pdp-header .pdp-price').prepend(
                            '<span class="product-price product-price-compare-at">' +
                            product.comparePrice +
                            '</span>',
                        );
                    }
                } else {
                    
                    $('.product-price-compare-at').remove();
                }
                //console.log('Price with bl:' + $frameAddOnsPrice);
            } else {

                
                // console.log('Price with readers:' + $frameAddOnsPrice);
                if (product.comparePrice != 'false') {
                    if ($('.product-price-compare-at').length) {
                        $('.product-price-compare-at').text(product.comparePrice);
                    } else {
                        $('.pdp-header .pdp-price').prepend(
                            '<span class="product-price product-price-compare-at">' +
                            product.comparePrice +
                            '</span>',
                        );
                    }
                    if (product.sale.sale_type === 'FINAL SALE' && product.familyName != 'FRAME CASE') {
                        if ($('.variant-hard-case').hasClass('variant-selected') && !window.theme.preShopActive) {
                            $('.product-price-main-price').text(product.add_ons_pricing.with_case);
                        } else {
                            $('.product-price-main-price').text(product.fullPrice);
                        }
                    } else {
                        $('.product-price-main-price').text(product.fullPrice);
                    }
                } else {
                    
                    $('.product-price-compare-at').remove();
                    
                    if (product.sale.sale_type === 'FINAL SALE' && product.familyName != 'FRAME CASE') {

                        if ($('.variant-hard-case').hasClass('variant-selected') && !window.theme.preShopActive) {
                            $('.product-price-main-price').text(product.add_ons_pricing.with_case);
                        } else {
                            $('.product-price-main-price').text(product.fullPrice);
                        }

                    } else {

                        $('.product-price-main-price').text(product.fullPrice);

                    }
                }
            }
            $productForm.val(product.variantID);
            $breadcrumbTitle.html(product.title);
            $frameMainDescription.html(product.frameMainDescription);
            $frameDescription.html(product.frameDetailsDescription);
            let market_prefix_2 = window.theme.marketPrefix;
            if (market_prefix_2 === 'main') {
                var newURI = '/products/' + product.handle;
                if (currentCollectionHandle) {
                    newURI = '/collections/' + currentCollectionHandle + newURI;
                }
            } else {
                var newURI = market_prefix_2 + '/products/' + product.handle;
                if (currentCollectionHandle) {
                    newURI = newURI.replace(market_prefix_2, '');
                    newURI =
                        market_prefix_2 + '/collections/' + currentCollectionHandle + newURI;
                }
            }
            window.history.replaceState({}, document.title, newURI);

            setTimeout(function () {
                if ($(window).width() > 990) {
                    $('.pdp-main-carousel .product__media').each(function () {
                        var $this = $(this); // Get a jQuery object for the current image
                        $this.zoom({
                            url: $this.attr('data-image-zoom'),
                            on: 'click',
                            onZoomIn: function () {
                                $this.parent().addClass('zoom-active');
                            },
                            onZoomOut: function () {
                                $this.parent().removeClass('zoom-active');
                            },
                        });
                    });
                    $('.pdp-main-carousel .product__media').on('click', function () {
                        var $this = $(this); // Get a jQuery object for the current image
                        // First destroy zoom on all images except the one being clicked
                        $('.pdp-main-carousel .product__media')
                            .not($this)
                            .trigger('zoom.destroy');
                        // Then reinitialize zoom on all images
                        $('.pdp-main-carousel .product__media')
                            .not($this)
                            .each(function () {
                                var $that = $(this); // Get a jQuery object for the current image
                                $that.zoom({
                                    url: $that.attr('data-image-zoom'),
                                    on: 'click',
                                    onZoomIn: function () {
                                        $that.parent().addClass('zoom-active');
                                    },
                                    onZoomOut: function () {
                                        $that.parent().removeClass('zoom-active');
                                    },
                                });
                            });
                    });
                }
            }, 100);

            $frameModelInfo.html(product.modelInfo);
            setTimeout(function () {
                updateAccordionModelCarousels();
            }, 100);

            if (
                !$('body').hasClass('template-summer-tote-2023') &&
                !$('body').hasClass('template-krewe-gift-card') &&
                !$('body').hasClass('pdp-frame-case')
                
            ) {
                //console.log('Not tote or gift card or case');
                
                openDefaultAccordion();
            }
            $('.pdp--availability-wrapper').scrollLeft(0);
            if (!$('.product').hasClass('colorway-specific-pdp')) {
                ////console.log'Not colorway specific PDP');
                if (product.sale.onSale === 'true' && window.theme.isSaleActive) {
                    $('body').addClass('sale-item');
                    //console.log'Is sale period: ' + product.sale.allSalePeriod);
                    if (product.sale.allSalePeriod === 'true') {
                        $('.pdp-collection-title').html(allSaleTag);
                    } else {
                        ////console.log'Sale item: true / Variable is:' + product.sale.onSale);
                        if (product.sale.isPreShop === 'true') {
                            ////console.log'Is preshop: true / Variable is: ' + product.sale.isPreShop);
                            $('body').addClass('template-pdp-pre-shop');
                            if (product.sale.isOnlineOnly === 'true') {
                                $('.pdp-collection-title').html(preShopTagOnlineOnly);
                            } else {
                                $('.pdp-collection-title').html(preShopTag);
                            }
                        } else {
                            //$("body").removeClass("template-pdp-pre-shop");
                            ////console.log'Is preshop: false / Variable is: ' + product.sale.isPreShop);
                            ////console.log'Sale item: ' + product.sale.onSale);
                            if (product.sale.isSOTD === 'true') {
                                $('.pdp-collection-title').html(sotdTag);
                            } else {
                                if (product.sale.isOnlineOnly === 'true') {
                                    $('.pdp-collection-title').html(onlineOnlyTag);
                                    ////console.log'Online only: ' + product.sale.onSale);
                                } else {
                                    $('.pdp-collection-title').empty();
                                    ////console.log'No online only');
                                }
                            }
                        }
                    }
                } else {
                    //$("body").removeClass("sale-item");
                    //$("body").removeClass("template-pdp-pre-shop");
                    ////console.log'Sale item: false / Variable is:' + product.sale.onSale);
                    ////console.log'Is not sale item: ' + product.sale.onSale);
                    if (product.hasSpecialBodyClass) {
                        //console.log'Body class: ' + product.hasSpecialBodyClass);
                        if (product.hasSpecialBodyClass === 'template-pdp-amore') {
                            $('body').addClass(product.hasSpecialBodyClass);
                        }
                    } else {
                        //console.log'No body class');
                        $('.pdp-collection-title .mg-gif--title').remove();
                        $addToCart.removeClass('colorway-pdp--atb-doubloon');
                        $('body').removeClass('template-pdp-amore');
                    }
                }
            }
        }

        if (product.hasSpecialBodyClass === 'false') {
            // console.log('Is not special body class');
            $('body').removeClass('template-pdp-revelry');
            $('body').removeClass('template-pdp-amore');
        } else {
            $('body').removeClass('template-pdp-revelry');
            $('body').removeClass('template-pdp-amore');
            $('body').addClass(product.hasSpecialBodyClass);
        }

        if (product.colorwayPDP === 'true') {
            //console.log('Colorway PDP');
            recheckReviews(product.id);
        }

        if (
            $('.family-collection-breadcrumb').length &&
            $('.product').attr('data-family-collection-handle') != product.familyHandle
        ) {
            $('.family-collection-breadcrumb').text(product.familyName);
            $('.family-collection-breadcrumb').attr(
                'href',
                '/collections/' + product.familyHandle,
            );
        }

        if (
            $('.product').attr('data-family-collection-handle') != product.familyHandle &&
            $('body').hasClass('template-is-elton') &&
            product.colorwayPDP != 'true'
        ) {
           // console.log('Colorway PDP');
            recheckReviews(product.id);
        }

        if ($(window).width() > 990) {
            $('.desktop-product-shop-images-container .product-shop-image-wrapper').trigger(
                'zoom.destroy',
            );
        }

        $addToCart.attr('data-gtm-label', product.familyName.trim() + ' | ' + product.title.trim());

        setTimeout(function () {
            if (
                $('body').hasClass('template-product-family-rampart-fold') &&
                $(window).width() > 990
            ) {
                var miniCasePosition = $('.pdp-main-carousel #mini-case').offset().top - 100;
                var gifPosition = $('.pdp-main-carousel #mini-case').offset().top - 100;
                $(document).on('click', 'a[href="#mini-case"]', function (e) {
                    e.preventDefault();
                    $('html,body').animate(
                        {
                            scrollTop: miniCasePosition,
                        },
                        400,
                    );
                });
                $(document).on('click', '.rampart-gif a', function (e) {
                    e.preventDefault();
                    $('html,body').animate(
                        {
                            scrollTop: gifPosition,
                        },
                        400,
                    );
                });
            }

            // Klaviyo tracking
            var item = {
                "Name": product.fullName,
                "ProductID": parseInt(product.id),
                "SKU": product.sku,
                "ImageURL": product.featuredImage,
                "URL": product.url,
                "Brand": "KREWE",
                "Price": product.fullPrice,
                "CompareAtPrice": product.comparePrice
            };
            klaviyo.push(["track", "Viewed Product", item]);


            //console.log(item);
            if (!deviceIsMobile.matches) {
                autoplayPLPVideos();
            }
        }, 400);
        if (deviceIsMobile.matches) {
            clearInterval(nudgeInterval);
            nudgeInterval = setInterval(nudgeProductInfo, 8000);
        }

        
        removePlayerControls();

        if (product.addToBagColors.subtitle !== 'false') {
            
            if (product.addToBagColors.subtitle_inventory_based) {
                if ($('.product-shop-inventory-notice.active.active-gwp').length && product.addToBagColors.subtitle_quantity !== 'false') {
                    $('.product-shop-inventory-notice').html('GOING FAST ' + product.addToBagColors.subtitle_quantity + ' left');
                }
                if (product.addToBagColors.subtitle_quantity === 'false' && product.addToBagColors.subtitle_inventory_based === 'true') {
                    return;

                    console.log('subtitle_quantity is false');
                }
            } else if (!$('.custom-subtitle').length) {
                $addToCart.addClass('custom-subtitle-atb');
                $addToCart.append('<span class="custom-subtitle">' + product.addToBagColors.subtitle + '</span>');
            } else {
                $addToCart.addClass('custom-subtitle-atb');
                $('.custom-subtitle').text(product.addToBagColors.subtitle);
            }
           
            
            // Check if subtitle_quantity is not false and add the class
            if (product.addToBagColors.subtitle_quantity !== false) {
                $addToCart.find('.custom-subtitle').addClass('atb-inventory');
            }
        } else {
            $addToCart.find('.custom-subtitle').text('');
            $addToCart.removeClass('custom-subtitle-atb');
        }
       
        if ($('.collection-description a').length) {
            addCrossSellingLinksTracking();
        }
        
        // $('.blue-lens-input').prop('checked', false);
        // $('.readers-lens-input').prop('checked', false);

        // FIX: FINAL SALE + ADD FRAME TO CART
        // EXCLUDE PDP FRAME CASE & TRAVEL KIT 
        if (product.sale.sale_type === "FINAL SALE" && (product.familyName !== "FRAME CASE" && product.familyName !== "TRAVEL KIT")) {
            console.log('****** TEST', product);
            $addToCart.attr('data-include-frame-case', true);
        }
    }
    if (deviceIsMobile.matches) {
        loadHoveredElements();
        $('.pdp-main-carousel .model-label-trigger').each(function () {
            if ($(this).modelIsInViewport()) {
                $('.model-face-shape-image-label').text($(this).text());
            }
        });

        $('#mediaGallery .product__media-item:first-of-type .pdp-ticker-extra').insertAfter(
            '.pdp-breadcrumbs',
        );
    } else {
        familyItemHover = setTimeout(function () {
            loadHoveredElements();
        }, 400);
    }
});
$(document).on('mouseleave', '.pdp-family-swatch-product button', function () {
    clearTimeout(familyItemHover);
});

function recheckReviews(productID) {
    $('.yotpo-widget-instance').attr('data-yotpo-product-id', productID);
    if (typeof yotpoWidgetsContainer != 'undefined') {
        yotpoWidgetsContainer.initWidgets();

        setTimeout(function () {
            yotpoReviewsFormatting();
        }, 1000);
    }
}

if ($(window).width() > 990) {
    $('.pdp-main-carousel .product__media').each(function () {
        var $this = $(this); // Get a jQuery object for the current image
        $this.zoom({
            url: $this.attr('data-image-zoom'),
            on: 'click',
            onZoomIn: function () {
                $this.parent().addClass('zoom-active');
            },
            onZoomOut: function () {
                $this.parent().removeClass('zoom-active');
            },
        });
    });
    $('.pdp-main-carousel .product__media').on('click', function () {
        var $this = $(this); // Get a jQuery object for the current image
        // First destroy zoom on all images except the one being clicked
        $('.pdp-main-carousel .product__media').not($this).trigger('zoom.destroy');
        // Then reinitialize zoom on all images
        $('.pdp-main-carousel .product__media')
            .not($this)
            .each(function () {
                var $that = $(this); // Get a jQuery object for the current image
                $that.zoom({
                    url: $that.attr('data-image-zoom'),
                    on: 'click',
                    onZoomIn: function () {
                        $that.parent().addClass('zoom-active');
                    },
                    onZoomOut: function () {
                        $that.parent().removeClass('zoom-active');
                    },
                });
            });
    });
}

if (window.theme.isSaleActive || window.theme.preShopActive) {
    function updateLabel() {
        const frameCaseCheckbox = $('#frameCase');
        const frameCaseLabel = $('label[for="frameCase"] .text-to-update');
        const frameCaseLabelPrice = $('label[for="frameCase"] .frame-case-upsell-price');
        const popupId = $('.final--cta').data('popup-id');

        const checkedPrice = $('.variant-selected .variant-price-main').text();
        const softCasePrice = $('.variant-soft-case .variant-price-main').text();

        if (frameCaseCheckbox.prop('checked')) {
            if (window.theme.isSaleActive) {
                frameCaseLabel.html(
                    `Uncheck frame case to save `,
                );
                
                    //frameCaseLabelPrice.text(checkedPrice);
                

                if ($('.show-variant-options.has-options-opened').length > 0 && deviceIsMobile.matches) {
                    $('.show-variant-options.has-options-opened').click();
                }
            } else {

                frameCaseLabel.html(
                    `Uncheck frame case`,
                );

            }

            if (deviceIsMobile.matches) {
                hideAllOptions()
            }

        } else {
            if (window.theme.isSaleActive) {
                frameCaseLabel.html(
                    `Add frame case for`,
                );
                //frameCaseLabelPrice.text(softCasePrice);
                setTimeout(function () {
                $('.variant-soft-case').removeClass('variant-selected');
                $('.variant-hard-case').addClass('variant-selected');
                },400);

                if ($('.show-variant-options.has-options-opened').length > 0 && deviceIsMobile.matches) {
                    $('.show-variant-options.has-options-opened').click();
                }
            } else {
                frameCaseLabel.html(
                    `Add frame case`,
                );
            }
        }
    }

    function updateCollapsedLabel() {
        const frameCaseCheckbox = $('#frameCase');
        const frameCaseLabel = $('label[for="frameCase"] .text-to-update');
        const frameCaseLabelPrice = $('label[for="frameCase"] .frame-case-upsell-price');
        const popupId = $('.final--cta').data('popup-id');

        if ($('.show-variant-options.has-options-opened').length > 0) {
            if (window.theme.isSaleActive) {
                
                if ($('button[data-variant-id="40160796180567"]').hasClass('variant-selected')) {
                    frameCaseLabel.html(
                        `Uncheck <span class="red-text">hard frame case</span> to save `,
                    );
                } else {
                    frameCaseLabel.html(
                        `Uncheck <span class="red-text">soft frame case</span> to save `,
                    );
                }
            } else {
                frameCaseLabel.html(
                    `Uncheck frame case`,
                );
            }
        } else {
 
                frameCaseLabel.html(
                    `Uncheck frame case to save `,
                );
               
            
        }
    }

    function updateCollapsedLabel2() {
        const frameCaseCheckbox = $('#frameCase');
        const frameCaseLabel = $('label[for="frameCase"] .text-to-update');
        const frameCaseLabelPrice = $('label[for="frameCase"] .frame-case-upsell-price');
        const popupId = $('.final--cta').data('popup-id');

        if ($('.show-variant-options.has-options-opened').length > 0) {
            if (window.theme.isSaleActive) {
                
                if ($('button[data-variant-id="40160796180567"]').hasClass('variant-selected')) {
                    frameCaseLabel.html(
                        `Uncheck frame case to save `,
                    );
                } else {
                    frameCaseLabel.html(
                        `Uncheck frame case to save `,
                    );
                }
            } else {
                frameCaseLabel.html(
                    `Uncheck frame case`,
                );
            }
        } else {
 
                frameCaseLabel.html(
                    `Uncheck frame case to save `,
                );
               
            
        }
    }

    // Add event listener
    $(document).on('click', '#frameCase', function () {
        //updateLabel();

        if (!$('body').hasClass('already-opened-tab')) {
            clearInterval(nudgeInterval);
            isFirstNudge = true;
            nudgeInterval = setInterval(nudgeProductInfo, 6000);
        }
        
    });
}

function addCrossSellingLinksTracking() {
    const crossSellingLinks = document.querySelectorAll(
        '.collection-description a'
    );
    crossSellingLinks.forEach((link) => {
        link.setAttribute('data-gtm-dynamic-click', 'true');
        link.setAttribute('data-gtm-category', 'Product Page');
        link.setAttribute('data-gtm-action', 'Cross-Selling Links');
        
        // Escape special characters in the link text content
        const escapedText = link.textContent
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        
        link.setAttribute('data-gtm-label', escapedText);
    });
}

var loadingAdditionalFamilies = false;
function checkSameDataProductHandle() {
    const divs = document.querySelectorAll('.family-product-contents');
    const productHandles = new Set();
    const duplicates = [];
    for (let i = 0; i < divs.length; i++) {
        const div = divs[i];
        const productHandle = div.getAttribute('data-product-handle');
        if (productHandles.has(productHandle)) {
            duplicates.push(div);
        } else {
            productHandles.add(productHandle);
        }
    }
    if (duplicates.length > 0) {
        //alert(`Duplicates found! Removing ${duplicates.length} duplicate(s).`);
        duplicates.forEach((div) => div.remove());
    }
}
function loadAdditionalProductFamilies() {
    if (!$('body').hasClass('additional-family-loaded')) {
        setTimeout(function () {
            let requestedHandles = []; // array to store requested handles
            $(
                '.family-product-contents .additional-family-variant:not(.unavailable-variant)',
            ).each(function () {
                //console.log("Checked buttons");
                let $this = $(this);
                let variantFamilyTitle = $this.attr('data-metafield-family-title');
                let variantFamilyHandle = $this.attr('data-metafield-family-handle');
                let firstSwatch = $(
                    '.pdp-family-products-swatch-bar-scroll .pdp-family-swatch:first-child button',
                );
                let firstSwatchFamilyName = firstSwatch.attr('data-product-family-name');
                if (variantFamilyHandle.indexOf('option') === -1) {
                    if (variantFamilyTitle != firstSwatchFamilyName) {
                        //console.log("Found additional family");
                        let familyCollectionURL =
                            market_prefix +
                            '/collections/' +
                            variantFamilyHandle +
                            '?view=family-pdp';
                        // Check if handle has been requested before
                        if (requestedHandles.includes(variantFamilyHandle)) {
                            // If it has, skip this iteration
                            return true; // equivalent to "continue" in a normal loop
                        } else {
                            // If it hasn't, add it to the list of requested handles
                            requestedHandles.push(variantFamilyHandle);
                        }
                        fetch(familyCollectionURL, { method: 'GET' })
                            .then((Result) => Result.text())
                            .then((familyProductContents) => {
                                $('.family-product-contents-wrapper').append(
                                    familyProductContents,
                                );
                                //console.log('loaded initial additional family products from: ' + variantFamilyHandle);
                                checkSameDataProductHandle();
                                $('body').addClass('additional-family-loaded');
                                let $openedOptionButton = $(
                                    '.sticky-option-selectors .has-options-opened',
                                ).attr('data-option-name');
                                let $openedOptionsList = $(
                                    '.sticky-option-selectors .show-variants',
                                );
                                let $selectedOpenedOptionVariant =
                                    $openedOptionsList.find('.active-variant');
                                let selectedOpenedOptionVariantName =
                                    $selectedOpenedOptionVariant.attr('data-variant-name');
                                $('.family-product-contents').each(function () {
                                    let $thisFamilyProduct = $(this);
                                    let familyProductHandle =
                                        $thisFamilyProduct.attr('data-product-handle');
                                    // Find out which variants are unavailable for the $selectedOpenedOptionVariantName (they'd have matching data-variant-name) and would have the class available variant
                                    let $familyProductMatchingSelectedVariant =
                                        $thisFamilyProduct.find(
                                            '.frame-variants button[data-variant-name="' +
                                                selectedOpenedOptionVariantName +
                                                '"]',
                                        );
                                    let $familyProductMatchingSelectedVariantOption =
                                        $familyProductMatchingSelectedVariant.parents('ul');
                                    // Check if the variant is available
                                    if (
                                        $familyProductMatchingSelectedVariant.hasClass(
                                            'available-variant',
                                        ) &&
                                        $familyProductMatchingSelectedVariantOption.find(
                                            '.available-variant',
                                        ).length > 1
                                    ) {
                                        $(
                                            '.pdp-family-swatch-product button[data-product-handle="' +
                                                familyProductHandle +
                                                '"]',
                                        ).addClass('selected-variant-available-in-colorway');
                                    } else {
                                        $(
                                            '.pdp-family-swatch-product button[data-product-handle="' +
                                                familyProductHandle +
                                                '"]',
                                        ).removeClass('selected-variant-available-in-colorway');
                                    }
                                    //console.log("Additional Products loaded");
                                });
                                ////console.log'Products loaded');
                            })
                            .catch((errorMsg) => {
                                console.log(errorMsg);
                            });
                    }
                }
            });
        }, 200);
    }
}
let market_prefix = window.theme.marketPrefix;
if (market_prefix === 'main') {
    market_prefix = '';
}
/// LOAD ADDITIONAL PRODUCT FAMILUES
window.addEventListener('DOMContentLoaded', (event) => {
    updateCarousels();
    if ($('.pdp-family-swatch-product').length > 1) {
        var familyCollectionHandle = $('.product').data('family-collection-handle');
        var familyCollectionURL =
            market_prefix + '/collections/' + familyCollectionHandle + '?view=family-pdp';
        ////console.log'Family collection URL: ' + familyCollectionURL);
        ////console.log'Family collection Handle: ' + familyCollectionHandle);
        fetch(familyCollectionURL, { method: 'GET' })
            .then((Result) => Result.text())
            .then((familyProductContents) => {
                $('.family-product-contents-wrapper').append(familyProductContents);
                //console.log('Products loaded');
                loadAdditionalProductFamilies();
            })
            .catch((errorMsg) => {
                console.log(errorMsg);
            });
        $('body').removeClass('body-hidden');
    }
});
$(document).on('click', '.show-variant-options[data-option-name="size"]', function () {
    $('.readers--show').removeClass('readers--show').attr('aria-hidden', 'true');
    if (!$('.readers--variant.selected-readers').length) {
        $('.readers-lens-input').prop('checked', false);
        $('.readers-li').removeClass('optical-option--selected');
    }
});
$(document).on('click', '.show-variant-options[data-option-name="lens"]', function () {
    if (!$('.readers--variant').length) {
        $('.readers--show').removeClass('readers--show').attr('aria-hidden', 'true');
        if (!$('.readers--variant.selected-readers').length) {
        }
    }
});
$(document).on('click', '.show-variant-options[data-option-name="case"]', function () {
    $('.readers--show').removeClass('readers--show').attr('aria-hidden', 'true');
    if (!$('.readers--variant.selected-readers').length) {
        $('.readers-lens-input').prop('checked', false);
        $('.readers-li').removeClass('optical-option--selected');
    }
});
/* +----------------------+
   |         ```          |
   +----------------------+
   Show/hide variant options
   +----------------------+
   |         ```          |
   +----------------------+ */
// On click show.hide vaiant options
document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.sticky-option-selectors .show-variant-options:not(.case-options-dropdown)');
    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            var optionName = button.getAttribute('data-option-name');
            var uls = document.querySelectorAll(
                '.sticky-option-selectors  ul[data-option-name="' + optionName + '"]',
            );
            var alreadyOpen = document.querySelector(
                '.sticky-option-selectors ul.show-variants',
            );
            var activeButton = document.querySelector('.has-options-opened');
            if (activeButton) {
                activeButton.classList.remove('has-options-opened');
            }
            if (alreadyOpen) {
                alreadyOpen.classList.remove('show-variants');
                if (alreadyOpen !== uls[0]) {
                    setTimeout(function () {
                        uls.forEach(function (ul) {
                            ul.classList.add('show-variants');
                        });
                    }, 10);
                    button.classList.add('has-options-opened');
                } else if (document.body.classList.contains('final-sale-item')) {
                    // For final sale items, keep pdp-variants-opened and activate case dropdown
                    $('.case-options-dropdown').addClass('has-options-opened');
                } else {
                    document.body.classList.remove('pdp-variants-opened');
                }
            } else {
                uls.forEach(function (ul) {
                    ul.classList.add('show-variants');
                });
                button.classList.add('has-options-opened');
                document.body.classList.add('pdp-variants-opened');
                if ($('body').hasClass('pdp-frame-case')) {
                    //$('.active-product-card .product__info-wrapper').css('transform', 'translateY(calc(100% - 216px))');
                } else {
                    //$('.active-product-card .product__info-wrapper').css('transform', 'translateY(calc(100% - 185px - 48px))');
                }
            }
            
            $('body').addClass('already-opened-tab');
        });
    });

    $('.case-options-dropdown').on('click', function () {
        let $this = $(this);
        if ($this.hasClass('has-options-opened')) {
            $('body').removeClass('pdp-variants-opened');
            $this.removeClass('has-options-opened');
            $('.show-variants').removeClass('show-variants');
        } else {
            $('body').addClass('pdp-variants-opened');
            $('.has-options-opened').removeClass('has-options-opened');
            $('.show-variants').removeClass('show-variants');
            $this.addClass('has-options-opened');
            $this.next('.variants-container').addClass('show-variants');
        }
    });
    //check if cross selling link is found
    if ($('.collection-description a').length) {
        addCrossSellingLinksTracking();
    }
});
/* +----------------------+
   |         ```          |
   +----------------------+
   Loading additional family products
   +----------------------+
   |         ```          |
   +----------------------+ */
$(document).on('click', '.show-variant-options:not(.show-optical-options)', function (index) {});
// Function to check if an element is in viewport
function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
let mensOnlyImages = false;
function checkIfMensOnlyImages() {
    if ($('body').hasClass('mens-images-only')) {
        mensOnlyImages = true;
    }
}

checkIfMensOnlyImages();

function updateProductImages(
    $frameImages,
    $productMainImagesContainer,
    productHandle,
    showSecondProductRow,
    showThirdProductRow
) {
    let productInfo = $('.active-product-card .product__info-wrapper');
    let plusMinusSwatch = $('.active-product-card .plus-minus-swatch');
    let plusMinusSwatchSymbol = plusMinusSwatch.find('em');
    let imageScrollbar = $('.active-product-card .pdp-main-carousel .carousel-track-wrapper');
    var $mediaGallery = $('#mediaGallery .product__media-list');
    var $matchedimages = $frameImages;
    var html = $('<div/>').append($matchedimages.clone()).html();
    $productMainImagesContainer.html(html);

        
    
    if (!deviceIsMobile.matches) {
        adjustGalleryTop();
    } else {
        $mediaGallery.css('overflow', 'hidden');
        $mediaGallery.css('scroll-behavior', 'auto');
        $mediaGallery.scrollTop(0);
        //console.log($mediaGallery.scrollTop());
        $mediaGallery.css('scroll-behavior', '');
        $mediaGallery.css('overflow', '');
        setTimeout(function () {
            $('.product__media-list img').each(function () {
                if (!this.classList.contains('lazyloaded')) {
                    lazySizes.loader.unveil(this);
                }
            });
            $('#productInfo .model-carousel .overflow-scroll-item').each(function (
                index,
                element,
            ) {
                // Index starts from 0, so we add 1 to start from 1 as you specified
                $(element).attr('data-model-image-index', index + 1);
            });
            $('.slick-active .product__media-list .model-trigger').each(function (
                index,
                element,
            ) {
                // Index starts from 0, so we add 1 to start from 1 as you specified
                $(element).attr('data-model-image-index', index + 1);
            });
        }, 600);
    }
    if (productInfo.attr('data-open') !== undefined) {
        productInfo.attr('data-closing', '');
        overlay.css('opacity', 0); // New line
        smoothScrollToTop(productInfo, 100);
        setTimeout(function () {
            //productInfo.style.removeProperty("transform");
            productInfo.removeAttr('data-open');
            productInfo.removeAttr('data-closing');
        }, 600);
        //console.log'Touch ended and it is closed')
    }

    if (mensOnlyImages) {
        const firstMensImage = document.querySelector('.pdp-main-carousel .mens--image');
        const mediaList = document.querySelector('.product__media-list');
        
        if (firstMensImage) {   
            firstMensImage.classList.add('first-mens-image');
        }
        const womensImages = document.querySelectorAll('.pdp-main-carousel .womens--image');

        if (womensImages.length > 0 && mediaList) {
            womensImages.forEach((womensImage) => {
                womensImage.parentNode.removeChild(womensImage);
                mediaList.appendChild(womensImage);
            });
        }
    }
}
function updateCarousels() {
    //console.log'updateCarousels called');
    document.querySelectorAll('.pdp-main-carousel .product__media-list').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = carousel.querySelectorAll('.product__media-item');
        const track = document.querySelector(
            `.pdp-main-carousel .carousel-track-wrapper[data-carousel-id="${carouselId}"] .carousel-track`,
        );
        const rectangle = track.querySelector('.carousel-rectangle');
        rectangle.style.height = `${track.offsetHeight / slides.length}px`;
        const trackHeight = track.offsetHeight - rectangle.offsetHeight;
        carousel.addEventListener('scroll', () => {
            const scrollTop = carousel.scrollTop;
            const scrollHeight = carousel.scrollHeight;
            const carouselHeight = carousel.offsetHeight;
            const scrollPercent = scrollTop / (scrollHeight - carouselHeight);
            rectangle.style.transform = `translateY(${scrollPercent * trackHeight}px)`;
        });
    });
}
function updateKeyFeaturesCarousels() {
    //console.log'updateCarousels called');
    document.querySelectorAll('.key-features-carousel').forEach((featuresCarousel) => {
        const slides = featuresCarousel.querySelectorAll('.overflow-scroll-item');
        const track = document.querySelector(
            `.key-features-track-wrapper[data-carousel-id="key-features-carousel"] .carousel-track`,
        );
        const rectangle = track.querySelector('.carousel-rectangle');
        // Reset the rectangle's position to the start
        rectangle.style.transform = 'translateX(0)';
        rectangle.style.width = `${track.offsetWidth / slides.length}px`;
        const trackWidth = track.offsetWidth - rectangle.offsetWidth;
        // Reset scroll position to the start
        featuresCarousel.scrollLeft = 0;
        featuresCarousel.addEventListener('scroll', () => {
            const scrollLeft = featuresCarousel.scrollLeft;
            const scrollWidth = featuresCarousel.scrollWidth;
            const carouselWidth = featuresCarousel.offsetWidth;
            const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);
            rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
        });
    });
}
updateKeyFeaturesCarousels();
function updateAccordionModelCarousels() {
    //console.log'updateCarousels called');
    document
        .querySelectorAll('.product__accordion .model-carousel')
        .forEach((fitGuideCarousel) => {
            const slides = fitGuideCarousel.querySelectorAll('.overflow-scroll-item');
            const track = document.querySelector(
                `.key-features-track-wrapper[data-carousel-id="fit-guide-carousel"] .carousel-track`,
            );
            const rectangle = track.querySelector('.carousel-rectangle');
            rectangle.style.width = `${track.offsetWidth / slides.length}px`;
            const trackWidth = track.offsetWidth - rectangle.offsetWidth;
            fitGuideCarousel.addEventListener('scroll', () => {
                const scrollLeft = fitGuideCarousel.scrollLeft;
                const scrollWidth = fitGuideCarousel.scrollWidth;
                const carouselWidth = fitGuideCarousel.offsetWidth;
                const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);
                rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
            });
        });
}
$(document).one('click', '.accordion-wrapper-key-features', function () {
    setTimeout(function () {
        updateKeyFeaturesCarousels();
    }, 500);
});
$(document).one('click', '.accordion-wrapper-how-it-fits', function () {
    setTimeout(function () {
        updateAccordionModelCarousels();
    }, 500);
});
function setOptionSelectorsSizeAndLens(variantColorwayHandle) {
    let frameSizeVariants = $(
        '.family-product-contents[data-product-handle="' +
            variantColorwayHandle +
            '"] .frame-variants ul[data-option-name="size"]',
    ).html();
    let frameLensVariants = $(
        '.family-product-contents[data-product-handle="' +
            variantColorwayHandle +
            '"] .frame-variants ul[data-option-name="lens"]',
    ).html();
    if (
        $(
            '.family-product-contents[data-product-handle="' +
                variantColorwayHandle +
                '"] .frame-variants ul[data-option-name="lens"] .available-variant',
        ).length === 3
    ) {
        $(
            '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
        ).addClass('three-option-list');
        //console.log('3 variants');
    } else {
        $(
            '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
        ).removeClass('three-option-list');
        //console.log('less than 3');
    }
    $(
        '.normal-option-selectors ul[data-option-name="size"], .sticky-option-selectors ul[data-option-name="size"]',
    ).html(frameSizeVariants);
    $(
        '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
    ).html(frameLensVariants);
}
function checkFamilyProductContentsWrapper(variantSelected) {
    $('.family-product-contents-wrapper .family-product-contents').each(function () {
        let $familyProduct = $(this);
        let $familyProductMatchingSelectedVariant = $familyProduct.find(
            '.frame-variants button[data-variant-name="' + variantSelected + '"]',
        );
        let familyProductHandle = $familyProduct.attr('data-product-handle');
        if ($familyProductMatchingSelectedVariant.hasClass('unavailable-variant')) {
            //console.log(familyProductHandle + ' has this variant unavailable');
            $(
                '.pdp-family-products-swatch-bar-scroll button[data-product-handle="' +
                    familyProductHandle +
                    '"]',
            ).addClass('unavailable-swatch');
        } else {
            $(
                '.pdp-family-products-swatch-bar-scroll button[data-product-handle="' +
                    familyProductHandle +
                    '"]',
            ).removeClass('unavailable-swatch');
        }
    });
}
/* +----------------------+
   |         ```          |
   +----------------------+
   Variant button click
   +----------------------+
   |         ```          |
   +----------------------+ */
$(document).on(
    'click',
    '.product-variants li button.all-available-variant:not(.active-variant)',
    function () {
        let $this = $(this);

        var activeSwatch = $('.frame-active button');

        let variant = {
            selected: $this.attr('data-variant-name'),
            familyTitle: $this.attr('data-metafield-family-title'),
            colorwayTitle: $this.attr('data-metafield-colorway-title'),
            id: $this.attr('data-metafield-variant-id'),
            price: $this.attr('data-metafield-price'),
            price_unchecked: $this.attr('data-metafield-price-unchecked'),
            soldout: $this.attr('data-product-sold-out'),
            colorwayHandle: $this.attr('data-metafield-colorway-handle'),
        };
        let $body = $('body');
        let $productPrice = $('.pdp-header .product-price-main-price');
        $body.addClass('variant-option-selected');
        $('button[data-variant-name="' + variant.selected + '"]')
            .parents('ul')
            .find('.active-variant')
            .removeClass('active-variant');
        $('button[data-variant-name="' + variant.selected + '"]').addClass('active-variant');
        var variantAddOnPrice = $this.attr('data-variant-add-on-price');
        if (variant.selected === 'Blue Light Readers') {
            $body.addClass('readers-selected');
            //$('button[data-variant-name="Blue Light"] em').remove();
            var priceOfAddOn = $('#frameCase').attr('data-add-on-amount');

            var priceWithAddOnAndCase = activeSwatch.attr('data-product-price-with-case-blue-light-readers');
            var priceWithAddOnAndSoftCase = activeSwatch.attr('data-product-price-with-case-blue-light-readers');
            var priceWithAddOn = activeSwatch.attr('data-product-price-with-blue-light-readers');

            if ($('#frameCase').is(':checked')) {
                if ($('.variant-hard-case').hasClass('variant-selected')) {
                $('.pdp-header .product-price-main-price').text(priceWithAddOnAndCase);
                } else {
                    $('.pdp-header .product-price-main-price').text(priceWithAddOn);
                }
            } else {
                $('.pdp-header .product-price-main-price').text(priceWithAddOn);
            }

            
                
        
            if (!$this.hasClass('has-readers-selected')) {
                $('.lens--readers--options')
                    .addClass('readers--show')
                    .attr('aria-hidden', 'false');
                activateReadersTabIndex();
                //console.log("Fired this");
                if (!$('.selected-readers').length) {
                    $addToCart.addClass('power-not-selected');
                    $AddToCartText.text('Select Power');
                }
                if (
                    $('.selected-readers').length &&
                    $this
                        .parents('.product-variants-wrapper')
                        .hasClass('normal-option-selectors')
                ) {
                    let readersSelectedPrice =
                        $('.selected-readers').attr('data-metafield-price');
                    $('body').addClass('optical-addon-selected');
                }
            } else {
                activateReadersTabIndex();
                $('.all-available-blue-light-readers').addClass('readers-power-selected');
                if ($('.selected-readers').length) {
                    let readersSelectedPrice =
                        $('.selected-readers').attr('data-metafield-price');
                }
                if (!$('.selected-readers').length) {
                    let readersSelectedPrice =
                        $('.selected-readers').attr('data-metafield-price');
                    $addToCart.addClass('power-not-selected');
                    $AddToCartText.text('Select Power');
                    $('body').addClass('optical-addon-selected');
                } else {
                    $('.normal-option-selectors .lens--readers--options')
                        .addClass('readers--show')
                        .attr('aria-hidden', 'false');
                    let powerValue = $('.selected-readers').attr('data-power-value');
                    if ($('body').hasClass('pdp-tab-opened')) {
                        if (!$('body').hasClass('extra20-pdp')) {
                            $AddToCartText.html('Add with Readers <em>' + powerValue + '</em>');
                        } else {
                            if (window.theme.currencyISO === 'USD') {
                                $AddToCartText.text('Add to Bag for +20% Off');
                            } else {
                                $AddToCartText.text('Add to Bag');
                            
                            }
                        }
                    } else {
                        if (!$('body').hasClass('extra20-pdp')) {
                            $AddToCartText.html('Add with Lens <em>' + powerValue + '</em>');
                        } else {
                            if (window.theme.currencyISO === 'USD') {
                                $AddToCartText.text('Add to Bag for +20% Off');
                            } else {
                                $AddToCartText.text('Add to Bag');
                            
                            }
                        }
                    }

                    $('body').addClass('optical-addon-selected');
                }
            }
        } else if (variant.selected === 'Blue Light') {
            var priceOfAddOn = $('#frameCase').attr('data-add-on-amount');
            
            var priceWithAddOnAndCase = activeSwatch.attr('data-product-price-with-case-blue-light');
            var priceWithAddOnAndSoftCase = activeSwatch.attr('data-product-price-with-case-blue-light');
            var priceWithAddOn = activeSwatch.attr('data-product-price-with-blue-light');

            if ($('#frameCase').is(':checked')) {
                if ($('.variant-hard-case').hasClass('variant-selected')) {
                    $('.pdp-header .product-price-main-price').text(priceWithAddOnAndCase);
                } else {
                    $('.pdp-header .product-price-main-price').text(priceWithAddOn);
                }
            } else {
                $('.pdp-header .product-price-main-price').text(priceWithAddOn);
            }

            if (!$('button[data-variant-name="Blue Light"] em').length) {
                $('button[data-variant-name="Blue Light"]').append(
                    '<em class="bl-slashed">$60</em><em class="bl-sale-price">' +
                        variantAddOnPrice +
                        '</em>',
                );
            }
            $addToCart.removeClass('power-not-selected');
            $body.removeClass('readers-selected');
            deactivateReadersTabIndex();

            $('.lens--readers--options.readers--show').each(function () {
                $(this).removeClass('readers--show').attr('aria-hidden', 'true');
            });
            if (!$('body').hasClass('extra20-pdp')) {
                if ($('body').hasClass('pdp-tab-opened')) {
                    $AddToCartText.html('Add with Blue Light');
                } else {
                    $AddToCartText.html('Add with Lens');
                }
            } else {
                if (window.theme.currencyISO === 'USD') {
                    $AddToCartText.text('Add to Bag for +20% Off');
                } else {
                    $AddToCartText.text('Add to Bag');
                }
            }
            $('body').addClass('optical-addon-selected');
        }
    },
);
$(document).on(
    'click',
    '.product-variants li button.all-available-variant.active-variant',
    function () {
        let $this = $(this);

        var activeSwatch = $('.frame-active button');
        var currentPrice = activeSwatch.attr('data-product-price-full');
        //console.log('clicked');
        let variant = {
            selected: $this.attr('data-variant-name'),
            familyTitle: $this.attr('data-metafield-family-title'),
            colorwayTitle: $this.attr('data-metafield-colorway-title'),
            id: $this.attr('data-metafield-variant-id'),
            price: $this.attr('data-metafield-price'),
            price_unchecked: $this.attr('data-metafield-price-unchecked'),
            soldout: $this.attr('data-product-sold-out'),
            colorwayHandle: $this.attr('data-metafield-colorway-handle'),
        };
        let $body = $('body');
        let $productPrice = $('.pdp-header .product-price-main-price');
        let optionsMenuSelected = $this.parents('ul').attr('data-option-name');
        let variantAddOnPrice = $this.attr('data-variant-add-on-price');
        if (variant.selected === 'Blue Light') {
            $('button[data-variant-name="' + variant.selected + '"]').removeClass(
                'active-variant',
            );

            //$('button[data-variant-name="Blue Light"] em').remove();
            if ($('body').hasClass('extra20-pdp')) {
                if (window.theme.currencyISO === 'USD') {
                    $AddToCartText.text('Add to Bag for +20% Off');
                } else {
                    $AddToCartText.text('Add to Bag');
                }
            } else {
                $AddToCartText.html('Add to Bag');
            }
            $('body').removeClass('optical-addon-selected');


            var priceWithCase = activeSwatch.attr('data-product-price-with-case');
            if ($('#frameCase').is(':checked')) {
                $('.pdp-header .product-price-main-price').text(priceWithCase);
            } else {
                $('.pdp-header .product-price-main-price').text(currentPrice);
            }
        } else if (variant.selected === 'Blue Light Readers') {
            if ($this.parents('.product-variants-wrapper').hasClass('normal-option-selectors')) {
                $('.normal-option-selectors .lens--readers--options')
                    .removeClass('readers--show')
                    .attr('aria-hidden', 'true');
                $('button[data-variant-name="Blue Light Readers"]').removeClass(
                    'active-variant',
                );
                if ($('body').hasClass('extra20-pdp')) {
                    if (window.theme.currencyISO === 'USD') {
                        $AddToCartText.text('Add to Bag for +20% Off');
                    } else {
                        $AddToCartText.text('Add to Bag');
                    }
                } else {
                    $AddToCartText.html('Add to Bag');
                }
                $productPrice.text(variant.price_unchecked);
                $('body').removeClass('optical-addon-selected');
                $addToCart.removeClass('power-not-selected');
            } else {
                if (!$this.hasClass('has-readers-selected')) {
                    if ($('body').hasClass('extra20-pdp')) {
                        if (window.theme.currencyISO === 'USD') {
                            $AddToCartText.text('Add to Bag for +20% Off');
                        } else {
                            $AddToCartText.text('Add to Bag');
                        }
                    } else {
                        $AddToCartText.html('Add to Bag');
                    }
                    $addToCart.removeClass('power-not-selected');
                }
                $('body').removeClass('optical-addon-selected');
                $('.lens--readers--options')
                    .addClass('readers--show')
                    .attr('aria-hidden', 'false');
            }

            var activeSwatch = $('.frame-active button');
            var priceWithCase = activeSwatch.attr('data-product-price-with-case');
            if ($('#frameCase').is(':checked')) {
                $('.pdp-header .product-price-main-price').text(priceWithCase);
            } else {
                $('.pdp-header .product-price-main-price').text(currentPrice);
            }

            if (!deviceIsMobile.matches) {
                
            } else {
                $addToCart.removeClass('power-not-selected');
            }
        }
    },
);
// --------------------------------------------------------- //
// --------------- Readers Variants Click ------------------ //
// --------------------------------------------------------- //
$(document).on('click', '.lens--readers--options .readers--variant', function () {
    let $this = $(this);
    let lensVariantID = $this.attr('data-variant-id');
    let powerValue = $this.attr('data-power-value');
    let variant = {
        selected: $this.attr('data-variant-name'),
        familyTitle: $this.attr('data-metafield-family-title'),
        colorwayTitle: $this.attr('data-metafield-colorway-title'),
        id: $this.attr('data-metafield-variant-id'),
        price: $this.attr('data-metafield-price'),
        price_unchecked: $this.attr('data-metafield-price-unchecked'),
        soldout: $this.attr('data-product-sold-out'),
        colorwayHandle: $this.attr('data-metafield-colorway-handle'),
    };
    let $productPrice = $('.pdp-header .product-price-main-price');
    if (!$this.hasClass('selected-readers')) {
        $('.lens--readers--options button').removeClass('selected-readers');
        $('.readers--variant[data-power-value="' + powerValue + '"]').addClass(
            'selected-readers',
        );
        $('.power-selected').text(powerValue);
        //$('button[data-variant-name="Blue Light Readers"]').append('<em>$100</em>');
        $this.parent().addClass('selected-readers-wrapper');
        $('.readers-li').addClass('optical-option--selected');
        $('.sticky-option-selectors .lens--readers--options')
            .removeClass('readers--show')
            .attr('aria-hidden', 'true');
        $('body').addClass('optical-addon-selected');
        if ($('.family-product-contents-wrapper .lens--readers--options').length) {
            $('.family-product-contents-wrapper .lens--readers--options').each(function () {
                $(this).removeClass('readers--show').attr('aria-hidden', 'true');
            });
        }
        $addToCart.attr('data-readers-selected-variant-id', lensVariantID);
        $addToCart.removeClass('power-not-selected');
        deactivateReadersTabIndex();
        if ($('body').hasClass('keyboard-focus')) {
            $(
                '.product-variants-wrapper button[data-variant-name="Blue Light Readers"]',
            ).focus();
        }
        $('button[data-variant-name="Blue Light Readers"]').addClass('has-readers-selected');

        if (!$('body').hasClass('extra20-pdp')) {
            if ($('body').hasClass('pdp-tab-opened')) {
                $AddToCartText.html('Add with Readers <em>' + powerValue + '</em>');
            } else {
                $AddToCartText.html('Add with Lens <em>' + powerValue + '</em>');
            }
        } else {
            if (window.theme.currencyISO === 'USD') {
                $AddToCartText.text('Add to Bag for +20% Off');
            } else {
                $AddToCartText.text('Add to Bag');
            }
        }
        $('.all-available-blue-light-readers').addClass('readers-power-selected');
        if ($(window).width() > 990) {
            $('.lens--readers--options')
                .removeClass('readers--show')
                .attr('aria-hidden', 'true');
        }
        $('body').addClass('optical-addon-selected');

        
    } else {
        deactivateReadersTabIndex();
        if ($('body').hasClass('keyboard-focus')) {
            $('.pdp-family-products-swatch-bar-scroll .frame-active button').focus();
        }
        $('button[data-variant-name="Blue Light Readers"]').removeClass('has-readers-selected');

        $this.parent().removeClass('selected-readers-wrapper');
        $('.optical-option--selected').removeClass('optical-option--selected');
        $this.removeClass('selected-readers');
        $('.power-selected').text('');
        $('.readers--variant[data-power-value="' + powerValue + '"]').removeClass(
            'selected-readers',
        );
        $('.lens--readers--options').removeClass('readers--show').attr('aria-hidden', 'true');
        $('.readers-variant-li.selected-readers-wrapper').removeClass(
            'selected-readers-wrapper',
        );
        //$('.AddToCart-text').text('Add to Bag');
        if ($('body').hasClass('extra20-pdp')) {
            if (window.theme.currencyISO === 'USD') {
                $AddToCartText.text('Add to Bag for +20% Off');
            } else {
                $AddToCartText.text('Add to Bag');
            }
        } else {
            $AddToCartText.html('Add to Bag');
        }
        $('button[data-variant-name="Blue Light Readers"]').removeClass('active-variant');
        $('.all-available-blue-light-readers').removeClass('readers-power-selected');
        $('body').removeClass('optical-addon-selected');

        $addToCart.attr('data-readers-selected-variant-id', lensVariantID);

        
    }
});
// --------------------------------------------------------- //
// --------------- Update Family Swatches ------------------ //
// --------------------------------------------------------- //
function updatePdpFamilySwatchProduct(selectedOpenedOptionVariantName) {
    let $openedOptionsList = $('.sticky-option-selectors .show-variants');
    let $selectedOpenedOptionVariant = $openedOptionsList.find('.active-variant');
    selectedOpenedOptionVariantName = $selectedOpenedOptionVariant.attr('data-variant-name');
    $('.family-product-contents').each(function () {
        let $thisFamilyProduct = $(this);
        let familyProductHandle = $thisFamilyProduct.attr('data-product-handle');
        // Find out which variants are unavailable for the $selectedOpenedOptionVariantName (they'd have matching data-variant-name) and would have the class available variant
        let $familyProductMatchingSelectedVariant = $thisFamilyProduct.find(
            '.frame-variants button[data-variant-name="' +
                selectedOpenedOptionVariantName +
                '"]',
        );
        let $familyProductMatchingSelectedVariantOption =
            $familyProductMatchingSelectedVariant.parents('ul');
        // Check if the variant is available
        if (
            $familyProductMatchingSelectedVariant.hasClass('available-variant') &&
            $familyProductMatchingSelectedVariantOption.find('.available-variant').length > 1
        ) {
            $(
                '.pdp-family-swatch-product button[data-product-handle="' +
                    familyProductHandle +
                    '"]',
            ).addClass('selected-variant-available-in-colorway');
        } else {
            $(
                '.pdp-family-swatch-product button[data-product-handle="' +
                    familyProductHandle +
                    '"]',
            ).removeClass('selected-variant-available-in-colorway');
        }
    });
}
function updateAccordionHeight() {
    $('.opened-accordion+.accordion__content').each(function () {
        var content = $(this);
        content.css('max-height', function () {
            return content.prop('scrollHeight') + 'px';
        });
    });
}
function updateAccordionHeightAfterLiChange() {
    $('.opened-accordion:not(.accordion-heading-key-features)+.accordion__content').each(
        function () {
            var content = $(this);
            content.css('max-height', function () {
                return content.prop('scrollHeight') + 'px';
            });
        },
    );
}
function checkEachAccordionLi() {
    $('.accordion__content li').each(function () {
        var $this = $(this);
        // get line-height, convert it to number removing 'px'
        var lineHeight = parseFloat($this.css('line-height'));
        // get padding-top and padding-bottom, convert them to number removing 'px'
        var paddingTop = parseFloat($this.css('padding-top'));
        var paddingBottom = parseFloat($this.css('padding-bottom'));
        // calculate total height of one line of text
        var totalHeight = lineHeight + paddingTop + paddingBottom;
        // If element's height is more than its totalHeight
        if ($this.height() > totalHeight) {
            $this.addClass('longer-text');
            setTimeout(function () {
                updateAccordionHeightAfterLiChange();
            }, 200);
        }
    });
}
$(document).ready(function () {
    checkEachAccordionLi();
});

function goToPreShopSlide() {
    $('.pdp-message-carousel-wrapper').slick('slickGoTo', 0);
    $('.pdp-message-carousel-wrapper').slick('slickPause');
}

function goToSCSlide() {
    //$('.pdp-message-carousel-wrapper').slick('slickGoTo', 2);
   // $('.pdp-message-carousel-wrapper').slick('slickPause');
}

function goToLWSlide() {
    //$('.pdp-message-carousel-wrapper').slick('slickGoTo', 1);
   // $('.pdp-message-carousel-wrapper').slick('slickPause');
}

function goToShippingSlide() {
    //$('.pdp-message-carousel-wrapper').slick('slickGoTo', 0);
    //$('.pdp-message-carousel-wrapper').slick('slickPause');
}

function filterSlides() {
    // This happens on hover, the message carousel will follow have specific logic for SALE - Exchange Items, SALE - Final Sale Items, and All Pre-Shop Items
    // If SALE - Exchange Item, show Exchange Message and Generic Message only
    // If SALE - Final Sale Item, show Final Sale Message and Generic Message only
    // If Pre-Shop Item, show Pre-Shop Message only
    // Otherwise, show Full Price Message and Generic Message only
    const isExchangeItem = $('body:not(.preshop-pdp)').hasClass('exchange-only-pdp');
    const isFinalSaleItem = $('body:not(.preshop-pdp)').hasClass('final-sale-item');
    const isPreShopItem = $('body').hasClass('preshop-pdp');
    
    // console.log('*** isPreShopItem: ', isPreShopItem);
    $('.pdp-message-carousel-wrapper .pdp-carousel-message').each(function() {
        const $slide = $(this);
        if (isExchangeItem) {
            $slide.toggleClass('slick-cloned', !$slide.hasClass('exchange-message') && !$slide.hasClass('generic-message'));
        } else if (isFinalSaleItem) {
            $slide.toggleClass('slick-cloned', !$slide.hasClass('finalsale-message') && !$slide.hasClass('generic-message'));
        } else if (isPreShopItem) {
            $slide.toggleClass('slick-cloned', !$slide.hasClass('preshop-message'));
        } else {
            $slide.toggleClass('slick-cloned', !$slide.hasClass('full-price-message') && !$slide.hasClass('generic-message'));
        }
    });
    
    $('.pdp-message-carousel-wrapper').slick('slickUnfilter').slick('slickFilter', ':not(.slick-cloned)');
}
  
if (window.theme.isSaleActive) {
$(".pdp-message-carousel-wrapper").slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    easing: "ease",
    vertical: true
});

// Apply initial filter
filterSlides();

} else if (window.theme.preShopActive && $('body').hasClass('pre-shop-area')) {
$(".pdp-message-carousel-wrapper").slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    easing: "ease",
    vertical: true
});

// Apply initial filter
filterSlides();

} else {
$(".pdp-message-carousel-wrapper").slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    easing: "ease",
    vertical: true
});
}

// Function to be called when color swatches are hovered
function updateSliderFilter() {
$('.pdp-message-carousel-wrapper').slick('slickUnfilter');
filterSlides();
}

$.fn.modelIsInViewport = function () {
    var elementOffset = 195;
    if (
        $('body').hasClass('pdp-showing-additional-colorways') &&
        $('body').hasClass('pdp-variants-opened') &&
        !$('body').hasClass('carousel-product-swatch-pdp')
    ) {
        elementOffset = 245;
    } else if (
        $('body').hasClass('pdp-showing-additional-colorways') &&
        $('body').hasClass('carousel-product-swatch-pdp')
    ) {
        elementOffset = 305;
    } else if (
        $('body').hasClass('pdp-showing-additional-colorways') &&
        $('body').hasClass('carousel-product-swatch-pdp') &&
        $('body').hasClass('pdp-variants-opened')
    ) {
        elementOffset = 305;
    } else if (
        $('body').hasClass('pdp-showing-additional-colorways') &&
        !$('body').hasClass('carousel-product-swatch-pdp')
    ) {
        elementOffset = 245;
    } else if ($('body').hasClass('pdp-variants-opened')) {
        elementOffset = 275;
    }
    var elementTop = $(this).offset().top + elementOffset;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementTop >= viewportTop && elementBottom <= viewportBottom; //Updated this line
};
/* +----------------------+
|         ```          |
+----------------------+
Update variant options
+----------------------+
|         ```          |
+----------------------+ */
function checkAvailableVariants($this, productHandle, frameSizeVariants, frameLensVariants) {
    if (
        $(
            '.family-product-contents[data-product-handle="' +
                productHandle +
                '"] .frame-variants ul[data-option-name="lens"] .available-variant',
        ).length === 3
    ) {
        $(
            '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
        ).addClass('three-option-list');
        //console.log('3 variants');
    } else {
        $(
            '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
        ).removeClass('three-option-list');
        //console.log('less than 3');
    }
    if (
        $(
            '.family-product-contents[data-product-handle="' +
                productHandle +
                '"] .frame-variants ul[data-option-name="size"]',
        ).length
    ) {
        //console.log('has size variants');
        $(
            '.normal-option-selectors ul[data-option-name="size"], .sticky-option-selectors ul[data-option-name="size"]',
        ).html(frameSizeVariants);
    } else {
        $('.product-variants-wrapper').addClass('size-option-hidden');
        //console.log('no size variants');
    }
    if (
        $(
            '.family-product-contents[data-product-handle="' +
                productHandle +
                '"] .frame-variants ul[data-option-name="lens"]',
        ).length
    ) {
        $(
            '.normal-option-selectors ul[data-option-name="lens"], .sticky-option-selectors ul[data-option-name="lens"]',
        ).html(frameLensVariants);
        //console.log('has lens variants');
    } else {
        $('.product-variants-wrapper').addClass('lens-option-hidden');
        //console.log('no lens variants');
    }
    $(
        '.family-product-contents[data-product-handle="' +
            productHandle +
            '"] .frame-variants ul:not(.lens-optical-options):not(.readers-variants):not(.all-options-available)',
    ).each(function () {
        let $thisOption = $(this);
        let thisOptionName = $thisOption.attr('data-option-name');
        if ($thisOption.find('.available-variant').length > 1) {
            $(
                '.product-dropdown .show-variant-options[data-option-name="' +
                    thisOptionName +
                    '"]',
            ).removeClass('hide-option');
            $('.sticky-option-selectors, .normal-option-selectors').removeClass(
                thisOptionName + '-option-hidden',
            );
            //console.log(thisOptionName + " has more than 1 available variant");
            //$('body').addClass('pdp-variants-opened');
            //$('#productInfo').css('transform', 'translateY(calc(100% - 185px) - 48px)');
        } else {
            //console.log(thisOptionName + " doesn't have more than 1 available variant");
            $('.sticky-option-selectors, .normal-option-selectors').addClass(
                thisOptionName + '-option-hidden',
            );
            if (!$this.hasClass('selected-variant-available-in-colorway')) {
                //hideAllOptions();
                $(
                    '.product-dropdown .show-variant-options[data-option-name="' +
                        thisOptionName +
                        '"]',
                ).addClass('hide-option');
                $('.sticky-option-selectors, .normal-option-selectors').addClass(
                    thisOptionName + '-option-hidden',
                );
                $(
                    '.sticky-option-selectors ul[data-option-name="' +
                        thisOptionName +
                        '"]:not(.lens-readers-variants)',
                ).removeClass('show-variants');
                if ($('.sticky-option-selectors').hasClass('size-option-hidden')) {
                    $('.product-back-in-stock').addClass('one-option-hidden');
                    //console.log("size option hidden");
                } else if (
                    $(
                        '.sticky-option-selectors:not(.product-variants-optical-wrapper)',
                    ).hasClass('size-option-hidden lens-option-hidden')
                ) {
                    $('.product-back-in-stock').addClass('both-options-hidden');
                } else if (!$('.sticky-option-selectors').length) {
                    $('.product-back-in-stock').addClass('no-options-available');
                } else {
                    $('.product-back-in-stock').removeClass('one-option-hidden');
                }
            }
            setTimeout(function () {
                if (
                    $('.sticky-option-selectors').hasClass('size-option-hidden') &&
                    $('.sticky-option-selectors').hasClass('lens-option-hidden')
                ) {
                    hideAllOptions();
                }
                if (
                    $('.sticky-option-selectors').hasClass('size-option-hidden') &&
                    $('button[data-option-name="size"]').hasClass('has-options-opened')
                ) {
                    hideAllOptions();
                }
                if (
                    $('.sticky-option-selectors').hasClass('lens-option-hidden') &&
                    $('button[data-option-name="lens"]').hasClass('has-options-opened')
                ) {
                    hideAllOptions();
                }
            }, 100);
            //$('body').removeClass('pdp-variants-opened');
            //$('#productInfo').css('transform', 'translateY(calc(100% - 185px))');
            //$('.product-dropdown .show-variant-options.has-options-opened[data-option-name="'+ thisOptionName +'"]').removeClass('has-options-opened');
        }
        if ($thisOption.find('.available-variant').length > 1) {
            $('.sticky-option-selectors.' + thisOptionName + '-option-hidden').removeClass(
                thisOptionName + '-option-hidden',
            );
        } else {
            $('.sticky-option-selectors.' + thisOptionName + '-option-hidden').addClass(
                thisOptionName + '-option-hidden',
            );
        }
    });
}

$.fn.zoomIsInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop() + 230; // Adjust for the height of the header
    var viewportBottom = viewportTop + $(window).height() - 270; // Adjust for when to deactivate
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
$(window).on('scroll', function () {
    $('.product__media-list .zoom-active').each(function () {
        var $this = $(this);
        if (!$this.zoomIsInViewport()) {
            $this.find('.zoomImg').click();
        }
    });
});

const debounceHover = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
        }, wait);
    };
};
$(document).on('click', '.product-shop-size-option-value', function () {
    var $this = $(this);
    var optionVariantID = $this.attr('data-variant-id');
    var priceSelected = $this.attr('data-variant-price');
    $('.active-swatch').removeClass('active-swatch');
    $this.addClass('active-swatch');
    $('.pdp-header .pdp-price').html(priceSelected);
    $('#buyItNow select').val(optionVariantID).trigger('change');
    $addToCart.attr('data-variant-id', optionVariantID);
});
$(document).on('click', '.go-to-reviews:not(.hovered-reviews)', function () {
    $('html, body').animate({ scrollTop: $('.reviews-wrapper').offset().top - 100 }, 700);
});

$(document).on('click', '.opaline-popup-cta', function () {
    $('.opaline-popup').fadeIn(300);
});
$(document).on(
    'click',
    '.opaline-popup .popup-close, .opaline-popup .close-popup-overlay',
    function () {
        $('.opaline-popup').fadeOut(300);
    },
);
$(document).on('click', '.amore-popup-cta', function () {
    $('.gwp-popup').fadeIn(400);
});
$(document).on(
    'click',
    '.amore-popup .popup-close, .amore-popup .close-popup-overlay',
    function () {
        $('.gwp-popup').fadeIn(400);
    },
);
$(document).on('click', '.lens-popup-cta', function () {
    $('.lens-popup').fadeIn(400);
});
$(document).on(
    'click',
    '.lens-popup .popup-close, .lens-popup .close-popup-overlay',
    function () {
        $('.lens-popup').fadeOut(400);
    },
);

$(document).on(
    'click',
    '.pdp-message-popup .popup-close, .pdp-message-popup .close-popup-overlay',
    function () {
        var $this = $(this);
        $this.parents('.pdp-message-popup').fadeOut(400);
    },
);

$(document).on('click', '.doubloon-popup-cta', function () {
    $('.gwp-popup').fadeIn(400);
});
$(document).on('click', '.gwp-popup .popup-close, .gwp-popup .close-popup-overlay', function () {
    $('.gwp-popup').fadeOut(400);
});
if (deviceIsMobile.matches) {
    $(document).on('click', '.power-not-selected', function () {
        if (productInfo.hasAttribute('data-open')) {
            $('.active-product-card .product__info-wrapper').animate(
                {
                    scrollTop: 0,
                },
                500,
            );
        } else {
            if (!$('.show-optical-options').hasClass('has-options-opened')) {
                $('.show-optical-options').click();
            }
        }
    });
}
$(document).on('click', '.close-readers', function () {
    $('.readers--show').removeClass('readers--show');
    $('.readers-li').removeClass('readers--showing');
    if (!$('.readers--variant.selected-readers').length) {
        $('#readersLens').prop('checked', false).change();
    }
});
document.addEventListener('DOMContentLoaded', (event) => {
    if (deviceIsMobile.matches) {
        setTimeout(function () {
            // console.log('Moved carousels');
            if (
                $('body').hasClass('template-krewe-gift-card') ||
                $('body').hasClass('template-summer-tote-2023') ||
                $('body').hasClass('pdp-frame-case')
            ) {
                $('.recently-viewed-section').insertAfter('.accordion-wrapper-design-notes');
                $('.product-recommendations-section').insertAfter(
                    '.accordion-wrapper-design-notes',
                );
            } else {
                $('.recently-viewed-section').insertAfter('.accordion-wrapper-reviews');
                $('.product-recommendations-section').insertAfter('.accordion-wrapper-reviews');
            }
        }, 100);
        $('.pdp-main-carousel .product__media-list').on('scroll', function () {
            $('.pdp-main-carousel .model-label-trigger').each(function () {
                var $this = $(this);
                if ($this.modelIsInViewport()) {
                    if ($this.is(':empty')) {
                        $('.model-face-shape-image-label').addClass(
                            'hidden-model-face-shape-image-label',
                        );
                        $(
                            '.krw--mobile-only.fera-wrapper[data-fera-container="382876"]',
                        ).removeClass('x-people-viewing-hidden');
                        if ($('body').hasClass('showing-waitlist-bar')) {
                            $('.product-soldout-label').addClass('show-sold-out-label');
                        }
                    } else {
                        var modelImageIndex = $this.attr('data-model-image-index');
                        $('.how-it-fits-trigger').attr(
                            'data-model-image-active-index-2',
                            modelImageIndex,
                        );
                        $(
                            '.krw--mobile-only.fera-wrapper[data-fera-container="382876"]',
                        ).addClass('x-people-viewing-hidden');
                        $('.model-face-shape-image-label')
                            .html($this.html())
                            .removeClass('hidden-model-face-shape-image-label');
                        if ($('body').hasClass('showing-waitlist-bar')) {
                            $('.product-soldout-label').removeClass('show-sold-out-label');
                        }
                    }
                }
            });
        });

        // $('#mediaGallery .product__media-item:first-of-type .pdp-ticker-extra').insertAfter('.pdp-breadcrumbs');
    }
});
$(document).on('focus', '.product-shop-back-in-stock-email', function () {
    $('.blink').fadeOut(100);
});
$(document).on(
    'click',
    '.sticky-option-selectors .show-optical-options:not(.has-options-opened)',
    function () {
        // console.log('active optical cicked');
        if ($addToCart.hasClass('power-not-selected')) {
            $addToCart.removeClass('power-not-selected');
            $AddToCartText.text('Add to Bag');
            $('.lens--readers--options')
                .removeClass('readers--show')
                .attr('aria-hidden', 'true');
            $('button[data-variant-name="Blue Light Readers"]').removeClass('active-variant');
        }
    },
);
function calculateAccordionsHeight() {
    var accordions = document.querySelectorAll('.product-accordion-opened');
    var accordionsHeight = 0;
    accordions.forEach(function (accordion) {
        var contentInner = accordion.querySelector('.accordion__content-inner');
        if (contentInner) {
            accordionsHeight += contentInner.offsetHeight;
        }
    });
    return accordionsHeight;
}
function adjustGalleryTop() {
    var productInfo = document.querySelector('.product__info-container');
    var productMediaList = document.querySelector('.product__media-list');
    var pdpMainCarousel = document.querySelector('.pdp-main-carousel');
    //console.log('productInfo height:', productInfo.offsetHeight);
    // console.log('productMediaList height:', productMediaList.offsetHeight);
    var accordionsHeight = calculateAccordionsHeight();
    //console.log('Accordions height:', accordionsHeight);
    var totalHeight = productInfo.offsetHeight + accordionsHeight;
    if (totalHeight > productMediaList.offsetHeight) {
        var viewportHeight = window.innerHeight;
        var topValue = viewportHeight - productMediaList.offsetHeight - 20;
        pdpMainCarousel.style.top = `${topValue}px`;
        pdpMainCarousel.setAttribute('data-top', topValue !== 0 ? '1' : '0'); // Set data-top attribute
        // console.log('Adjusted top:', pdpMainCarousel.style.top);
    } else {
        pdpMainCarousel.style.removeProperty('top');
        pdpMainCarousel.setAttribute('data-top', '0'); // Set data-top attribute to 0
        // console.log('Removed top property');
    }
}
document.addEventListener('DOMContentLoaded', function () {
    if (deviceIsMobile.matches) {
        // Get the elements by their IDs
        var footerSection = document.getElementById('shopify-section-footer');
        // Append the footer section to the product info
        $('.product__info-container').append(footerSection);
        $('#productInfo').attr('aria-label', 'Swipe up to view product details');
        $('.accordion-wrapper-design-notes').attr('aria-hidden', 'false');
    } else {
        $('.fixed-atc-bar').appendTo('.desktop-atc');
            $('.product-price-main-price').append('<span class="afterpay-update"></span>');
            $('.afterpay-update').remove();

        $('div[data-fera-container="382876"], .views-carts-slider-wrapper').insertAfter('.collection-description');
        $('#productInfo').removeAttr('aria-label').removeAttr('role');
        adjustGalleryTop();
    }
    $('.final-sale-popup').each(function () {
        var $this = $(this);
        $this.appendTo('body');

    });
});
function disableAllPopupFocusableElements() {
    $('.popup-theme-standard_mobile_overlay')
        .find('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
        .attr('tabindex', '-1');
    //$('#MainContent').focus();
    $('.final-sale-popup').attr('aria-hidden', 'true');
    $('.tag-based-popup-trigger, .pdp-popup-trigger').attr('aria-expanded', 'false');
}
function enableAllPopupFocusableElements() {
    $('.final-sale-popup').attr('aria-hidden', 'false');
    $('.popup-theme-standard_mobile_overlay')
        .find('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
        .attr('tabindex', '0');
    $('.popup-theme-standard_mobile_overlay .popup-close').focus();
}
$(document).on('click', '.tag-based-popup-trigger:not([data-info-popup-item-tag="revelry"]), .pdp-popup-trigger, .pdp-message-popup-cta, .accordion-popup-trigger', function () {
    var $this = $(this);
    var popup_id = $this.attr('data-info-popup-item-tag');
    $this.attr('aria-expanded', 'true');
    $('body').addClass('show-vanity-popup');
    $('.final-sale-popup[data-popup-tag="' + popup_id + '"]').fadeIn(300);
    enableAllPopupFocusableElements();
});

$(document).on('click', '.pdp-message-popup-cta', function () {
    var $this = $(this);
    var popup_id = $this.attr('data-info-popup-item-tag');
    $this.attr('aria-expanded', 'true');
    $('body').addClass('show-vanity-popup');
    $('.final-sale-popup#' + popup_id).fadeIn(300);
    enableAllPopupFocusableElements();
});

$(document).on('click', '.kf-popup-trigger', function () {
    var $this = $(this);
    var popup_id = $this.attr('data-info-popup-item-tag');
    $('body').addClass('show-vanity-popup');
    $('.final-sale-popup[data-popup-tag="' + popup_id + '"]').fadeIn(300);
    enableAllPopupFocusableElements();
});

$(document).on(
    'click',
    '.final-sale-popup .popup-close, .final-sale-popup .close-popup-overlay',
    function () {
        $('body').removeClass('show-vanity-popup');
        disableAllPopupFocusableElements();
    },
);

$(document).on('click', '.kf-frame-case-special a[href="#gwp2024"], .kf-gwp img', function (e) {
    e.preventDefault();
    var $this = $(this);
    var popup_id = $this.attr('data-info-popup-item-tag');
    $('body').addClass('show-vanity-popup');
    $('.final-sale-popup[data-popup-tag="gwp2024"]').fadeIn(300);
    enableAllPopupFocusableElements();

    console.log('clicked');
});


if (deviceIsMobile.matches) {
    window.addEventListener('load', function () {
        setTimeout(function () {
            $('body').scrollTop(0);
        }, 400);
    });
    $(document).on('focus', '.product-shop-back-in-stock-email', function () {
        $('body').scrollTop(0);
        $('body').addClass('waitlist-focused');
    });
    $(document).on('blur', '.product-shop-back-in-stock-email', function () {
        $('body').removeClass('waitlist-focused');
    });
    $('.collection-description').insertAfter('.normal-option-selectors');
    $('.pdp-inventory-final').insertBefore('.collection-description');
}
let lastKnownWindowWidth = window.innerWidth;
let resizeTimeout;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
        if (window.innerWidth !== lastKnownWindowWidth) {
            lastKnownWindowWidth = window.innerWidth;
            if (deviceIsMobile.matches) {
                $('.fixed-atc-bar').appendTo('.product');
                $('#pr-reviewdisplay').appendTo('.accordion-reviews .accordion__content-inner');
                $('.product-recommendations-section').insertAfter('.accordion-wrapper-reviews');
                $('.recently-viewed-section').insertAfter('.product-recommendations-section');
                $('#shopify-section-footer').insertAfter('.recently-viewed-section');
                $('html, body').scrollTop(0);
                $('#productInfo').attr('aria-label', 'Swipe up to view product details');
            } else {
                $('.fixed-atc-bar').appendTo('.desktop-atc');
                $('.product-recommendations-section')
                    .insertBefore('.reviews-wrapper')
                    .parent();
                $('.recently-viewed-section').insertAfter('.reviews-wrapper').parent();
                $('#shopify-section-footer').insertAfter('main');
                $('#pr-reviewdisplay').appendTo('.main-reviews');
                $('#productInfo').removeAttr('aria-label').removeAttr('role');
                checkEachAccordionLi();
                adjustGalleryTop();
                setTimeout(function () {
                    updateAccordionHeight();
                }, 100);
            }
        }
    }, 250);
});
function activateAccordionFocusableElements($this) {
    $this.parent().find('a, button:not(.accordion-heading)').attr('tabindex', '0');
}
function disableAccordionFocusableElements($this) {
    $this.parent().find('a, button:not(.accordion-heading)').attr('tabindex', '-1');
}
$(document).ready(function () {
    // Assign the first accordion to a variable
    if (
        $('body').hasClass('template-krewe-gift-card') ||
        $('body').hasClass('pdp-frame-case') ||
        $('body').hasClass('template-summer-tote-2023')
    ) {
        var firstAccordion = $('.accordion-heading').eq(0);
    } else {
        var firstAccordion = $('.accordion-heading').eq(1);
    }
    openedAccordions.push(firstAccordion);
    initializing = false;
    //console.log(openedAccordions);
    if (deviceIsMobile.matches) {
        $('.accordion-heading').on('click', function () {
            // Skip accordion behavior if this is a popup trigger
            if ($(this).hasClass('accordion-popup-trigger')) {
                return;
            }
            
            var isOpening = !$(this).hasClass('opened-accordion');
            if (isOpening) {
                $(this).addClass('opened-accordion');
                $(this).parent().addClass('product-accordion-opened');
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .css(
                        'max-height',
                        `${$(this).parent().find('.accordion__content')[0].scrollHeight}px`,
                    );
                openedAccordions.push($(this));
                $(this).parent().find('.accordion__content').attr('aria-hidden', 'false');
                $(this).attr('aria-expanded', 'true');
                let childOffset = $(this).parent().offset().top;
                let parentOffset = $('.product__info-wrapper').offset().top;
                let scrollPosition =
                    childOffset - parentOffset + $('.product__info-wrapper').scrollTop() - 20;
                $('.product__info-wrapper').animate({ scrollTop: scrollPosition }, 500);
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .prop('hidden', false)
                    .attr('aria-hidden', 'false');
                var accordionHeading = $(this).find('.accordion__title').text().trim();
                $(this).attr('data-gtm-label', accordionHeading + ' - Close');
            } else {
                var index = openedAccordions.indexOf($(this));
                if (index > -1) {
                    openedAccordions.splice(index, 1);
                }
                var accordionHeading = $(this).find('.accordion__title').text().trim();
                $(this).attr('data-gtm-label', accordionHeading + ' - Open');
                $(this).removeClass('opened-accordion');
                $(this).parent().removeClass('product-accordion-opened');
                $(this).parent().find('.accordion__content').css('max-height', '0');
                $(this).parent().find('.accordion__content').attr('aria-hidden', 'true');
                $(this).attr('aria-expanded', 'false');
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .prop('hidden', true)
                    .attr('aria-hidden', 'true');

                let childOffset = $(this).parent().offset().top;
                let parentOffset = $('.product__info-wrapper').offset().top;
                let scrollPosition =
                    childOffset - parentOffset + $('.product__info-wrapper').scrollTop() - 20;
                var $this = $(this);
                if ($this.hasClass('accordion-heading-reviews')) {
                    $('.product__info-wrapper').animate({ scrollTop: scrollPosition - 70 }, 500);
                }

                setTimeout(function () {
                    if ($this.hasClass('accordion-heading-how-it-fits')) {
                        $('.accordion__content .model-carousel').scrollLeft(0);
                        $('.face-shapes-wrapper').removeClass('face-shapes-opened');
                        $('.face-shapes-trigger').removeClass('close-face-shapes');
                        $('.face-shapes-trigger').attr(
                            'data-gtm-label',
                            "What's My Face Shape? - Open",
                        );
                    }
                    if ($this.hasClass('accordion-heading-key-features')) {
                        $(
                            '.accordion__content .key-features-carousel[data-carousel-id="key-features-carousel"]',
                        ).scrollLeft(0);
                    }
                    if ($this.hasClass('accordion-heading-krewe-store-near-you')) {
                        $('.accordion__content .pdp--availability-wrapper').scrollLeft(0);
                    }
                }, 650);
            }
        });
    } else {
        $('.accordion-heading').on('click', function () {
            // Skip accordion behavior if this is a popup trigger
            if ($(this).hasClass('accordion-popup-trigger')) {
                return;
            }
            
            var isOpening = !$(this).hasClass('opened-accordion');
            if (isOpening) {
                $(this).addClass('opened-accordion');
                $(this).parent().addClass('product-accordion-opened');
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .css(
                        'max-height',
                        `${$(this).parent().find('.accordion__content')[0].scrollHeight}px`,
                    );
                openedAccordions.push($(this));
                $(this).parent().find('.accordion__content').attr('aria-hidden', 'false');
                $(this).attr('aria-expanded', 'true');
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .prop('hidden', false)
                    .attr('aria-hidden', 'false');
                let $this = $(this);
                var accordionHeading = $(this).find('.accordion__title').text().trim();
                $(this).attr('data-gtm-label', accordionHeading + ' - Close');

                activateAccordionFocusableElements($this);
                setTimeout(() => {
                    let fullyOpenedContent = $(this).parent().find('.accordion__content');
                    if (!isInViewport(fullyOpenedContent)) {
                        let fullyOpenedContentHeight = fullyOpenedContent.outerHeight();
                        let viewportHeight =
                            window.innerHeight || document.documentElement.clientHeight;
                        let childOffset = $(this).parent().offset().top;
                        let parentOffset = 0;
                        let scrollPosition =
                            childOffset -
                            parentOffset +
                            fullyOpenedContentHeight -
                            viewportHeight +
                            120; // Additional offset for padding or margin
                        // Smooth scroll
                        $('html, body').animate({ scrollTop: scrollPosition }, 500);
                    }
                    adjustGalleryTop();
                }, 400);
            } else {
                var index = openedAccordions.indexOf($(this));
                if (index > -1) {
                    openedAccordions.splice(index, 1);
                }

                var accordionHeading = $(this).find('.accordion__title').text().trim();
                $(this).attr('data-gtm-label', accordionHeading + ' - Open');
                $(this).removeClass('opened-accordion');
                $(this).parent().removeClass('product-accordion-opened');
                $(this).parent().find('.accordion__content').css('max-height', '0');
                $(this).attr('aria-expanded', 'false');
                $(this).parent().find('.accordion__content').attr('aria-hidden', 'true');
                $(this)
                    .parent()
                    .find('.accordion__content')
                    .prop('hidden', true)
                    .attr('aria-hidden', 'true');
                var $this = $(this);
                disableAccordionFocusableElements($this);
                setTimeout(function () {
                    adjustGalleryTop();
                    if ($this.hasClass('accordion-heading-how-it-fits')) {
                        $('.accordion__content .model-carousel').scrollLeft(0);
                        $('.face-shapes-wrapper').removeClass('face-shapes-opened');
                        $('.face-shapes-trigger').removeClass('close-face-shapes');
                        $('.face-shapes-trigger').attr(
                            'data-gtm-label',
                            "What's My Face Shape? - Open",
                        );
                    }
                    if ($this.hasClass('accordion-heading-key-features')) {
                        $(
                            '.accordion__content .key-features-carousel[data-carousel-id="key-features-carousel"]',
                        ).scrollLeft(0);
                    }
                    if ($this.hasClass('accordion-heading-krewe-store-near-you')) {
                        $('.accordion__content .pdp--availability-wrapper').scrollLeft(0);
                    }
                }, 650);
            }
        });
        function isInViewport(element) {
            var rect = element[0].getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    }
});
$(document).on('click', '.pdp-tab-opened .tab-trigger', function () {
    $('.product__info-wrapper').animate({ scrollTop: 0 }, 300);
});
// Cache selectors which don't depend on a specific event instance
const $body = $('body');
const $productVariants = $('.product-variants');
const $productWrapper = $('.product');
const $pdpFamilyTitle = $('.pdp-family-title');
const $pdpFrameTitle = $('.pdp-frame-title');
const $swatchBar = $('.pdp-family-products-swatch-bar');
const $plusMinusSwatch = $('.plus-minus-swatch');
const $productFramePrice = $('.pdp-header .product-price-main-price');

// Function to update swatch bar type
function updateSwatchBarType(swatchCount) {
    $swatchBar.removeClass('large-product-swatch-bar carousel-product-swatch-bar');
    $body.removeClass('carousel-product-swatch-pdp large-product-family-pdp');
    $plusMinusSwatch.css('opacity', '0');
    if (swatchCount > 8 && swatchCount < 16) {
        $swatchBar.addClass('large-product-swatch-bar');
        $body.addClass('large-product-family-pdp');
        $plusMinusSwatch.css('opacity', '1');
    } else if (swatchCount > 15) {
        $swatchBar.addClass('large-product-swatch-bar carousel-product-swatch-bar');
        $body.addClass('carousel-product-swatch-pdp large-product-family-pdp');
        $plusMinusSwatch.css('opacity', '1');
    }
    $plusMinusSwatch.html('<span><em>+</em>' + (swatchCount - 7) + '</span>');
}
function recheckAdditionalFamilyVariants(familyVariantHandle, familyCollectionHandle) {
    if ($('.pdp-family-swatch-product').length > 1) {
        var familyCollectionURL =
            market_prefix + '/collections/' + familyVariantHandle + '?view=family-pdp';
        fetch(familyCollectionURL, { method: 'GET' })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error in fetching family collection');
                }
                return response.text();
            })
            .then((familyProductContents) => {
                if (
                    !$(
                        '.family-product-contents-wrapper [data-product-family-handle=' +
                            familyCollectionHandle +
                            ']',
                    ).length
                ) {
                    $('.family-product-contents-wrapper').append(familyProductContents);
                    //console.log(familyCollectionHandle + ' family products loaded');
                    checkSameDataProductHandle();
                } else {
                    //console.log(familyCollectionHandle + ' family products already loaded');
                }
            })
            .catch((errorMsg) => {
                console.log(errorMsg);
            });
    }
}
var checkedFamilyHandles = {};
function handleVariantSelection(variant, $this, isLens, optionsMenuSelected, familyCollectionHandle) {
    $body.removeClass('manually-opened-swatch-bar').addClass('variant-option-selected');
    $productVariants.find('.active-variant').removeClass('active-variant');
    $productVariants
        .find(
            'ul[data-option-name="' +
                optionsMenuSelected +
                '"] button[data-variant-name="' +
                variant.selected +
                '"]',
        )
        .addClass('active-variant');
    $frameTitle.text(variant.colorwayTitle);
    $addToCart.attr('data-variant-id', variant.id);
    if (variant.soldout === 'true') {
        $('.has-options-opened').removeClass('has-options-opened');
        $('.show-variants').removeClass('show-variants');
    }
    const $familySwatches = $(
        '.family-product-contents[data-product-family-title="' +
            variant.familyTitle +
            '"] .frame-swatch:not(.frame-swatch-hidden)',
    );
    let familySwatchesHTML = '';
    $familySwatches.each(function () {
        familySwatchesHTML += $(this).html();
    });
    const swatchCount = $familySwatches.length;
    $swatchBar.attr('data-family-products-count', swatchCount);

    if (swatchCount > 16) {
        $('body').addClass('three-row-product');
    } else {
        $('body').removeClass('three-row-product');
    }
    updateSwatchBarType(swatchCount);
    let variantColorwayHandleSelector =
        '.family-product-contents button[data-product-handle="' +
        variant.colorwayHandle +
        '"]';
    const hiddenSwatch = $(variantColorwayHandleSelector).clone();
    if (variant.familyHandle != familyCollectionHandle) {
        $('.pdp-family-products-swatch-bar-scroll').html(familySwatchesHTML);
        $pdpFamilyTitle.text(variant.familyTitle);
        $pdpFrameTitle.text(variant.colorwayTitle);
        if ($(variantColorwayHandleSelector).length) {
            updatePdpFamilySwatchProduct(variant.selected);
            if (
                !$(
                    '.family-product-contents-wrapper button[data-product-handle="' +
                        variant.colorwayHandle +
                        '"]',
                )
                    .parent()
                    .hasClass('frame-active')
            ) {
                $(
                    '.family-product-contents-wrapper button[data-product-handle="' +
                        variant.colorwayHandle +
                        '"]',
                ).click();
                if ($('.family-collection-breadcrumb').length) {
                    $('.family-collection-breadcrumb').text(variant.familyTitle);
                    $('.family-collection-breadcrumb').attr(
                        'href',
                        '/collections/' + variant.familyHandle,
                    );
                }
            }
        }
        $('.frame-reviews-section .pr-rating-stars .pr-snippet-stars-png').remove();
        $('.reviews-count-display .pr-snippet-stars-reco-inline').remove();
        $('.frame-reviews-section .reviews-counter').text('');

        $('.yotpo-widget-instance').attr('data-yotpo-product-id', variant.product_id);
        if (typeof yotpoWidgetsContainer != 'undefined') {
            yotpoWidgetsContainer.initWidgets();

            setTimeout(function () {
                yotpoReviewsFormatting();
            }, 1000);
        }
        $(
            '.family-product-contents-wrapper .available-variant.additional-family-variant',
        ).each(function () {
            var $this = $(this);
            var familyVariantTitle = $this.attr('data-metafield-family-title');
            var familyVariantHandle = $this.attr('data-metafield-family-handle');
            if (
                !$(
                    '.family-product-contents[data-product-family-title="' +
                        familyVariantTitle +
                        '"]',
                ).length
            ) {
                if (!checkedFamilyHandles[familyVariantHandle]) {
                    recheckAdditionalFamilyVariants(
                        familyVariantHandle,
                        familyCollectionHandle,
                    );
                    checkedFamilyHandles[familyVariantHandle] = true;
                }
            }
        });
        $productWrapper.attr('data-family-collection-handle', variant.familyHandle);
    }
    if (variant.familyHandle === familyCollectionHandle) {
        $pdpFamilyTitle.text(variant.familyTitle);
        $pdpFrameTitle.text(variant.colorwayTitle);
        $('.pdp-family-products-swatch-bar-scroll .frame-active button').replaceWith(hiddenSwatch,);
        $('.family-product-contents-wrapper button[data-product-handle="'+variant.colorwayHandle+'"]',).click();
    }

    setOptionSelectorsSizeAndLens(variant.colorwayHandle);
    checkFamilyProductContentsWrapper(variant.selected);

    // If the PDP is a Custom PDP, it does not build out meta for related products (swatches, images, titles, content, etc).
    // As a result, it's not able to swap content + url while on the same plage. As a workaround, we force the selector to go to the actual URL.
    if ($isCustomPdp) {
        location.href = `https://www.krewe.com/products/${variant.colorwayHandle}`;
    }
}

function findClosestMatchingVariant(variant) {
    let $matchingButton = $(
        '.family-product-contents button[data-variant-name="' + variant.selected + '"]:not(.unavailable-variant-li button)'
    ).first();

    // Custom PDP's will not have the element generated mentioned above. As a result, we have to redefine and find an alternative selector that works the same way.
    if ($isCustomPdp) {
        $matchingButton = $('.product-variants-list button[data-variant-name="' + variant.selected + '"]:not(.unavailable-variant-li button)').first();
    }

    if ($matchingButton.length) {
        const $familyProductContents = $matchingButton.closest('.family-product-contents');
        const familyTitle = $familyProductContents.attr('data-product-family-title');
        // Update the variant object with the new family title
        variant.familyTitle = familyTitle;
        return $familyProductContents;
    }
    return null;
}

$(document).on(
    'click',
    '.product-variants li button:not(.readers--variant):not(.all-available-variant)',
    function () {
        const $this = $(this);
        const variant = {
            selected: $this.attr('data-variant-name'),
            familyTitle: $this.attr('data-metafield-family-title'),
            colorwayTitle: $this.attr('data-metafield-colorway-title'),
            id: $this.attr('data-metafield-variant-id'),
            product_id: $this.attr('data-metafield-product-id'),
            price: $this.attr('data-metafield-price'),
            soldout: $this.attr('data-product-sold-out'),
            colorwayHandle: $this.attr('data-metafield-colorway-handle'),
            familyHandle: $this.attr('data-metafield-family-handle'),
        };
        const isLens =
            $this.parents('.product-variants-list').attr('data-option-name') === 'lens';
        const optionsMenuSelected = $this.parents('ul').attr('data-option-name');
        const familyCollectionHandle = $productWrapper.attr('data-family-collection-handle');

        let $familyProductContents = $(
            '.family-product-contents[data-product-family-title="' +
                variant.familyTitle +
                '"]'
        );

        //console.log(variant.familyTitle);

        if ($familyProductContents.length) {
            handleVariantSelection(variant, $this, isLens, optionsMenuSelected, familyCollectionHandle);
        } else {
            // console.log('*** Family not found, searching for closest match');
            $familyProductContents = findClosestMatchingVariant(variant);
            
            if ($familyProductContents) {
                // console.log('*** Closest matching family found:', variant.familyTitle);
                handleVariantSelection(variant, $this, isLens, optionsMenuSelected, familyCollectionHandle);
            } 
        }
    }
);

function setAccordionHeight() {
    var openedAccordionContent = $('.accordion-heading-reviews')
        .parent()
        .find('.accordion__content');
    openedAccordionContent.css('max-height', `${openedAccordionContent[0].scrollHeight}px`);
}
document.arrive(
    '.yotpo-widget-instance[data-yotpo-instance-id="616162"]:not(.initial-review-load) .yotpo-reviews-pagination-item',
    function () {
        // Your existing mutation observer...
        const reviewsDisplayEl = $(
            '.yotpo-widget-instance[data-yotpo-instance-id="616162"]:not(.initial-review-load)',
        )[0];
        const reviewsObserverconfig = { attributes: false, childList: true, subtree: true };
        const reviewsPageChange = (mutationsList, reviewsPageChange) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    yotpoReviewsFormatting();
                    setTimeout(setAccordionHeight, 100);
                    reviewsPageChangeObserver.disconnect();
                }
            }
        };
        let reviewsPageChangeObserver = new MutationObserver(reviewsPageChange);
        // 'this' refers to the newly created element
        $(this).on('click', function () {
            reviewsPageChangeObserver.observe(reviewsDisplayEl, reviewsObserverconfig);
        });
    },
);

var currentObserver = null;
const reviewObserver = function (element, updateReviewLayout) {
    // If there's an existing observer, disconnect it before creating a new one
    if (currentObserver) {
        currentObserver.disconnect();
        //console.log('Previous mutation observer disconnected');
    }
    // Options for the observer
    var config = { attributes: false, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    var callback = function (mutationsList, observer) {
        // Clear the timeout as soon as a mutation is detected
        clearTimeout(timeoutID);
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // If children are added or removed, set the height
                setAccordionHeight();
                updateReviewLayout();
                //console.log('Mutation observer fired');
                // Disconnect observer after the first change
                observer.disconnect();
                // Clear current observer
                currentObserver = null;
            }
        }
    };
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);
    // Set current observer to this new observer
    currentObserver = observer;
    // Start observing the target node for configured mutations
    observer.observe(element, config);
    // Setup a timeout to disconnect observer after 1 second
    var timeoutID = setTimeout(function () {
        observer.disconnect();
        //console.log('Mutation observer disconnected due to timeout');
        // Clear current observer
        currentObserver = null;
    }, 1000);
};

$(document).on('click', '.yotpo-clear-filters, .yotpo-dropdown-option', function () {
    reviewObserver(
        $('.yotpo-widget-instance[data-yotpo-instance-id="616162"] #yotpo-app')[0],
        yotpoReviewsFormatting,
    );
});
$(document).on('keydown', '.yotpo-search-input', function (e) {
    var key = e.which || e.keyCode;
    if (key === 13) {
        // 13 is the code for the Enter key
        // prevent form submission if the input is within a form
        reviewObserver(
            $('.yotpo-widget-instance[data-yotpo-instance-id="616162"] #yotpo-app')[0],
            yotpoReviewsFormatting,
        );
    }
});
$('button').on('click', function () {
    $(this).blur();
});
$('button.active-variant').on('click', function () {
    $(this).blur();
});
$(document).ready(function () {
    if (deviceIsMobile.matches) {
        var overscrollBehaviorSupported = 'overscrollBehavior' in document.documentElement.style;
        if (overscrollBehaviorSupported) {
            // CSS overscroll-behavior is supported
            // Perform actions specific to devices that support it
        } else {
            // CSS overscroll-behavior is not supported
            // Handle devices that do not support it
            (function (global) {
                var startY = 0;
                var enabled = false;
                var supportsPassiveOption = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function () {
                            supportsPassiveOption = true;
                        },
                    });
                    window.addEventListener('test', null, opts);
                } catch (e) {}
                var handleTouchmove = function (evt) {
                    var el = evt.target;
                    var zoom = window.innerWidth / window.document.documentElement.clientWidth;
                    if (evt.touches.length > 1 || zoom !== 1) {
                        return;
                    }
                    while (el !== document.body && el !== document) {
                        var style = window.getComputedStyle(el);
                        if (!style) {
                            break;
                        }
                        if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
                            return;
                        }
                        var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
                        var overflowY = style.getPropertyValue('overflow-y');
                        var height = parseInt(style.getPropertyValue('height'), 10);
                        var isScrollable =
                            scrolling === 'touch' &&
                            (overflowY === 'auto' || overflowY === 'scroll');
                        var canScroll = el.scrollHeight > el.offsetHeight;
                        if (isScrollable && canScroll) {
                            var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;
                            var isAtTop = startY <= curY && el.scrollTop === 0;
                            var isAtBottom =
                                startY >= curY && el.scrollHeight - el.scrollTop === height;
                            if (isAtTop || isAtBottom) {
                                evt.preventDefault();
                            }
                            return;
                        }
                        el = el.parentNode;
                    }
                    evt.preventDefault();
                };
                var handleTouchstart = function (evt) {
                    startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
                };
                var enable = function () {
                    window.addEventListener(
                        'touchstart',
                        handleTouchstart,
                        supportsPassiveOption ? { passive: false } : false,
                    );
                    window.addEventListener(
                        'touchmove',
                        handleTouchmove,
                        supportsPassiveOption ? { passive: false } : false,
                    );
                    enabled = true;
                };
                var disable = function () {
                    window.removeEventListener('touchstart', handleTouchstart, false);
                    window.removeEventListener('touchmove', handleTouchmove, false);
                    enabled = false;
                };
                var isEnabled = function () {
                    return enabled;
                };
                var testDiv = document.createElement('div');
                document.documentElement.appendChild(testDiv);
                testDiv.style.WebkitOverflowScrolling = 'touch';
                var isScrollSupported =
                    'getComputedStyle' in window &&
                    window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
                document.documentElement.removeChild(testDiv);
                if (isScrollSupported) {
                    enable();
                }
                var iNoBounce = {
                    enable: enable,
                    disable: disable,
                    isEnabled: isEnabled,
                    isScrollSupported: isScrollSupported,
                };
                if (typeof module !== 'undefined' && module.exports) {
                    module.exports = iNoBounce;
                }
                if (typeof global.define === 'function') {
                    (function (define) {
                        define('iNoBounce', [], function () {
                            return iNoBounce;
                        });
                    })(global.define);
                } else {
                    global.iNoBounce = iNoBounce;
                }
            })(this);
        }
    }
});
$(document).on('keydown', '.hidden-focus-target', function (e) {
    var $carousel = $(this).closest('.accordion__content').find('.overflow-scroll-x');
    if (e.key === 'ArrowLeft') {
        e.preventDefault();
        $carousel.scrollLeft($carousel.scrollLeft() - 100); // Scroll left by 100 pixels
    } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        $carousel.scrollLeft($carousel.scrollLeft() + 100); // Scroll right by 100 pixels
    }
});
$(document).ready(function () {
    if ($('body').hasClass('showing-waitlist-bar')) {
        setTimeout(function () {
            $('.product-form button, .product-form div[role=button]').attr('tabindex', '-1');
            $('#buyItNow, .afterpay-link').attr('aria-hidden', true).attr('tabindex', '-1');
        }, 6000);
    }
});

$(document).on('click', '#AddToCart.power-not-selected', function () {
    $('.readers--show').addClass('nudge-readers');

    setTimeout(function () {
        $('.readers--show').removeClass('nudge-readers');
    }, 600);
});

document
    .querySelector('.krw--mobile-only.fera-wrapper.model-face-shape-image-label')
    .addEventListener('click', function () {
        // Get the index from the clicked element's data attribute
        let index = $('.how-it-fits-trigger').attr('data-model-image-active-index-2') - 1;

        setTimeout(function () {
            // Get the model carousel and its children
            let modelCarousel = document.querySelector('#productInfo .model-carousel');
            let children = modelCarousel.children;

            // Check if the index is valid
            if (index < children.length && index >= 0) {
                // Get the width of a child (assuming all children are of equal width)
                let childWidth = children[index].offsetWidth;

                // Calculate the desired scroll position
                let scrollPosition = childWidth * index;

                // Scroll the model carousel to the desired position
                modelCarousel.scrollLeft = scrollPosition;

                updateAccordionModelCarousels();
            }
        }, 400);
    });

$(document).on('click', '.how-it-fits-product-trigger', function (e) {
    e.preventDefault();
    let $this = $(this);

    let hifProductHandle = $this.attr('data-product-handle');
    let productSwatchBar = $('.pdp-family-products-swatch-bar-scroll');
    let productVariantNormalSelectors = $('.normal-option-selectors');

    let matchingButtonInSwatchBar = productSwatchBar.find(
        `button[data-product-handle="${hifProductHandle}"]`,
    );

    if (matchingButtonInSwatchBar.length > 0) {
        if ($(window).width() < 991) {
            $('#productInfo').animate({ scrollTop: 0 }, 400);
        } else {
            $('html,body').animate({ scrollTop: 0 }, 400);
        }

        setTimeout(function () {
            matchingButtonInSwatchBar.click();
        }, 450);
    } else {
        let matchingButtonInNormalSelectors = productVariantNormalSelectors.find(
            `button[data-metafield-colorway-handle="${hifProductHandle}"]`,
        );

        if (matchingButtonInNormalSelectors.length > 0) {
            if ($(window).width() < 991) {
                $('#productInfo').animate({ scrollTop: 0 }, 400);
            } else {
                $('html,body').animate({ scrollTop: 0 }, 400);
            }
            setTimeout(function () {
                matchingButtonInNormalSelectors.click();
            }, 450);
        } else {
            window.location.href = $this.attr('href');
        }
    }
});

let faceShapesHeight;

$(document).on('click', '.face-shapes-trigger:not(.close-face-shapes)', function () {
    var $this = $(this);
    $('.face-shapes-wrapper').addClass('face-shapes-opened');
    $(this).addClass('close-face-shapes');
    $this.attr('aria-expanded', 'true');
    $('.face-shapes-trigger').attr('data-gtm-label', "What's My Face Shape? - Close");

    faceShapesHeight = $('.face-shapes').outerHeight(true);
    let childOffset = $(this).offset().top;

    if (deviceIsMobile.matches) {
        let scrollFitsPosition = childOffset + $('.product__info-wrapper').scrollTop() - 90;
        $('.product__info-wrapper').animate({ scrollTop: scrollFitsPosition }, 500);
    } else {
        setTimeout(function () {
            let fullyOpenedContent = $this.parent()[0];
            if (!isInViewport(fullyOpenedContent)) {
                let fullyOpenedContentHeight = $(fullyOpenedContent).outerHeight();
                let viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                let parentOffset = 0;
                let scrollPosition =
                    childOffset - parentOffset + fullyOpenedContentHeight - viewportHeight + 90; // Additional offset for padding or margin
                // Smooth scroll
                $('html, body').animate({ scrollTop: scrollPosition }, 500);
            }
            adjustGalleryTop();
        }, 600);
    }

    //console.log(faceShapesHeight);

    var howItFitsAccordionContent = $('.accordion-how-it-fits')
        .parent()
        .find('.accordion__content');
    setTimeout(function () {
        howItFitsAccordionContent.css(
            'max-height',
            `${howItFitsAccordionContent[0].scrollHeight}px`,
        );
        $this.parent().find('.face-shapes').attr('aria-hidden', 'false');
    }, 50);
});

$(document).on('click', '.face-shapes-trigger.close-face-shapes', function () {
    var $this = $(this);
    let howItFitsAccordionContent = $('.accordion-how-it-fits')
        .parent()
        .find('.accordion__content');
    $this.attr('aria-expanded', 'false');
    let childOffset = $(this).offset().top;
    if (deviceIsMobile.matches) {
        let scrollFitsPosition = childOffset + $('.product__info-wrapper').scrollTop() - 200;
        $('.product__info-wrapper').animate({ scrollTop: scrollFitsPosition }, 500);
    } else {
        setTimeout(function () {
            let fullyOpenedContent = $this.parent()[0];
            if (!isInViewport(fullyOpenedContent)) {
                let fullyOpenedContentHeight = $(fullyOpenedContent).outerHeight();
                let viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                let parentOffset = 0;
                let scrollPosition =
                    childOffset - parentOffset + fullyOpenedContentHeight - viewportHeight; // Additional offset for padding or margin
                // Smooth scroll
                $('html, body').animate({ scrollTop: scrollPosition }, 500);
            }
            adjustGalleryTop();
        }, 600);
    }
    $('.face-shapes-trigger').attr('data-gtm-label', "What's My Face Shape? - Open");
    setTimeout(function () {
        howItFitsAccordionContent.css(
            'max-height',
            `${howItFitsAccordionContent[0].scrollHeight - faceShapesHeight}px`,
        );
        $this.parent().find('.face-shapes').attr('aria-hidden', 'true');
        //console.log(faceShapesHeight);
    }, 50);
    $(this).removeClass('close-face-shapes');
    setTimeout(function () {
        $('.face-shapes-wrapper').removeClass('face-shapes-opened');
    }, 100);
});

$(document).on('click', '.standard-variant[data-variant-name="with-case"]', function () {
    $('#frameCase').prop('checked', true).change();
});

$(document).on('click', '.standard-variant[data-variant-name="no-case"]', function () {
    $('#frameCase').prop('checked', false).change();
});

$(document).on('click', '.frame-case-learn-more, .regular-case-options h3', function () {
    $('.final--cta').click();
});

function syncInitialFrameCasePrice() {
    if (!window.theme.isSaleActive) {
        return;
    }

    const $frameCaseCheckbox = $('#frameCase');
    const activeSwatch = $('.frame-active button');

    if (!$frameCaseCheckbox.length || !activeSwatch.length) {
        return;
    }

    let price = {
        base: activeSwatch.attr('data-product-price-full'),
        with_case: activeSwatch.attr('data-product-price-with-case'),
        with_blue_light: activeSwatch.attr('data-product-price-with-blue-light'),
        with_readers: activeSwatch.attr('data-product-price-with-blue-light-readers'),
        with_case_and_blue_light: activeSwatch.attr('data-product-price-with-case-blue-light'),
        with_case_and_readers: activeSwatch.attr('data-product-price-with-case-blue-light-readers')
    };

    if ($frameCaseCheckbox.is(':checked')) {
        if ($('button[data-variant-name="Blue Light Readers"]').hasClass('active-variant')) {
            $('.pdp-header .product-price-main-price').text(price.with_case_and_readers);
        } else if ($('button[data-variant-name="Blue Light"]').hasClass('active-variant')) {
            $('.pdp-header .product-price-main-price').text(price.with_case_and_blue_light);
        } else {
            $('.pdp-header .product-price-main-price').text(price.with_case);
        }
        $addToCart.attr('data-include-frame-case', 'true');
    } else {
        if ($('button[data-variant-name="Blue Light Readers"]').hasClass('active-variant')) {
            $('.pdp-header .product-price-main-price').text(price.with_readers);
        } else if ($('button[data-variant-name="Blue Light"]').hasClass('active-variant')) {
            $('.pdp-header .product-price-main-price').text(price.with_blue_light);
        } else {
            $('.pdp-header .product-price-main-price').text(price.base);
        }
        $addToCart.attr('data-include-frame-case', 'false');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    syncInitialFrameCasePrice();
    setTimeout(syncInitialFrameCasePrice, 200);
    
    if (!deviceIsMobile.matches) {
        setTimeout(function () {
            $('#productInfo div[data-carousel-id="key-features-carousel"]').addClass(
                'nudge-key-features',
            );
        }, 4000);

        setTimeout(function () {
            $('#productInfo div[data-carousel-id="key-features-carousel"]').removeClass(
                'nudge-key-features',
            );
        }, 4800);
    }
});

// Listen for the click event on the .accordion-heading-how-it-fits element
$(document).on('click', '.accordion-heading-how-it-fits', function () {
    // Check if .overflow-scroll-x.model-carousel is found
    var carouselElement = $('#productInfo .overflow-scroll-x.model-carousel');
    if (carouselElement.length > 0 && carouselElement.find('.overflow-scroll-item').length > 1) {
        // Define a variable to track if the user scrolls within the next 5 seconds
        var scrolledWithin5Seconds = false;

        // Listen for the scroll event on the .overflow-scroll-x.model-carousel element
        var scrollListener = function () {
            scrolledWithin5Seconds = true;
        };
        carouselElement.on('scroll', scrollListener);

        // Wait for 5 seconds to check if the user has scrolled
        setTimeout(function () {
            // Remove the scroll listener
            carouselElement.off('scroll', scrollListener);

            // If the user hasn't scrolled within 5 seconds, add the class
            if (!scrolledWithin5Seconds) {
                carouselElement.addClass('nudge-model-carousel');

                // Remove the class after 1 second of adding it
                setTimeout(function () {
                    carouselElement.removeClass('nudge-model-carousel');
                }, 800);
            }
        }, 3000);
    }
});

function carouselsDrag() {
    const body = document.body;

    const scrollContainers = document.querySelectorAll('.overflow-scroll-x');

    scrollContainers.forEach(function (container) {
        var isDown = false;
        var startX;
        var scrollLeft;
        if (container.nextElementSibling) {
            var rectangle = container.nextElementSibling.querySelector('.carousel-rectangle');

            container.addEventListener('mousedown', function (e) {
                isDown = true;
                container.classList.add('active');
                body.classList.add('carousel-cursor'); // Add body class
                startX = e.pageX;
                scrollLeft = container.scrollLeft;
            });

            container.addEventListener('mouseleave', endScrolling);
            container.addEventListener('mouseup', endScrolling);

            container.addEventListener('mousemove', function (e) {
                if (!isDown) return;
                e.preventDefault();
                var x = e.pageX - container.offsetLeft;
                var walk = (x - startX) * 3;
                container.scrollLeft = scrollLeft - walk;
            });

            function endScrolling() {
                isDown = false;
                container.classList.remove('active');
                body.classList.remove('carousel-cursor'); // Remove body class
            }

            rectangle.addEventListener('mousedown', function (e) {
                rectangle.classList.add('active');
                body.classList.add('carousel-cursor'); // Add body class
                var startX = e.pageX;
                var carouselId = rectangle.closest('.carousel-track-wrapper').dataset.carouselId;
                var carousel = document.querySelector(
                    '.overflow-scroll-x[data-carousel-id="' + carouselId + '"]',
                );
                var scrollLeft = carousel.scrollLeft;

                function onMouseMove(e) {
                    e.preventDefault();
                    var x = e.pageX;
                    var walk = (x - startX) * 3;
                    carousel.scrollLeft = scrollLeft + walk;
                }

                function onMouseUp() {
                    rectangle.classList.remove('active');
                    body.classList.remove('carousel-cursor'); // Remove body class
                    document.removeEventListener('mousemove', onMouseMove);
                    document.removeEventListener('mouseup', onMouseUp);
                }

                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            });
        }
    });

    var carouselImages = document.querySelectorAll('.overflow-scroll-x img');

    carouselImages.forEach(function (image) {
        image.addEventListener('dragstart', function (e) {
            e.preventDefault();
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    carouselsDrag();
});

function autoplayPLPVideos() {
    // Detecting if the device is mobile or not
    const isMobile = window.innerWidth <= 768; // Adjust width as per your requirement

    // Select the appropriate videos based on the device type
    const selector = isMobile ? '.plp-video.krw--mobile-only' : '.plp-video.krw--desktop-only';
    const videos = document.querySelectorAll(selector);

    // Check if there are any videos on the page
    if (videos.length === 0) {
        console.log('No videos found for the current device type.');
        return; // Exit the function if no videos are found
    }

    videos.forEach((video) => {
        // Check if the video is already playing
        if (!video.paused || (video.currentTime > 0 && !video.ended)) {
            //console.log('Video is already playing.');
            return; // Skip to the next video if this one is already playing
        }

        // Get the source element and the data-src attribute
        const source = video.querySelector('source');
        const videoSrc = source.getAttribute('data-src');

        if (videoSrc) {
            // Set the src attribute from data-src
            source.src = videoSrc;

            // Load the video
            video.load();

            // Attempt to play the video, catching any errors
            video.play().catch((e) => console.error('Error trying to play the video:', e));
        }
    });
}

// Example of usage based on device type detection (assuming deviceIsMobile is defined correctly)
if (window.innerWidth <= 768) {
    window.onload = function () {};
} else {
    document.addEventListener('DOMContentLoaded', function () {
        autoplayPLPVideos();
    });
}

$(document).on('click', '.absolute-review-link', function () {
    $('.yotpo-new-review-btn')[0].click();
});

function yotpoReviewsFormatting() {
    let no_reviews = $('.yotpo-widget-instance .yotpo-empty-state');

    if (no_reviews.length) {
        $('body').addClass('no-reviews');
        $('.accordion-wrapper-reviews').prepend('<span class="absolute-review-link"></span>');
        $('.heading-reviews .accordion__title').html(
            'Be the first to <span class="write-a-review">Write a Review</span>',
        );
    } else {
        $('body').removeClass('no-reviews');
        $('.accordion-wrapper-reviews .absolute-review-link').remove();

        $('.yotpo-review:not(.branded-review)').each(function () {
            var $this = $(this);

            let review = {
                left_panel: $this.find('.yotpo-review-left-panel'),
                center_panel: $this.find('.yotpo-review-center-panel'),
                right_panel: $this.find('.yotpo-review-right-panel'),
                review_content: $this.find('.yotpo-review-content'),
                stars: $this.find('.yotpo-star-rating'),
                date: $this.find('.yotpo-review-date'),
                additional_questions: $this.find('.yotpo-review-customer-questions-container'),
                reviewer: $this.find('.yotpo-reviewer'),
                reviewer_name: $this.find('.yotpo-reviewer-name'),
                read_more: $this.find('.yotpo-read-more'),
                see_more: $this.find('.yotpo-custom-questions-see-more-label'),
                location: null, // Initialize location as null; it will be updated if a location is found
            };

            if (review.see_more.length) {
                review.see_more.click();
                review.see_more.remove();
            }

            if (review.read_more.length) {
                review.read_more[0].click();
                //review.read_more.remove();
            }

            // Trigger see more click to potentially reveal more content

            setTimeout(function () {
                // Iterate over each title to find the one that contains 'Location'
                $this.find('.yotpo-custom-questions-free-text-title').each(function () {
                    if (
                        $(this).text().trim() === 'Location' &&
                        !$this.find('.reviewer-location').length
                    ) {
                        // Check to ensure location isn't already found

                        // Find the closest .yotpo-custom-questions-free-text-question that contains the 'Location' title
                        let locationQuestion = $(this).closest(
                            '.yotpo-custom-questions-free-text-question',
                        );

                        // Extract the location value
                        let locationValue = locationQuestion
                            .find('.yotpo-custom-questions-free-text-value')
                            .text();
                        review.location = locationValue;

                        //console.log('found location: ' + locationValue);

                        // Append location to reviewer_name if found and if not already appended
                        if (review.location && !$this.find('.reviewer-location').length) {
                            review.reviewer_name.append(
                                '<div class="reviewer-location">' + review.location + '</div>',
                            );
                        }

                        // Remove the original question/answer pair from the review
                        locationQuestion.remove();
                    }
                });
            }, 100); // Adjust this timeout as needed based on how quickly dynamic content loads

            // Reformat the date text
            var newDateText = review.date.find('div').text().replace(/\//g, '.');
            review.date.find('div').text(newDateText);

            if ($(window).width() < 991) {
                // Mobile-specific adjustments
                const $reviewsSearchInput = $('#searchInput');
                let writeAReviewButton = $('.yotpo-new-review-btn-wrapper');

                $reviewsSearchInput.attr('placeholder', 'Search');

                $('.yotpo-filters-container-inner').append(writeAReviewButton);
                review.reviewer.append(review.date);
                review.review_content.append(review.reviewer);
            } else {
                // Desktop-specific adjustments
                $this.find('.yotpo-review-left-panel').prepend(review.stars);
                $this.find('.yotpo-review-left-panel').append(review.date);
                $this.find('.yotpo-review-center-panel').append(review.additional_questions);
            }
            $this.addClass('branded-review');
        });
    }
    setTimeout(function () {
        if ($('.initial-review-load').length) {
            $('.initial-review-load').removeClass('initial-review-load');
        }
    }, 200);
}

// Remember to call yotpoReviewsFormatting() at the appropriate time,
// e.g., after the DOM is fully loaded, or after the Yotpo reviews have been loaded onto the page.

document.addEventListener(
    'animationstart',
    function (event) {
        if (event.animationName == 'yotpoNodeInserted') {
            //console.log('widget loaded');
            if ($(window).width() < 991) {
                $('.reviews-wrapper .yotpo-widget-instance').appendTo(
                    '.accordion-reviews .accordion__content-inner',
                );
            } else {
                const reviewsSearchInput = $('#searchInput');
                let reviewsRating = $('.yotpo-header-container .yotpo-bottom-line-score');

                reviewsSearchInput.attr('placeholder', 'Search');

                $('.yotpo-bottom-line-stars').append(reviewsRating);
            }

            yotpoReviewsFormatting();
            
            
        }
    },
    true,
);

//Search Started Reviews
$(document).on('click', '.yotpo-free-search-filter-container', function() {
    if (typeof mixpanel !== 'undefined') {
        mixpanel.track("Search Started",{"Source":'Reviews'});
    }
});

$(document).on('keypress', '.yotpo-search-input', function(event) {
    var pageurl=window.location.href;
    if (event.which === 13) {
        var query = $(this).val();
        if (typeof mixpanel !== 'undefined') {
            mixpanel.track("Search Completed",{"Searched Query":query,"Page URL":pageurl,"Source":'Reviews'})
        }
    }
});

//Review sorted
$(document).on('click', '.yotpo-dropdown-option', function() {
    // Get the selected sorting option
    var selectedOption = $(this).text().trim();
    var currentUrl = window.location.href;
    // Log the event
    console.log("revie sorted");
    if (typeof mixpanel !== 'undefined') {
        mixpanel.track("Sort Completed", {
            "Selected Option": selectedOption,
            "Source": "Reviews",
            "pageUrl": currentUrl
        });
    }
});

// Review submitted
$(document).on('submit', '.yotpo-review-form', function() {
    var rating = $('.yotpo-star-rating-text').text().trim();
    var productName = $('.yotpo-input-wrapper.yotpo-new-review-headline input').val();
    if (rating !== '') {
        // Log review as "rated"
        console.log("rated review");
        if (typeof mixpanel !== 'undefined') {
            mixpanel.track("Review Rated", {"Product Name": productName});
        }
    } else {
        // Extracting the data from the form
        var productId = ''; // You need to extract product ID from your page
        var mediaAdded = $('.yotpo-uploaded-images img').length + $('.yotpo-uploaded-images video').length;
        var cityAdded = $('.yotpo-form-custom-text-question:nth-child(1) textarea').val();
        var bestComplimentAdded = $('.yotpo-form-custom-text-question:nth-child(2) textarea').val();

        // Logging the data to the console
        console.log("Rating:", rating);
        console.log("Product Name:", productName);
        console.log("Product ID:", productId);
        console.log("Media Added:", mediaAdded);
        console.log("City Added:", cityAdded);
        console.log("Best Compliment Added:", bestComplimentAdded);

        if (typeof mixpanel !== 'undefined') {
            mixpanel.track("Review Added", {
                "Rating": rating,
                "Product Name": productName,
                "Product ID": productId,
                "Media Added": mediaAdded,
                "City Added": cityAdded,
                "Best Compliment Added": bestComplimentAdded
            });
        }
    }
});

$(document).on('click', 'button.yotpo-new-review-submit', function(event) {
    // Alert when the button is clicked

    var rating = $('.yotpo-star-rating-text').text().trim();
    var productName = $('.yotpo-input-wrapper.yotpo-new-review-headline input').val();
    if (rating !== '') {
        // Log review as "rated"
        console.log("rated review");
        if (typeof mixpanel !== 'undefined') {
            mixpanel.track("Review Rated", {"Product Name": productName});
        }
    } else {
        // Extracting the data from the form
        var productId = ''; // You need to extract product ID from your page
        var mediaAdded = $('.yotpo-uploaded-images img').length + $('.yotpo-uploaded-images video').length;
        var cityAdded = $('.yotpo-form-custom-text-question:nth-child(1) textarea').val();
        var bestComplimentAdded = $('.yotpo-form-custom-text-question:nth-child(2) textarea').val();

        // Logging the data to the console
        console.log("Rating:", rating);
        console.log("Product Name:", productName);
        console.log("Product ID:", productId);
        console.log("Media Added:", mediaAdded);
        console.log("City Added:", cityAdded);
        console.log("Best Compliment Added:", bestComplimentAdded);

        if (typeof mixpanel !== 'undefined') {
            mixpanel.track("Review Added", {
                "Rating": rating,
                "Product Name": productName,
                "Product ID": productId,
                "Media Added": mediaAdded,
                "City Added": cityAdded,
                "Best Compliment Added": bestComplimentAdded
            });
        }
    }
});

// Function to handle clicks on accordion sections
function handleAccordionSectionClick(sectionName) {
    var namesec =sectionName;
    //console.log(namesec)
    var refurl= document.referrer;
    var currenturl= window.location.href;
    if (typeof mixpanel !== 'undefined') {
        mixpanel.track("Product Section Viewed",{"sectionName":namesec,"Referrer URL":refurl,"Current URL":currenturl})
    }
}

// Attach click event listeners to each button element
$(".product__accordion button").click(function() {
    var sectionName = $(this).find(".accordion__title").text().trim();
    handleAccordionSectionClick(sectionName);
});

function updateSwatchDimensions() {
    const firstSwatch = document.querySelector('.pdp-family-swatch');

    if (firstSwatch) {
        const swatchRect = firstSwatch.getBoundingClientRect();
        const swatchWidth = swatchRect.width;
        const swatchHeight = swatchRect.height + 1;
        
        document.documentElement.style.setProperty('--swatch-width', `${swatchWidth}px`);
        document.documentElement.style.setProperty('--swatch-height', `${swatchHeight}px`);
    }
}

window.addEventListener('resize', function() {
    // Debounce the resize event to avoid excessive calculations
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(function() {
        updateSwatchDimensions();
    }, 250);
});

if (window.theme.isSaleActive || window.theme.preShopActive) {
    document.addEventListener('variantSelected', function(event) {
        const activeSwatch = $('.frame-active button');
        const variantId = event.detail.variantId;
        const variantTitle = event.detail.variantTitle;
        //console.log('Selected variant:', variantId, variantTitle);
        const product = {
            add_ons_pricing: {
                no_case: activeSwatch.attr('data-product-price-full'),
                with_case: activeSwatch.attr('data-product-price-with-case'),
                with_soft_case: activeSwatch.attr('data-product-price-with-case'),
                with_blue_light: activeSwatch.attr('data-product-price-with-blue-light'),
                with_readers: activeSwatch.attr('data-product-price-with-blue-light-readers'),
                with_case_and_blue_light: activeSwatch.attr('data-product-price-with-case-blue-light'),
                with_case_and_readers: activeSwatch.attr('data-product-price-with-case-blue-light-readers'),
                with_soft_case_and_blue_light: activeSwatch.attr('data-product-price-with-case-blue-light'),
                with_soft_case_and_readers: activeSwatch.attr('data-product-price-with-case-blue-light-readers')
            },
        }
        if ($('button[data-variant-name="Blue Light Readers"]').hasClass('active-variant')) {
            if ($('.variant-hard-case').hasClass('variant-selected')) {
                $('.product-price-main-price').text(product.add_ons_pricing.with_case_and_readers);
                $addToCart.attr('data-include-frame-case', 'true');
                console.log('Final sale with readers and case', product.add_ons_pricing.with_case_and_readers);
            } else {
                $('.product-price-main-price').text(product.add_ons_pricing.with_readers);
                $addToCart.attr('data-include-frame-case', 'false');
                console.log('Final sale with readers', product.add_ons_pricing.with_readers);
            }
        } else if ($('button[data-variant-name="Blue Light"]').hasClass('active-variant')) {
            if ($('.variant-hard-case').hasClass('variant-selected')) {
                $('.product-price-main-price').text(product.add_ons_pricing.with_case_and_blue_light);
                $addToCart.attr('data-include-frame-case', 'true');
                console.log('Final sale with blue light and case', product.add_ons_pricing.with_case_and_blue_light);
            } else {
                $('.product-price-main-price').text(product.add_ons_pricing.with_blue_light);
                $addToCart.attr('data-include-frame-case', 'false');
                console.log('Final sale with blue light', product.add_ons_pricing.with_blue_light);
            }
        } else {
            if ($('.variant-hard-case').hasClass('variant-selected')) {
                $('.product-price-main-price').text(product.add_ons_pricing.with_case);
                $addToCart.attr('data-include-frame-case', 'true');
                console.log('Final sale with case', product.add_ons_pricing.with_case);
            } else {
                $('.product-price-main-price').text(product.add_ons_pricing.no_case);
                $addToCart.attr('data-include-frame-case', 'false');
                console.log('Final sale without case', product.add_ons_pricing.no_case);
            }
        }

        if (!$('body').hasClass('already-opened-tab')) {
            clearInterval(nudgeInterval);
            nudgeInterval = setInterval(nudgeProductInfo, 6000);
        }
    });
}

const revelryScrollConfig = {
    desktopOffset: 120,
    mobileThreshold: 70
  };
  
document.addEventListener('click', function (event) {
    const mgTrigger = event.target.closest('.tag-based-popup-trigger[data-info-popup-item-tag="revelry"]');
    if (!mgTrigger) return;

    event.preventDefault();

    if (!deviceIsMobile.matches) {
        const mediaGallery = document.querySelector('#mediaGallery');
        if (!mediaGallery) return;
        
        const lastImage = mediaGallery.querySelector('.product__media-item:last-child');
        if (!lastImage) return;

        openDefaultAccordion();
        
        const rect = lastImage.getBoundingClientRect();
        const scrollTarget = window.scrollY + rect.top - revelryScrollConfig.desktopOffset;
        
        window.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });

    } else {
        const threshold = revelryScrollConfig.mobileThreshold;
        const accordionEl = document.querySelector('.accordion-wrapper-key-features');
        const productInfoEl = document.querySelector('#productInfo');
        if (!accordionEl || !productInfoEl) return;
        
        document.body.classList.add('pdp-tab-opened', 'already-opened-tab');
        productInfoEl.setAttribute('data-open', '');
        productInfoEl.classList.remove('closed-state');
        overlay.css('opacity', 0.9);
        
        setTimeout(function() {
            const rect = accordionEl.getBoundingClientRect();
            const currentScroll = productInfoEl.scrollTop;
            const offsetTopInContainer = currentScroll + rect.top;
            
            productInfoEl.scrollTo({
                top: offsetTopInContainer - threshold,
                behavior: 'smooth'
            });
        }, 500);
    }
});

// Hide Rotating Text Carousel when Empty
// TODO: Refactor and create more appropriate function.
const pageUrl = window.location.href;
// console.log('*** pageUrl',pageUrl)
const pageUrlString = [
    '/products/the-lighter',
    '/products/the-wine-tote-woven-canvas',
    '/products/the-embroidered-tote'
];
const isPageUrlMatch = pageUrlString.some(str => pageUrl.includes(str));
if (isPageUrlMatch) {
    setTimeout((e) => {
        const slickList = document.querySelector('.pdp-message-carousel-wrapper .slick-list');
        const slickTrack = document.querySelector('.pdp-message-carousel-wrapper .slick-track');
        if (slickList && slickTrack) {
            slickList.style.display = slickTrack.textContent.trim() ? '' : 'none';
        }
    }, 250);
}
